/* oxlint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A Cursor is an opaque string that indicates a specific point in the list. */
  Cursor: { input: string; output: string };
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string };
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string };
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: string; output: string };
  /** Accepts a string or number (e.g. ID that may be either type). */
  StringOrInt: { input: string | number; output: string | number };
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string };
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string };
};

/** The organization's running recruitment, human and synthetic: cohorts still recruiting (not completed, filled, stopped, expired or failed, on orders neither awaiting payment nor cancelled). That is the recruitingRollup(activeOnly: true) set without failed cohorts, which wait on Retry or Cancel on the project. Zero/zero with no projects when nothing is running. */
export type ActiveRecruitment = {
  __typename?: 'ActiveRecruitment';
  /** Orders with at least one running cohort. */
  activeOrderCount: Scalars['Int']['output'];
  /** Sum of the projects' completed. */
  completed: Scalars['Int']['output'];
  /** One row per project with a running cohort, most recently placed order first. */
  projects: Array<ActiveRecruitmentProject>;
  /** Sum of the projects' total. */
  total: Scalars['Int']['output'];
};

export type ActiveRecruitmentProject = {
  __typename?: 'ActiveRecruitmentProject';
  /** Sum of the project's running cohorts' completedCount, each capped at its quantity. */
  completed: Scalars['Int']['output'];
  projectId: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** Sum of the project's running cohorts' quantities. */
  total: Scalars['Int']['output'];
};

export type AddBackgroundImageInput = {
  /** The GCS path of the uploaded background image */
  imagePath: Scalars['String']['input'];
};

export type AddClipInput = {
  /** If true, automatically triggers clip video generation upon add */
  autoTriggerGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['Float']['input'];
  insightId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Float']['input'];
};

export type AddDocumentInput = {
  /** GCS key for the document. Only one of gcsKey, text, or url should be provided. */
  gcsKey?: InputMaybe<Scalars['String']['input']>;
  /** MIME type of the document (e.g., application/pdf, text/plain) */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Optional name for the document. If not provided, will be derived from the source. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Text content of the document. Only one of gcsKey, text, or url should be provided. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** URL of the document. Only one of gcsKey, text, or url should be provided. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddFormMessagePreviewInput = {
  assets?: InputMaybe<Array<MessageAssetInput>>;
  /** Answer payload. OpenEnded: free text. Rating: the option value. MultipleChoice/Ranking: comma-joined option values. Matrix: send subQuestionAnswers instead; this field is ignored for matrix questions. */
  content: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  questionId: Scalars['UUID']['input'];
  sessionId: Scalars['String']['input'];
  /** Required for matrix questions. Per-row answers; BE serialises to the canonical wire format and overwrites content. */
  subQuestionAnswers?: InputMaybe<Array<SubQuestionAnswerPreviewInput>>;
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AddFormMessagesPreviewInput = {
  answers: Array<FormQuestionAnswerPreviewInput>;
  projectId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type AddHyperbeamSessionInput = {
  /** Viewport height in pixels (defaults to 1080) */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The initial URL to load in the Hyperbeam session */
  startUrl: Scalars['String']['input'];
  /** Viewport width in pixels (defaults to 1920); required for mobile UT to size the embed correctly */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type AddInsightTagInput = {
  insightId: Scalars['UUID']['input'];
  tagId: Scalars['UUID']['input'];
};

export type AddMessagePreviewInput = {
  assets?: InputMaybe<Array<MessageAssetInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AddModeratorVoiceInput = {
  gcsKey: Scalars['String']['input'];
  langCode?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  mood: VoiceMood;
  name?: InputMaybe<Scalars['String']['input']>;
  transcript: Scalars['String']['input'];
};

export type AddObservationInput = {
  /** Observation title. */
  name: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
  /** What was observed, referencing the data it comes from. */
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type AddProjectDocumentInput = {
  /** GCS key for the document. Only one of gcsKey, text, or url should be provided. */
  gcsKey?: InputMaybe<Scalars['String']['input']>;
  /** MIME type of the document (e.g., application/pdf, text/plain) */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Optional name for the document. If not provided, will be derived from the source. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The project to attach the document to. */
  projectId: Scalars['ID']['input'];
  /** Text content of the document. Only one of gcsKey, text, or url should be provided. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** URL of the document. Only one of gcsKey, text, or url should be provided. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddQuestionMessagePreviewInput = {
  /** The assets of the message */
  assets?: InputMaybe<Array<MessageAssetInput>>;
  /** The message content */
  content: Scalars['String']['input'];
  /** Exact text typed for the "other" option of a multiple-choice question (content carries it with commas swapped for semicolons) */
  otherText?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['UUID']['input'];
  questionId: Scalars['UUID']['input'];
  /** Session id returned by startUnifiedPreview */
  sessionId: Scalars['UUID']['input'];
  /** The message transcript in voice mode */
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AddQuestionMessagePreviewResponse = {
  __typename?: 'AddQuestionMessagePreviewResponse';
  actions?: Maybe<SurveyActions>;
  /** Whether the whole survey is complete */
  isConversationOver: Scalars['Boolean']['output'];
  /** Whether this question session is complete */
  isQuestionComplete: Scalars['Boolean']['output'];
  /** The next primary question to open, set when the session completed and the survey continues */
  nextQuestion?: Maybe<QuestionV2>;
  /** The next prompt inside this question session (follow-up or re-ask) */
  reply?: Maybe<MessageV2>;
  /** Conversational feedback shown before the next prompt */
  replyFeedback?: Maybe<MessageV2>;
  /** The message that was sent by the user */
  sent: MessageV2;
  /** Progress of the survey (0-1) */
  surveyProgress: Scalars['Float']['output'];
  /** Terminal thank-you message, set when the survey completed on this call */
  thankYouMessage?: Maybe<MessageV2>;
};

export type AddReelInput = {
  /** If true, enqueue reel composition after create (clip scenes need generated clip videos first) */
  autoTriggerGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['UUID']['input'];
  /** Ordered scenes: clip segments and/or transition holds (black + text) */
  scenes: Array<AddReelSceneInput>;
};

export type AddReelSceneInput = {
  /** Required when sceneType is clip — references an existing clip row */
  clipId?: InputMaybe<Scalars['UUID']['input']>;
  /** Required when sceneType is transition. Optional for clip — reel segment length; when set, composition uses at most this many seconds of the clip video. */
  duration?: InputMaybe<Scalars['Float']['input']>;
  sceneType: SceneType;
  /** Transition caption (white text on black). Optional; empty yields plain black hold */
  transitionText?: InputMaybe<Scalars['String']['input']>;
};

export type AddScreenerPreviewAnswerInput = {
  answer: Scalars['String']['input'];
  /** The project whose screener is being previewed. */
  projectId: Scalars['UUID']['input'];
  /** Session id returned by startScreenerPreview */
  sessionId: Scalars['UUID']['input'];
};

export type AddScreenerQuestionInput = {
  options?: InputMaybe<Array<ScreenerQuestionOptionInput>>;
  projectScreenerId: Scalars['UUID']['input'];
  text: Scalars['String']['input'];
  type: ScreenerQuestionType;
};

export type AddSkillInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  instructions: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Defaults to analysis. Cannot be changed after creation. */
  scope?: InputMaybe<SkillScope>;
};

export type AnsweredQuestionModel = {
  __typename?: 'AnsweredQuestionModel';
  /** Time in seconds the user took to answer the question (for usability-testing projects only) */
  answerTime?: Maybe<Scalars['Float']['output']>;
  answeredValue: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The number of the follow-up question (for follow-up questions only) */
  followupNumber?: Maybe<Scalars['Int']['output']>;
  /** The text of the follow-up question (for follow-up questions only) */
  followupText?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Whether the question is a follow-up question (for follow-up questions only) */
  isFollowup?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the user showed frustration on this question (based on negative signal in user responses)
   * @deprecated Frustration metrics are being removed. This field always returns null.
   */
  isFrustrated?: Maybe<Scalars['Boolean']['output']>;
  /** Text the respondent typed for the "other" option (multiple-choice answers whose answeredValue includes "other") */
  otherText?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['UUID']['output'];
  /** Whether the user completed the task successfully (for Task questions, from success follow-up response: yes/no) */
  success?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiDoc = {
  __typename?: 'ApiDoc';
  name: Scalars['String']['output'];
  pages: Array<ApiDocPage>;
};

export type ApiDocPage = {
  __typename?: 'ApiDocPage';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Apikey = {
  __typename?: 'Apikey';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  key?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type ApikeyAddInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

/** The status of the asset */
export const AssetStatus = {
  Complete: 'Complete',
  Error: 'Error',
  Pending: 'Pending',
  Processing: 'Processing',
} as const;

export type AssetStatus = (typeof AssetStatus)[keyof typeof AssetStatus];
/** The type of asset */
export const AssetType = {
  File: 'File',
  Text: 'Text',
  Url: 'Url',
} as const;

export type AssetType = (typeof AssetType)[keyof typeof AssetType];
/** Which background style a project theme renders: solid, gradient or image */
export const BackgroundType = {
  Gradient: 'GRADIENT',
  Image: 'IMAGE',
  Solid: 'SOLID',
} as const;

export type BackgroundType =
  (typeof BackgroundType)[keyof typeof BackgroundType];
/** Biological sex selector for synthetic AI testers */
export const BiologicalSex = {
  Any: 'Any',
  Female: 'Female',
  Male: 'Male',
} as const;

export type BiologicalSex = (typeof BiologicalSex)[keyof typeof BiologicalSex];
export type ChangeUserRoleInput = {
  /** The new role to assign to the user. */
  role: Role;
  /** The ID of the user whose role will be changed. */
  userId: Scalars['ID']['input'];
};

/** The channel through which an insight was collected */
export const Channel = {
  Email: 'Email',
  Link: 'Link',
  QrCode: 'QrCode',
  SocialMedia: 'SocialMedia',
  TheySaidPanel: 'TheySaidPanel',
  UxAgentPanel: 'UxAgentPanel',
  Website: 'Website',
} as const;

export type Channel = (typeof Channel)[keyof typeof Channel];
export type ChannelStats = {
  __typename?: 'ChannelStats';
  channel: Channel;
  count: Scalars['Int']['output'];
  median?: Maybe<Scalars['Float']['output']>;
};

/** Size category of the chat history (S/M/L) */
export const ChatSize = {
  Large: 'Large',
  Medium: 'Medium',
  Small: 'Small',
} as const;

export type ChatSize = (typeof ChatSize)[keyof typeof ChatSize];
export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  url: Scalars['String']['output'];
};

export type ClaimTempProjectInput = {
  /** Free-survey project to copy into your organization. */
  projectId: Scalars['UUID']['input'];
  /** Free-survey (temporary) organization that owns the project. */
  tempOrgId: Scalars['UUID']['input'];
};

/** A client-recorded artifact attached to a session. */
export type CompanionArtifact = {
  __typename?: 'CompanionArtifact';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** JSON-encoded artifact payload. */
  payloadJson: Scalars['String']['output'];
};

/** One generative-UI block operation of a skill-result turn. The document is an ordered block list the client maintains incrementally: upsert inserts a new block (at afterBlockId, else appended) or replaces the existing block with the same blockId in place; remove deletes it. */
export type CompanionBlockFrame = {
  __typename?: 'CompanionBlockFrame';
  /** For a NEW block: insert after this block id; null = append at the end. */
  afterBlockId?: Maybe<Scalars['String']['output']>;
  blockId: Scalars['String']['output'];
  /** JSON-encoded ViewBlock (upsert only) — see docs/skill-result-ui-contract.md. */
  blockJson?: Maybe<Scalars['String']['output']>;
  /** 'upsert' | 'remove'. */
  op: Scalars['String']['output'];
};

/** A rendered chart image hosted on GCS. */
export type CompanionChartFrame = {
  __typename?: 'CompanionChartFrame';
  alt?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** One progressive frame of a companion turn. */
export type CompanionFrame = {
  __typename?: 'CompanionFrame';
  /** Block operation (BLOCK frames of skill-result turns). */
  block?: Maybe<CompanionBlockFrame>;
  chart?: Maybe<CompanionChartFrame>;
  conversationId: Scalars['ID']['output'];
  /** The final reconciled view document JSON — {theme, blocks[]} — on the DONE frame of skill-result turns; authoritative over incrementally applied BLOCK/THEME frames. */
  documentJson?: Maybe<Scalars['String']['output']>;
  /** Total turn duration (DONE frame). */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Machine-readable error code (ERROR frames only). */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** The complete final report markdown (DONE frame). */
  finalMarkdown?: Maybe<Scalars['String']['output']>;
  section?: Maybe<CompanionSection>;
  /** Monotonic sequence number within the turn. */
  seq: Scalars['Int']['output'];
  /** The drafted skill (SKILL_DRAFT frames of skill-author turns). */
  skillDraft?: Maybe<CompanionSkillDraftFrame>;
  /** The persisted ProjectSkillResult id (DONE frame of skill-result turns) — pass back to patch this result later. */
  skillResultId?: Maybe<Scalars['String']['output']>;
  /** Text for NOTICE / TEXT_DELTA / ERROR frames. */
  text?: Maybe<Scalars['String']['output']>;
  /** Document theme (THEME frames of skill-result turns). */
  theme?: Maybe<CompanionThemeFrame>;
  tool?: Maybe<CompanionToolFrame>;
  type: CompanionFrameType;
};

export const CompanionFrameType = {
  Block: 'BLOCK',
  Chart: 'CHART',
  Done: 'DONE',
  Error: 'ERROR',
  Notice: 'NOTICE',
  Section: 'SECTION',
  SkillDraft: 'SKILL_DRAFT',
  TextDelta: 'TEXT_DELTA',
  Theme: 'THEME',
  ToolCall: 'TOOL_CALL',
  ToolResult: 'TOOL_RESULT',
} as const;

export type CompanionFrameType =
  (typeof CompanionFrameType)[keyof typeof CompanionFrameType];
/** One item of a session's chain-of-thought history. */
export type CompanionMessage = {
  __typename?: 'CompanionMessage';
  /** JSON-encoded legacy sidebar actions (backwards-compatibility only). */
  actionsJson?: Maybe<Scalars['String']['output']>;
  /** Files the user attached to this message; null/absent on every other item. Render these as attachment chips — `text` holds only what the user typed. */
  attachments?: Maybe<Array<CompanionMessageAttachment>>;
  /** JSON-encoded raw agent history item (full fidelity); always present. */
  contentJson: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Item kind: 'message' | 'function_call' | 'function_call_result' | 'reasoning' | … */
  itemType: Scalars['String']['output'];
  /** For message items: 'user' | 'assistant' | 'system'. */
  role?: Maybe<Scalars['String']['output']>;
  /** Visible message text; null for tool/reasoning items. */
  text?: Maybe<Scalars['String']['output']>;
};

/** A file the user attached to a companion message. */
export type CompanionMessageAttachment = {
  __typename?: 'CompanionMessageAttachment';
  /** The uploader's original file name, for display. */
  fileName: Scalars['String']['output'];
  /** Object path in the public bucket (`org-assets/{orgId}/…`). */
  gcsKey: Scalars['String']['output'];
  /** 'image' (shown to the companion directly) | 'document' (text extracted server-side) | 'pdf-pages' (a PDF with no text layer, shown to the companion as rendered pages). Treat any unknown value as a document. */
  kind: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  /** Public URL of the file. */
  url?: Maybe<Scalars['String']['output']>;
};

export type CompanionMessageInput = {
  /** Files attached to this message: the public URLs (or bucket paths) returned by createSignedUploadUrl, uploaded BEFORE sending the message. Max 5 per message, and each must belong to the caller's organization. Images (png/jpeg/webp/gif) are shown to the companion; documents (pdf, Word, Excel, PowerPoint, txt, markdown, csv, rtf) have their text extracted server-side. */
  attachmentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The existing session to run this turn in (create one first via createCompanionSession). Omit for a stateless turn: no history is loaded, nothing is persisted, and the turn cannot be resumed or listed afterward. */
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  /** The user's message. Send an empty string for an attachment-only turn (attachmentUrls must then be non-empty). */
  message: Scalars['String']['input'];
  /** Output persona id (from the companionPersonas query) shaping the narration style of this turn only. Omit or send 'default' for the standard voice; unknown ids fall back to default. */
  personaId?: InputMaybe<Scalars['String']['input']>;
  /** The user's IANA timezone (e.g. 'America/New_York'), from the browser. Used to interpret relative/date-only dates (today, last week, exports) in the user's local time rather than the server's. Omit to fall back to UTC. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** A selectable output persona that changes only the narration STYLE of the companion — never the data, tools, or formatting. */
export type CompanionPersona = {
  __typename?: 'CompanionPersona';
  /** One-line description of the voice. */
  description: Scalars['String']['output'];
  /** Stable id to send back as CompanionMessageInput.personaId. */
  id: Scalars['ID']['output'];
  /** True for the default persona (identical to the base voice). */
  isDefault: Scalars['Boolean']['output'];
  /** Short display name for the persona picker. */
  name: Scalars['String']['output'];
};

/** A clickable example prompt for the companion. STATIC suggestions are a fixed generic catalog; DYNAMIC ones are generated from the org's live activity and carry a `reason` and (usually) a `projectId`. */
export type CompanionPromptSuggestion = {
  __typename?: 'CompanionPromptSuggestion';
  /** Stable id — for click-tracking / dedup on the client. */
  id: Scalars['ID']['output'];
  kind: CompanionPromptSuggestionKind;
  /** DYNAMIC only — the project the suggestion is scoped to. */
  projectId?: Maybe<Scalars['String']['output']>;
  /** DYNAMIC only — short human-readable "why this surfaced". */
  reason?: Maybe<Scalars['String']['output']>;
  /** The prompt text shown to the user (also what gets sent on click). */
  title: Scalars['String']['output'];
};

export const CompanionPromptSuggestionKind = {
  Dynamic: 'DYNAMIC',
  Static: 'STATIC',
} as const;

export type CompanionPromptSuggestionKind =
  (typeof CompanionPromptSuggestionKind)[keyof typeof CompanionPromptSuggestionKind];
/** A custom-rendered block; render `kind` specially or fall back to `markdown`. */
export type CompanionSection = {
  __typename?: 'CompanionSection';
  kind: Scalars['String']['output'];
  /** Markdown fallback if the frontend has no custom renderer for `kind`. */
  markdown?: Maybe<Scalars['String']['output']>;
  /** JSON-encoded structured payload for bespoke rendering. */
  payloadJson?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** A companion conversation session, owned by one user within one organization. */
export type CompanionSession = {
  __typename?: 'CompanionSession';
  /** Number of artifacts recorded on this session. */
  artifactCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** AI-generated or user-set conversation name; null until set. */
  name?: Maybe<Scalars['String']['output']>;
  /** Output persona id for this conversation (narration style only); defaults to the base voice. */
  personaId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A drafted skill (SKILL_DRAFT frames of skill-author turns): the form fields the client should fill. Replaces any previously streamed draft in the same turn. */
export type CompanionSkillDraftFrame = {
  __typename?: 'CompanionSkillDraftFrame';
  /** One sentence; doubles as the chat companion's trigger line. */
  description: Scalars['String']['output'];
  instructions: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Why the draft is shaped this way (shown as a caption, not saved). */
  rationale?: Maybe<Scalars['String']['output']>;
};

/** The view document theme (branding-derived); replaces any previously streamed theme. */
export type CompanionThemeFrame = {
  __typename?: 'CompanionThemeFrame';
  /** JSON-encoded ViewTheme — see docs/skill-result-ui-contract.md. */
  themeJson: Scalars['String']['output'];
};

/** A tool call the companion is making or has completed. */
export type CompanionToolFrame = {
  __typename?: 'CompanionToolFrame';
  /** JSON-encoded tool arguments. */
  argsJson?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** 'started' | 'succeeded' | 'failed' */
  status: Scalars['String']['output'];
  /** Short human-readable result summary. */
  summary?: Maybe<Scalars['String']['output']>;
};

/** Creates the connection’s ticket-agent setup, or updates it in place (one per connection). */
export type ConfigureTicketAgentInput = {
  provider: Scalars['String']['input'];
  /** The provider scope id (ClickUp space, Jira project key, monday board, Linear team, Asana project). */
  scopeId: Scalars['String']['input'];
  scopeName?: InputMaybe<Scalars['String']['input']>;
  /** The status whose transition starts a test. Comments only continue tickets already started. */
  triggerStatus: Scalars['String']['input'];
};

export type ConnectSessionResponse = {
  __typename?: 'ConnectSessionResponse';
  connectSessionToken: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ContactDetailModel = {
  __typename?: 'ContactDetailModel';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastResponseDate?: Maybe<Scalars['DateTime']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Total responses (insights) this contact has given across all projects. */
  responseCount: Scalars['Int']['output'];
  /** Most recent responses first (max 50). */
  responses: Array<ContactResponseModel>;
};

export type ContactResponseModel = {
  __typename?: 'ContactResponseModel';
  createdAt: Scalars['DateTime']['output'];
  /** The insight id — opens the conversation dialog. */
  insightId: Scalars['UUID']['output'];
  projectId: Scalars['UUID']['output'];
  projectTitle?: Maybe<Scalars['String']['output']>;
  /** Sentiment signal of the response. */
  signal?: Maybe<Signal>;
  summaryTitle?: Maybe<Scalars['String']['output']>;
};

export type ContactSummaryModel = {
  __typename?: 'ContactSummaryModel';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastResponseDate?: Maybe<Scalars['DateTime']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  /** Total responses (insights) this contact has given across all projects. */
  responseCount: Scalars['Int']['output'];
};

export type CounterThemeModel = {
  __typename?: 'CounterThemeModel';
  /** A short one-to-three sentence description of the theme (concise counterpart to `summary`). */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sentiment?: Maybe<Signal>;
  summary?: Maybe<Scalars['String']['output']>;
  totalInsights: Scalars['Int']['output'];
  /** `description` translated into the project language (non-English projects only) */
  translatedDescription?: Maybe<Scalars['String']['output']>;
  /** `name` translated into the project language (non-English projects only) */
  translatedName?: Maybe<Scalars['String']['output']>;
  /** `summary` translated into the project language (non-English projects only) */
  translatedSummary?: Maybe<Scalars['String']['output']>;
};

export type CreateCompanionArtifactInput = {
  /** JSON-encoded artifact payload (must be a JSON object). */
  payloadJson: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
};

export type CreateConnectionRuleInput = {
  activationData: Scalars['String']['input'];
  activationType: RuleActivationType;
  aiFollowup: Scalars['Int']['input'];
  postActivationActionData?: InputMaybe<Scalars['String']['input']>;
  postActivationActionType: RuleActionType;
  preActivationActionData?: InputMaybe<Scalars['String']['input']>;
  preActivationActionType?: InputMaybe<RuleActionType>;
  sourceQuestionId: Scalars['ID']['input'];
  targetQuestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateConnectionRuleSpecInput = {
  activationData: Scalars['String']['input'];
  activationType: RuleActivationType;
  aiFollowup: Scalars['Int']['input'];
  postActivationActionData?: InputMaybe<Scalars['String']['input']>;
  postActivationActionType: RuleActionType;
  preActivationActionData?: InputMaybe<Scalars['String']['input']>;
  preActivationActionType?: InputMaybe<RuleActionType>;
  targetQuestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateConnectionRulesInput = {
  rules: Array<CreateConnectionRuleSpecInput>;
  sourceQuestionId: Scalars['ID']['input'];
};

export type CreateInsightTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type CreateMobileAppSignedUploadUrlInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
};

export type CreateOptionAssetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optionId: Scalars['UUID']['input'];
  url: Scalars['String']['input'];
};

export type CreateOrgIntroVideoInput = {
  /** Duration of the intro video in seconds. */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** GCS key of the uploaded intro video. */
  gcsKey: Scalars['String']['input'];
  /** MIME type of the video (must be a video/* type). */
  mimeType: Scalars['String']['input'];
  /** Optional display name for the intro video. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationInput = {
  /** The name of the organization to create. */
  name: Scalars['String']['input'];
};

export type CreateOrganizationSettingsInput = {
  /** Whether the organization consents to TheySaid using its survey data to train and improve TheySaid's AI models */
  aiTrainingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL of the organization avatar */
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  /** Background color */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Primary brand color in hex format (e.g. #FF0000) */
  brandColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  /** Organization category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization_assets intro video to use as the org-level default intro video (null clears it) */
  defaultIntroVideoAssetId?: InputMaybe<Scalars['UUID']['input']>;
  /** ID of the organization_assets moderator voice to use as the org-level default moderator voice (null uses the built-in ElevenLabs default) */
  defaultModeratorVoiceAssetId?: InputMaybe<Scalars['UUID']['input']>;
  /** Font family name */
  font?: InputMaybe<Scalars['String']['input']>;
  /** Whether to hide the TheySaid logo */
  hideTheysaidLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization industry */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Default language code for new projects in this organization (e.g. 'en', 'fr') */
  language?: InputMaybe<Scalars['String']['input']>;
  /** URL of the organization logo */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Selected background image URL (must be one of the backgrounds in backgroundImages) */
  selectedBackground?: InputMaybe<Scalars['String']['input']>;
  /** Target customers */
  targetCustomers?: InputMaybe<Scalars['String']['input']>;
  /** Theme mode (dark or light) */
  themeMode?: InputMaybe<ThemeMode>;
  /** Transparency level (0-100) */
  transparency?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum widget popups per device per month (null = no limit, must be >= 1) */
  widgetMaxPopupsPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Seconds between widget popups for the same device (null = no limit) */
  widgetTimeBetweenPopupsSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProjectInput = {
  /** When enabled, voice recordings are deleted and PII is redacted. */
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  calendarLink?: InputMaybe<Scalars['String']['input']>;
  /** Whether responders may jump forward to later questions. Redesigned builder. */
  canJumpForward?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Device types this project supports (computer | phone). Redesigned builder. */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  inAppPopupMessage?: InputMaybe<Scalars['String']['input']>;
  inferredType?: InputMaybe<ProjectType>;
  /** How responders interact with the survey (voice | text). Redesigned builder. */
  interactionType?: InputMaybe<InteractionType>;
  /** @deprecated Redesigned builder (868gc1px2): intro content now lives in the project_intro table. */
  introText?: InputMaybe<Scalars['String']['input']>;
  /** Whether AI form assistance is enabled for this project. */
  isAIFormAssistanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAiVoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAnalyticsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isCameraEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isPoll?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the thank-you screen is shown. Null defaults to on when a custom message exists. */
  isThankyouEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUserVoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `objectives` instead */
  learningGoal?: InputMaybe<Scalars['String']['input']>;
  maxResponses?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use `interactionType` instead. Redesigned builder (868gc1px2). */
  mode?: InputMaybe<ProjectMode>;
  objectives?: InputMaybe<Array<CreateProjectObjectiveInput>>;
  publicTitle?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<CreateProjectQuestionInput>>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  reviewLink?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatus>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  syntheticAge?: InputMaybe<IntRangeInput>;
  syntheticAiTesters?: InputMaybe<Scalars['Int']['input']>;
  syntheticBiologicalSex?: InputMaybe<BiologicalSex>;
  syntheticCompanyIndustry?: InputMaybe<Scalars['String']['input']>;
  syntheticCompanySize?: InputMaybe<Scalars['String']['input']>;
  syntheticKnowledgebase?: InputMaybe<Scalars['String']['input']>;
  syntheticMotivation?: InputMaybe<Scalars['String']['input']>;
  syntheticPersonality?: InputMaybe<Array<PersonalityRangeInput>>;
  syntheticTitles?: InputMaybe<Scalars['String']['input']>;
  syntheticUseProxy?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticWorldview?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<CreateTagV2Input>>;
  thankyouDescription?: InputMaybe<Scalars['String']['input']>;
  thankyouText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  type?: InputMaybe<ProjectType>;
};

export type CreateProjectInsightsDownloadInput = {
  /** Language for the export — either English or the project's own language (a project supports exactly those two). English renders the translated columns for non-English projects; defaults to the original project language when omitted. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the project to filter by. If not provided, download for all projects will be created. */
  projectId: Scalars['UUID']['input'];
};

export type CreateProjectIntroInput = {
  /** Channels this intro is shown on. */
  audience?: InputMaybe<Array<Channel>>;
  introSource?: InputMaybe<IntroSource>;
  /** Whether the responder shows this intro. Defaults to true. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the intro instructions (title/subtitle) are shown. Defaults to true. */
  isInstructionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the intro video is shown. Defaults to true. */
  isVideoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orgAssetId?: InputMaybe<Scalars['UUID']['input']>;
  projectAssetId?: InputMaybe<Scalars['UUID']['input']>;
  projectId: Scalars['UUID']['input'];
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectIntroVideoInput = {
  /** Duration of the intro video in seconds. */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** GCS key of the uploaded intro video. */
  gcsKey: Scalars['String']['input'];
  /** MIME type of the video (must be a video/* type). */
  mimeType: Scalars['String']['input'];
  /** Optional display name for the intro video. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The project to attach the intro video to. */
  projectId: Scalars['ID']['input'];
};

export type CreateProjectObjectiveInput = {
  text: Scalars['String']['input'];
};

export type CreateProjectQuestionInput = {
  aiConvoDepth?: InputMaybe<Scalars['Int']['input']>;
  aiInsights?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<Array<CreateQuestionV2AssetInput>>;
  contentUrl?: InputMaybe<Scalars['String']['input']>;
  /** For Task questions in usability-testing projects: enable feedback follow-up question */
  feedbackQuestionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Per-question voice|text override; null inherits the project. Redesigned builder. */
  interactionType?: InputMaybe<InteractionType>;
  maxSelections?: InputMaybe<Scalars['Int']['input']>;
  minSelections?: InputMaybe<Scalars['Int']['input']>;
  multipleSelect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Label for the Not Applicable option on matrix questions. Null/omitted means N/A is disabled; any value enables it. */
  notApplicableLabel?: InputMaybe<Scalars['String']['input']>;
  optionRenderType?: InputMaybe<OptionRenderType>;
  options?: InputMaybe<Array<QuestionOptionInput>>;
  questionOrder?: InputMaybe<Scalars['Int']['input']>;
  randomize?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this question shows live results to responders. Redesigned builder. */
  showLiveDistribution?: InputMaybe<Scalars['Boolean']['input']>;
  subQuestions?: InputMaybe<Array<CreateSubQuestionInput>>;
  /** For Task questions in usability-testing projects: enable success follow-up question */
  successQuestionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<CreateTagV2Input>>;
  text: Scalars['String']['input'];
  type: QuestionType;
};

export type CreateQuestionAssetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['UUID']['input'];
  url: Scalars['String']['input'];
};

export type CreateQuestionV2AssetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateQuestionV2Input = {
  aiConvoDepth?: InputMaybe<Scalars['Int']['input']>;
  aiInsights?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<Array<CreateQuestionV2AssetInput>>;
  contentUrl?: InputMaybe<Scalars['String']['input']>;
  /** For Task questions in usability-testing projects: enable feedback follow-up question */
  feedbackQuestionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Per-question voice|text override; null inherits the project. Redesigned builder. */
  interactionType?: InputMaybe<InteractionType>;
  maxSelections?: InputMaybe<Scalars['Int']['input']>;
  minSelections?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use maxSelections instead */
  multipleSelect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Label for the Not Applicable option on matrix questions. Null/omitted means N/A is disabled; any value enables it. */
  notApplicableLabel?: InputMaybe<Scalars['String']['input']>;
  optionRenderType?: InputMaybe<OptionRenderType>;
  options?: InputMaybe<Array<QuestionOptionInput>>;
  projectId: Scalars['ID']['input'];
  questionOrder?: InputMaybe<Scalars['Int']['input']>;
  randomize?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this question shows live results to responders. Redesigned builder. */
  showLiveDistribution?: InputMaybe<Scalars['Boolean']['input']>;
  subQuestions?: InputMaybe<Array<CreateSubQuestionInput>>;
  /** For Task questions in usability-testing projects: enable success follow-up question */
  successQuestionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<CreateTagV2Input>>;
  text: Scalars['String']['input'];
  type: QuestionType;
};

export type CreateRecruitingAudienceInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Short summary of who the audience is: trimmed, then at most 280 characters; blank or omitted: null. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Per-tester human incentive in cents: a whole-dollar amount from 100 ($1) to 9900 ($99). Omitted or null: none. */
  humanIncentive?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  qualifications?: InputMaybe<Array<PanelQualificationFilterInput>>;
  syntheticAgeMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticAgeMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticAiTesters?: InputMaybe<Scalars['Int']['input']>;
  syntheticBiologicalSex?: InputMaybe<BiologicalSex>;
  syntheticCompanyIndustry?: InputMaybe<Scalars['String']['input']>;
  syntheticCompanySize?: InputMaybe<Scalars['String']['input']>;
  syntheticCompletionMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticCompletionMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticDecisionMakingMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticDecisionMakingMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticDirectnessMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticDirectnessMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticEmotionalExpressivenessMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticEmotionalExpressivenessMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticKnowledgebase?: InputMaybe<Scalars['String']['input']>;
  syntheticLocation?: InputMaybe<Scalars['String']['input']>;
  syntheticMotivation?: InputMaybe<Scalars['String']['input']>;
  syntheticPatienceMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticPatienceMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticPerfectionMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticPerfectionMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticReadingTypeMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticReadingTypeMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticRiskMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticRiskMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticSpeakerBoost?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticTechnologyTrustMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticTechnologyTrustMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticTitles?: InputMaybe<Scalars['String']['input']>;
  syntheticUseProxy?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticVerbosityMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticVerbosityMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticVictorOrVictimMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticVictorOrVictimMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticVoiceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  syntheticVoiceSimilarityBoost?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceSpeed?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStability?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStyle?: InputMaybe<Scalars['Float']['input']>;
  syntheticWorldview?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSignedUrlInput = {
  /** The GCS signed URL action: 'write' (default) or 'resumable' for chunked uploads. */
  action?: InputMaybe<SignedUrlAction>;
  /** The file name to be uploaded */
  fileName: Scalars['String']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mime type of the file */
  mimeType: Scalars['String']['input'];
};

export type CreateSubQuestionInput = {
  questionOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Client-supplied stable id for the sub-question (UUID). For existing rows send the current id; for new rows generate a fresh UUID. The BE upserts by this id so answers survive edits. */
  subQuestionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type CreateTagV2Input = {
  color?: InputMaybe<Scalars['HexColorCode']['input']>;
  name: Scalars['String']['input'];
};

export type CreateWidgetImageInput = {
  /** GCS key of the uploaded image. */
  gcsKey: Scalars['String']['input'];
  /** MIME type of the image (must be an image/* type). */
  mimeType: Scalars['String']['input'];
  /** Optional display name for the image. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The project to attach the widget image to. */
  projectId: Scalars['ID']['input'];
};

export type CreditLedgerEntry = {
  __typename?: 'CreditLedgerEntry';
  /** Signed amount in minor units (cents) of currency: positive adds credit, negative spends it. */
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Lowercase ISO 4217 currency code of amount (e.g. usd). */
  currency: Scalars['String']['output'];
  /** Human-readable summary of the entry. */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: CreditLedgerEntryKind;
  /** The recruiting order the entry belongs to; null for top-ups and manual adjustments. */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** The cohort (order line item) a cancellation refund is for; null for every other entry. */
  orderLineItemId?: Maybe<Scalars['ID']['output']>;
};

/** Kind of entry in the append-only organization credit ledger */
export const CreditLedgerEntryKind = {
  ManualAdjustment: 'ManualAdjustment',
  OrderCancellationCredit: 'OrderCancellationCredit',
  OrderSpend: 'OrderSpend',
  PrepaidTopup: 'PrepaidTopup',
} as const;

export type CreditLedgerEntryKind =
  (typeof CreditLedgerEntryKind)[keyof typeof CreditLedgerEntryKind];
export type CreditLedgerFilterInput = {
  /** Lowercase ISO 4217 currency code to keep; omitted: every currency. */
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  activity?: Maybe<UserActivity>;
  /** The email address of the user. */
  email: Scalars['EmailAddress']['output'];
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the user. */
  id: Scalars['ID']['output'];
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The current user's onboarding-checklist completion flags for the active organization (per-user, per-org). */
  onboardingSteps?: Maybe<OnboardingStepsModel>;
  organizations: Array<OrganizationMembership>;
  /** A URL reference to an image representing the user. */
  profilePictureUrl?: Maybe<Scalars['URL']['output']>;
  /** The role of the user in the organization. */
  role?: Maybe<Role>;
  workosOrganizations: Array<OrganizationMembership>;
};

export type DashboardFilterInput = {
  /** Filter insights to those that occurred on or after this time. */
  since: Scalars['DateTime']['input'];
  /** Filter insights to those that occurred before this time. */
  until: Scalars['DateTime']['input'];
};

export type DateFilterInput = {
  /** How to match `values` against the target field. Accepted values for this filter: IS, AFTER, BEFORE. */
  matchingType: MatchingType;
  /** Values to compare the target field against. */
  values: Array<Scalars['DateTime']['input']>;
};

export type DeleteApiKeyInput = {
  id: Scalars['String']['input'];
};

export type DeleteDocumentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteInsightV2Input = {
  id: Scalars['UUID']['input'];
};

export type DeleteOrgIntroVideoInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationInput = {
  /** The ID of the organization to delete. */
  orgId: Scalars['String']['input'];
};

export type DeleteProjectDocumentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteProjectIntegrationChannelInput = {
  channel: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
};

export type DeleteProjectIntroVideoInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTagV2Input = {
  id: Scalars['ID']['input'];
};

export type DeploySyntheticAgentsInput = {
  /** @deprecated Use `syntheticAge`. */
  age?: InputMaybe<IntRangeInput>;
  /** @deprecated Use `syntheticAiTesters`. */
  aiTesters?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use `syntheticBiologicalSex`. */
  biologicalSex?: InputMaybe<BiologicalSex>;
  /** @deprecated Use `syntheticCompanyIndustry`. */
  companyIndustry?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `syntheticCompanySize`. */
  companySize?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `syntheticKnowledgebase`. */
  knowledgebase?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `syntheticMotivation`. */
  motivation?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `syntheticPersonality`. */
  personality?: InputMaybe<Array<PersonalityRangeInput>>;
  projectId: Scalars['UUID']['input'];
  syntheticAge?: InputMaybe<IntRangeInput>;
  syntheticAiTesters?: InputMaybe<Scalars['Int']['input']>;
  syntheticBiologicalSex?: InputMaybe<BiologicalSex>;
  syntheticCompanyIndustry?: InputMaybe<Scalars['String']['input']>;
  syntheticCompanySize?: InputMaybe<Scalars['String']['input']>;
  syntheticKnowledgebase?: InputMaybe<Scalars['String']['input']>;
  syntheticMotivation?: InputMaybe<Scalars['String']['input']>;
  syntheticPersonality?: InputMaybe<Array<PersonalityRangeInput>>;
  syntheticSpeakerBoost?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticTitles?: InputMaybe<Scalars['String']['input']>;
  syntheticUseProxy?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticVoiceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  syntheticVoiceSimilarityBoost?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceSpeed?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStability?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStyle?: InputMaybe<Scalars['Float']['input']>;
  syntheticWorldview?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `syntheticTitles`. */
  titles?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `syntheticWorldview`. */
  worldview?: InputMaybe<Scalars['String']['input']>;
};

export type DeploySyntheticAgentsResult = {
  __typename?: 'DeploySyntheticAgentsResult';
  jobId: Scalars['ID']['output'];
  sessionId: Scalars['ID']['output'];
};

/** Device type a project supports. computer or phone */
export const DeviceType = {
  Computer: 'Computer',
  Phone: 'Phone',
} as const;

export type DeviceType = (typeof DeviceType)[keyof typeof DeviceType];
export type DistributionItem = {
  __typename?: 'DistributionItem';
  count: Scalars['Int']['output'];
  /** Open-ended/task only: `value` translated into the project language (non-English projects). Filter on `value`. */
  translatedValue?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type DocumentAsset = {
  __typename?: 'DocumentAsset';
  createdAt: Scalars['DateTime']['output'];
  gcsKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: AssetStatus;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentLink = {
  __typename?: 'DocumentLink';
  /** The temporary signed URL that can be used to access the document. Valid for 5 minutes. */
  url: Scalars['String']['output'];
};

export type DocumentListFilterInput = {
  status?: InputMaybe<Array<AssetStatus>>;
  types?: InputMaybe<Array<AssetType>>;
};

export type DocumentOrder = {
  direction?: OrderDirection;
  field: DocumentOrderField;
};

export const DocumentOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT',
} as const;

export type DocumentOrderField =
  (typeof DocumentOrderField)[keyof typeof DocumentOrderField];
export type Download = {
  __typename?: 'Download';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** File extension, e.g. 'xlsx', 'csv', 'pdf', 'docx', 'md'. */
  fileType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Human-readable file name (companion exports). */
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  status: DownloadStatus;
  url?: Maybe<Scalars['String']['output']>;
};

/** The status of the download. */
export const DownloadStatus = {
  Canceled: 'Canceled',
  Complete: 'Complete',
  Error: 'Error',
  Pending: 'Pending',
  Processing: 'Processing',
} as const;

export type DownloadStatus =
  (typeof DownloadStatus)[keyof typeof DownloadStatus];
/** The type of project draft (distinguishes between survey, poll, form, and usability testing) */
export const DraftProjectType = {
  Form: 'Form',
  Poll: 'Poll',
  Survey: 'Survey',
  UsabilityTesting: 'UsabilityTesting',
} as const;

export type DraftProjectType =
  (typeof DraftProjectType)[keyof typeof DraftProjectType];
export type DuplicateProjectInput = {
  projectId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditClipInput = {
  /** If true, enqueue clip video generation after update (only applies when `startTime` and/or `endTime` are sent) */
  autoTriggerGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  publishStatus?: InputMaybe<VideoPublishStatus>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};

export type EditModeratorVoiceInput = {
  id: Scalars['ID']['input'];
  mood?: InputMaybe<VoiceMood>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditProjectTagsInput = {
  projectId: Scalars['ID']['input'];
  tags: Array<CreateTagV2Input>;
};

export type EditQuestionMessagePreviewInput = {
  /** The assets of the new message */
  assets?: InputMaybe<Array<MessageAssetInput>>;
  /** The new message content */
  content: Scalars['String']['input'];
  /** The user message being replaced */
  messageId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
  /** Session id returned by startUnifiedPreview */
  sessionId: Scalars['UUID']['input'];
  /** The new message transcript in voice mode */
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type EditReelInput = {
  /** If true, enqueue reel composition after update (only applies when `scenes` are replaced) */
  autoTriggerGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Reel row id (not the highlight video / project_assets id) */
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  publishStatus?: InputMaybe<VideoPublishStatus>;
  /** When set, replaces all reel scenes (at least one scene required). Omit to leave scenes unchanged. */
  scenes?: InputMaybe<Array<AddReelSceneInput>>;
};

export type EditScreenerQuestionInput = {
  id: Scalars['UUID']['input'];
  options?: InputMaybe<Array<ScreenerQuestionOptionInput>>;
  questionOrder?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ScreenerQuestionType>;
};

export type EditSkillInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skillId: Scalars['UUID']['input'];
};

/** Stable machine-readable error codes returned on the `errorCode` field of every error response. See docs/error-codes.md for messages and HTTP statuses. */
export const ErrorCode = {
  AccountInactive: 'ACCOUNT_INACTIVE',
  AuthCannotLeaveLastOwner: 'AUTH_CANNOT_LEAVE_LAST_OWNER',
  AuthInvitationNotFound: 'AUTH_INVITATION_NOT_FOUND',
  AuthInviteOwnerRequiresOwner: 'AUTH_INVITE_OWNER_REQUIRES_OWNER',
  AuthInviteRequiresAdminOrOwner: 'AUTH_INVITE_REQUIRES_ADMIN_OR_OWNER',
  AuthInviteRequiresMembership: 'AUTH_INVITE_REQUIRES_MEMBERSHIP',
  AuthInviteResendUnsupported: 'AUTH_INVITE_RESEND_UNSUPPORTED',
  AuthInviteWorkosError: 'AUTH_INVITE_WORKOS_ERROR',
  AuthNotMemberOfOrganization: 'AUTH_NOT_MEMBER_OF_ORGANIZATION',
  AuthOnlyOwnersCanDeleteOrg: 'AUTH_ONLY_OWNERS_CAN_DELETE_ORG',
  AuthOrganizationMissingWorkosId: 'AUTH_ORGANIZATION_MISSING_WORKOS_ID',
  AuthOrganizationNotFound: 'AUTH_ORGANIZATION_NOT_FOUND',
  AuthTemplateProjectNotFound: 'AUTH_TEMPLATE_PROJECT_NOT_FOUND',
  AuthUserAssignOwnerRequiresOwner: 'AUTH_USER_ASSIGN_OWNER_REQUIRES_OWNER',
  AuthUserCannotChangeOwnRole: 'AUTH_USER_CANNOT_CHANGE_OWN_ROLE',
  AuthUserCannotDeleteSelf: 'AUTH_USER_CANNOT_DELETE_SELF',
  AuthUserChangeOwnerRoleRequiresOwner:
    'AUTH_USER_CHANGE_OWNER_ROLE_REQUIRES_OWNER',
  AuthUserDeleteAdminRequiresOwner: 'AUTH_USER_DELETE_ADMIN_REQUIRES_OWNER',
  AuthUserDeleteOwnerRequiresOwner: 'AUTH_USER_DELETE_OWNER_REQUIRES_OWNER',
  AuthUserDeleteRequiresAdminOrOwner:
    'AUTH_USER_DELETE_REQUIRES_ADMIN_OR_OWNER',
  AuthUserRoleChangeRequiresAdminOrOwner:
    'AUTH_USER_ROLE_CHANGE_REQUIRES_ADMIN_OR_OWNER',
  BillingCheckoutSessionFailed: 'BILLING_CHECKOUT_SESSION_FAILED',
  BillingCreditBalanceInvalid: 'BILLING_CREDIT_BALANCE_INVALID',
  BillingCreditLedgerCurrencyInvalid: 'BILLING_CREDIT_LEDGER_CURRENCY_INVALID',
  BillingCreditLedgerEntryInvalid: 'BILLING_CREDIT_LEDGER_ENTRY_INVALID',
  BillingCreditLedgerOrderSpendMismatch:
    'BILLING_CREDIT_LEDGER_ORDER_SPEND_MISMATCH',
  BillingCreditLedgerWriteFailed: 'BILLING_CREDIT_LEDGER_WRITE_FAILED',
  BillingCustomerPortalSessionFailed: 'BILLING_CUSTOMER_PORTAL_SESSION_FAILED',
  BillingOrderCheckoutAmountInvalid: 'BILLING_ORDER_CHECKOUT_AMOUNT_INVALID',
  BillingOrderCheckoutAmountMismatch: 'BILLING_ORDER_CHECKOUT_AMOUNT_MISMATCH',
  BillingOrderCheckoutLineItemsInvalid:
    'BILLING_ORDER_CHECKOUT_LINE_ITEMS_INVALID',
  BillingOrderCheckoutOriginInvalid: 'BILLING_ORDER_CHECKOUT_ORIGIN_INVALID',
  BillingOrderCheckoutSessionExpiryUnconfirmed:
    'BILLING_ORDER_CHECKOUT_SESSION_EXPIRY_UNCONFIRMED',
  BillingOrderCheckoutSessionFailed: 'BILLING_ORDER_CHECKOUT_SESSION_FAILED',
  BillingOrderCheckoutSessionRetrieveFailed:
    'BILLING_ORDER_CHECKOUT_SESSION_RETRIEVE_FAILED',
  BillingOrganizationNotFound: 'BILLING_ORGANIZATION_NOT_FOUND',
  BillingStripeCustomerCreationFailed:
    'BILLING_STRIPE_CUSTOMER_CREATION_FAILED',
  BillingStripeCustomerIdNotFound: 'BILLING_STRIPE_CUSTOMER_ID_NOT_FOUND',
  BillingStripeProductFetchFailed: 'BILLING_STRIPE_PRODUCT_FETCH_FAILED',
  ClipsReelsAssetNotAReel: 'CLIPS_REELS_ASSET_NOT_A_REEL',
  ClipsReelsClipsMustBelongToReelProject:
    'CLIPS_REELS_CLIPS_MUST_BELONG_TO_REEL_PROJECT',
  ClipsReelsClipAccessDenied: 'CLIPS_REELS_CLIP_ACCESS_DENIED',
  ClipsReelsClipIdNotAllowedOnTransitionScene:
    'CLIPS_REELS_CLIP_ID_NOT_ALLOWED_ON_TRANSITION_SCENE',
  ClipsReelsClipIdRequiredForClipScene:
    'CLIPS_REELS_CLIP_ID_REQUIRED_FOR_CLIP_SCENE',
  ClipsReelsClipInsightNotFound: 'CLIPS_REELS_CLIP_INSIGHT_NOT_FOUND',
  ClipsReelsClipMissingStartEndTime: 'CLIPS_REELS_CLIP_MISSING_START_END_TIME',
  ClipsReelsClipNotFound: 'CLIPS_REELS_CLIP_NOT_FOUND',
  ClipsReelsClipRowMissing: 'CLIPS_REELS_CLIP_ROW_MISSING',
  ClipsReelsClipSceneDurationMustBePositive:
    'CLIPS_REELS_CLIP_SCENE_DURATION_MUST_BE_POSITIVE',
  ClipsReelsClipSceneRequiresCompletedVideo:
    'CLIPS_REELS_CLIP_SCENE_REQUIRES_COMPLETED_VIDEO',
  ClipsReelsInsightAccessDenied: 'CLIPS_REELS_INSIGHT_ACCESS_DENIED',
  ClipsReelsInsightNotFound: 'CLIPS_REELS_INSIGHT_NOT_FOUND',
  ClipsReelsInvalidStartEndTime: 'CLIPS_REELS_INVALID_START_END_TIME',
  ClipsReelsProjectAccessDenied: 'CLIPS_REELS_PROJECT_ACCESS_DENIED',
  ClipsReelsProjectHighlightVideoAccessDenied:
    'CLIPS_REELS_PROJECT_HIGHLIGHT_VIDEO_ACCESS_DENIED',
  ClipsReelsProjectHighlightVideoNotFound:
    'CLIPS_REELS_PROJECT_HIGHLIGHT_VIDEO_NOT_FOUND',
  ClipsReelsProjectNotFound: 'CLIPS_REELS_PROJECT_NOT_FOUND',
  ClipsReelsReelAccessDenied: 'CLIPS_REELS_REEL_ACCESS_DENIED',
  ClipsReelsReelClipSceneMissingVideo:
    'CLIPS_REELS_REEL_CLIP_SCENE_MISSING_VIDEO',
  ClipsReelsReelHasNoScenes: 'CLIPS_REELS_REEL_HAS_NO_SCENES',
  ClipsReelsReelNotFound: 'CLIPS_REELS_REEL_NOT_FOUND',
  ClipsReelsReelRowMissing: 'CLIPS_REELS_REEL_ROW_MISSING',
  ClipsReelsTooManyReelScenes: 'CLIPS_REELS_TOO_MANY_REEL_SCENES',
  ClipsReelsTransitionSceneDurationMustBePositive:
    'CLIPS_REELS_TRANSITION_SCENE_DURATION_MUST_BE_POSITIVE',
  ClipsReelsTransitionSceneDurationRequired:
    'CLIPS_REELS_TRANSITION_SCENE_DURATION_REQUIRED',
  ClipsReelsTransitionTextOnlyOnTransitionScene:
    'CLIPS_REELS_TRANSITION_TEXT_ONLY_ON_TRANSITION_SCENE',
  ClipsReelsUnsupportedHighlightVideoType:
    'CLIPS_REELS_UNSUPPORTED_HIGHLIGHT_VIDEO_TYPE',
  CompanionAttachmentNotFound: 'COMPANION_ATTACHMENT_NOT_FOUND',
  CompanionAttachmentTextExtractionFailed:
    'COMPANION_ATTACHMENT_TEXT_EXTRACTION_FAILED',
  CompanionAttachmentTooLarge: 'COMPANION_ATTACHMENT_TOO_LARGE',
  CompanionInvalidArtifactPayload: 'COMPANION_INVALID_ARTIFACT_PAYLOAD',
  CompanionInvalidPersona: 'COMPANION_INVALID_PERSONA',
  CompanionMessageRequired: 'COMPANION_MESSAGE_REQUIRED',
  CompanionProjectNotFound: 'COMPANION_PROJECT_NOT_FOUND',
  CompanionRunFailed: 'COMPANION_RUN_FAILED',
  CompanionSessionNotFound: 'COMPANION_SESSION_NOT_FOUND',
  CompanionSessionRequired: 'COMPANION_SESSION_REQUIRED',
  CompanionSkillRefRequired: 'COMPANION_SKILL_REF_REQUIRED',
  CompanionTooManyAttachments: 'COMPANION_TOO_MANY_ATTACHMENTS',
  CompanionUnsupportedAttachmentType: 'COMPANION_UNSUPPORTED_ATTACHMENT_TYPE',
  CompanyInfoDocumentDuplicate: 'COMPANY_INFO_DOCUMENT_DUPLICATE',
  CompanyInfoDocumentMimeTypeRequired:
    'COMPANY_INFO_DOCUMENT_MIME_TYPE_REQUIRED',
  CompanyInfoDocumentMissingGcsKey: 'COMPANY_INFO_DOCUMENT_MISSING_GCS_KEY',
  CompanyInfoDocumentNotFound: 'COMPANY_INFO_DOCUMENT_NOT_FOUND',
  CompanyInfoDocumentProcessingFailed:
    'COMPANY_INFO_DOCUMENT_PROCESSING_FAILED',
  CompanyInfoDocumentSourceInvalidCount:
    'COMPANY_INFO_DOCUMENT_SOURCE_INVALID_COUNT',
  CompanyInfoDocumentSourceMultipleProvided:
    'COMPANY_INFO_DOCUMENT_SOURCE_MULTIPLE_PROVIDED',
  CompanyInfoFileUploadFailed: 'COMPANY_INFO_FILE_UPLOAD_FAILED',
  CompanyInfoIntroVideoInvalidGcsKey:
    'COMPANY_INFO_INTRO_VIDEO_INVALID_GCS_KEY',
  CompanyInfoIntroVideoInvalidMimeType:
    'COMPANY_INFO_INTRO_VIDEO_INVALID_MIME_TYPE',
  CompanyInfoIntroVideoMissingGcsKey:
    'COMPANY_INFO_INTRO_VIDEO_MISSING_GCS_KEY',
  CompanyInfoIntroVideoNotFound: 'COMPANY_INFO_INTRO_VIDEO_NOT_FOUND',
  CompanyInfoInvalidImagePath: 'COMPANY_INFO_INVALID_IMAGE_PATH',
  CompanyInfoInvalidWebsite: 'COMPANY_INFO_INVALID_WEBSITE',
  CompanyInfoOrganizationIdMismatch: 'COMPANY_INFO_ORGANIZATION_ID_MISMATCH',
  CompanyInfoOrganizationMissingWorkosId:
    'COMPANY_INFO_ORGANIZATION_MISSING_WORKOS_ID',
  CompanyInfoOrganizationNotFound: 'COMPANY_INFO_ORGANIZATION_NOT_FOUND',
  CompanyInfoOrganizationSettingsNotFound:
    'COMPANY_INFO_ORGANIZATION_SETTINGS_NOT_FOUND',
  CompanyInfoSignedUrlGenerationFailed:
    'COMPANY_INFO_SIGNED_URL_GENERATION_FAILED',
  CompanyInfoUnknownError: 'COMPANY_INFO_UNKNOWN_ERROR',
  CompanyInfoUrlPreviewFailed: 'COMPANY_INFO_URL_PREVIEW_FAILED',
  CompanyInfoWorkosOrgAndCompanyCreationFailed:
    'COMPANY_INFO_WORKOS_ORG_AND_COMPANY_CREATION_FAILED',
  Conflict: 'CONFLICT',
  ConnectionRulesForbidden: 'CONNECTION_RULES_FORBIDDEN',
  ConnectionRulesNotFound: 'CONNECTION_RULES_NOT_FOUND',
  ConnectionRulesProjectMismatch: 'CONNECTION_RULES_PROJECT_MISMATCH',
  ConnectionRulesSourceProjectNotFound:
    'CONNECTION_RULES_SOURCE_PROJECT_NOT_FOUND',
  ConnectionRulesSourceQuestionNotFound:
    'CONNECTION_RULES_SOURCE_QUESTION_NOT_FOUND',
  ConnectionRulesTargetQuestionNotFound:
    'CONNECTION_RULES_TARGET_QUESTION_NOT_FOUND',
  Forbidden: 'FORBIDDEN',
  GatingRestriction: 'GATING_RESTRICTION',
  InsightsNotFound: 'INSIGHTS_NOT_FOUND',
  InsightsOrgMismatch: 'INSIGHTS_ORG_MISMATCH',
  InsightsPreviewScreenerSessionKeyRequired:
    'INSIGHTS_PREVIEW_SCREENER_SESSION_KEY_REQUIRED',
  InsightsProjectNotFound: 'INSIGHTS_PROJECT_NOT_FOUND',
  InsightsQuestionNotFound: 'INSIGHTS_QUESTION_NOT_FOUND',
  InsightsTagAlreadyAssociated: 'INSIGHTS_TAG_ALREADY_ASSOCIATED',
  InsightsTagNotAssociated: 'INSIGHTS_TAG_NOT_ASSOCIATED',
  InsightsTagNotFound: 'INSIGHTS_TAG_NOT_FOUND',
  InsightsTagNotFoundAfterAdding: 'INSIGHTS_TAG_NOT_FOUND_AFTER_ADDING',
  InternalError: 'INTERNAL_ERROR',
  LlmGatewayChatV4EmptySetupResponse:
    'LLM_GATEWAY_CHAT_V4_EMPTY_SETUP_RESPONSE',
  LlmGatewayChatV4InspectUnavailable: 'LLM_GATEWAY_CHAT_V4_INSPECT_UNAVAILABLE',
  LlmGatewayChatV4ProjectNotFound: 'LLM_GATEWAY_CHAT_V4_PROJECT_NOT_FOUND',
  LlmGatewayChatV4QuestionNotFound: 'LLM_GATEWAY_CHAT_V4_QUESTION_NOT_FOUND',
  LlmGatewayChatV4SessionIdRequired: 'LLM_GATEWAY_CHAT_V4_SESSION_ID_REQUIRED',
  LlmGatewayChatV4SessionNotFound: 'LLM_GATEWAY_CHAT_V4_SESSION_NOT_FOUND',
  LlmGatewayChatV4SetupMissingQuestionId:
    'LLM_GATEWAY_CHAT_V4_SETUP_MISSING_QUESTION_ID',
  MessagesPreviewEditNotAllowed: 'MESSAGES_PREVIEW_EDIT_NOT_ALLOWED',
  MessagesPreviewJumpNotAllowed: 'MESSAGES_PREVIEW_JUMP_NOT_ALLOWED',
  MessagesPreviewMessageNotFound: 'MESSAGES_PREVIEW_MESSAGE_NOT_FOUND',
  MessagesPreviewProjectNotUnified: 'MESSAGES_PREVIEW_PROJECT_NOT_UNIFIED',
  MessagesPreviewQuestionNotFound: 'MESSAGES_PREVIEW_QUESTION_NOT_FOUND',
  MessagesPreviewQuestionNotPrimary: 'MESSAGES_PREVIEW_QUESTION_NOT_PRIMARY',
  MessagesPreviewQuestionNotSkippable:
    'MESSAGES_PREVIEW_QUESTION_NOT_SKIPPABLE',
  MessagesPreviewScreenerSessionKeyRequired:
    'MESSAGES_PREVIEW_SCREENER_SESSION_KEY_REQUIRED',
  MessagesPreviewSelectionBoundsViolated:
    'MESSAGES_PREVIEW_SELECTION_BOUNDS_VIOLATED',
  MessagesPreviewSessionRecoveryStateMissing:
    'MESSAGES_PREVIEW_SESSION_RECOVERY_STATE_MISSING',
  MessagesProjectNotFound: 'MESSAGES_PROJECT_NOT_FOUND',
  MessagesValidationFailed: 'MESSAGES_VALIDATION_FAILED',
  ModeratorVoiceCloneFailed: 'MODERATOR_VOICE_CLONE_FAILED',
  ModeratorVoiceExternalMissing: 'MODERATOR_VOICE_EXTERNAL_MISSING',
  ModeratorVoiceInvalidGcsKey: 'MODERATOR_VOICE_INVALID_GCS_KEY',
  ModeratorVoiceInvalidMimeType: 'MODERATOR_VOICE_INVALID_MIME_TYPE',
  ModeratorVoiceInUse: 'MODERATOR_VOICE_IN_USE',
  ModeratorVoiceLanguageUnsupported: 'MODERATOR_VOICE_LANGUAGE_UNSUPPORTED',
  ModeratorVoiceMissingGcsKey: 'MODERATOR_VOICE_MISSING_GCS_KEY',
  ModeratorVoiceMissingTranscript: 'MODERATOR_VOICE_MISSING_TRANSCRIPT',
  ModeratorVoiceNotFound: 'MODERATOR_VOICE_NOT_FOUND',
  ModeratorVoiceNotReady: 'MODERATOR_VOICE_NOT_READY',
  ModeratorVoiceProcessing: 'MODERATOR_VOICE_PROCESSING',
  ModeratorVoiceSampleTooLarge: 'MODERATOR_VOICE_SAMPLE_TOO_LARGE',
  ModeratorVoiceSampleTooLong: 'MODERATOR_VOICE_SAMPLE_TOO_LONG',
  ModeratorVoiceSampleTooShort: 'MODERATOR_VOICE_SAMPLE_TOO_SHORT',
  ModeratorVoiceTextTooLong: 'MODERATOR_VOICE_TEXT_TOO_LONG',
  ModeratorVoiceTextTooShort: 'MODERATOR_VOICE_TEXT_TOO_SHORT',
  NotFound: 'NOT_FOUND',
  PaginationInvalidParams: 'PAGINATION_INVALID_PARAMS',
  ProjectsAiLearntTextTriggerFailed: 'PROJECTS_AI_LEARNT_TEXT_TRIGGER_FAILED',
  ProjectsAttachmentNotFoundOrInaccessible:
    'PROJECTS_ATTACHMENT_NOT_FOUND_OR_INACCESSIBLE',
  ProjectsCannotJumpForward: 'PROJECTS_CANNOT_JUMP_FORWARD',
  ProjectsContactNotFound: 'PROJECTS_CONTACT_NOT_FOUND',
  ProjectsDeleteRecruitingFulfilmentInFlight:
    'PROJECTS_DELETE_RECRUITING_FULFILMENT_IN_FLIGHT',
  ProjectsDeleteRecruitingPaymentInFlight:
    'PROJECTS_DELETE_RECRUITING_PAYMENT_IN_FLIGHT',
  ProjectsDocumentDuplicate: 'PROJECTS_DOCUMENT_DUPLICATE',
  ProjectsDocumentMimeTypeRequired: 'PROJECTS_DOCUMENT_MIME_TYPE_REQUIRED',
  ProjectsDocumentMissingGcsKey: 'PROJECTS_DOCUMENT_MISSING_GCS_KEY',
  ProjectsDocumentNotFound: 'PROJECTS_DOCUMENT_NOT_FOUND',
  ProjectsDocumentSourceInvalidCount: 'PROJECTS_DOCUMENT_SOURCE_INVALID_COUNT',
  ProjectsDocumentSourceMultipleProvided:
    'PROJECTS_DOCUMENT_SOURCE_MULTIPLE_PROVIDED',
  ProjectsDownloadLanguageNotSupported:
    'PROJECTS_DOWNLOAD_LANGUAGE_NOT_SUPPORTED',
  ProjectsDownloadNotFound: 'PROJECTS_DOWNLOAD_NOT_FOUND',
  ProjectsDuplicateFailed: 'PROJECTS_DUPLICATE_FAILED',
  ProjectsIntroNotFound: 'PROJECTS_INTRO_NOT_FOUND',
  ProjectsIntroOrgAssetNotInOrg: 'PROJECTS_INTRO_ORG_ASSET_NOT_IN_ORG',
  ProjectsIntroVideoAssetNotInProject:
    'PROJECTS_INTRO_VIDEO_ASSET_NOT_IN_PROJECT',
  ProjectsIntroVideoInvalidGcsKey: 'PROJECTS_INTRO_VIDEO_INVALID_GCS_KEY',
  ProjectsIntroVideoInvalidMimeType: 'PROJECTS_INTRO_VIDEO_INVALID_MIME_TYPE',
  ProjectsIntroVideoMissingGcsKey: 'PROJECTS_INTRO_VIDEO_MISSING_GCS_KEY',
  ProjectsIntroVideoNotFound: 'PROJECTS_INTRO_VIDEO_NOT_FOUND',
  ProjectsInvalidCursor: 'PROJECTS_INVALID_CURSOR',
  ProjectsNotFound: 'PROJECTS_NOT_FOUND',
  ProjectsPanelConfigNotFound: 'PROJECTS_PANEL_CONFIG_NOT_FOUND',
  ProjectsPanelConfigSaveFailed: 'PROJECTS_PANEL_CONFIG_SAVE_FAILED',
  ProjectsPanelCreateFailed: 'PROJECTS_PANEL_CREATE_FAILED',
  ProjectsPanelNotEnabled: 'PROJECTS_PANEL_NOT_ENABLED',
  ProjectsPanelPublishConfigSaveFailed:
    'PROJECTS_PANEL_PUBLISH_CONFIG_SAVE_FAILED',
  ProjectsPanelPublishFailed: 'PROJECTS_PANEL_PUBLISH_FAILED',
  ProjectsPollMissingContactTag: 'PROJECTS_POLL_MISSING_CONTACT_TAG',
  ProjectsPollNoQuestionsFound: 'PROJECTS_POLL_NO_QUESTIONS_FOUND',
  ProjectsPollTooManyQuestions: 'PROJECTS_POLL_TOO_MANY_QUESTIONS',
  ProjectsRecruitingActive: 'PROJECTS_RECRUITING_ACTIVE',
  ProjectsRedirectUrlQuestionNotFound:
    'PROJECTS_REDIRECT_URL_QUESTION_NOT_FOUND',
  ProjectsRepdataUnavailable: 'PROJECTS_REPDATA_UNAVAILABLE',
  ProjectsScreenerAlreadyExists: 'PROJECTS_SCREENER_ALREADY_EXISTS',
  ProjectsScreenerNotFound: 'PROJECTS_SCREENER_NOT_FOUND',
  ProjectsScreenerOptionsRequired: 'PROJECTS_SCREENER_OPTIONS_REQUIRED',
  ProjectsScreenerOrderInvalid: 'PROJECTS_SCREENER_ORDER_INVALID',
  ProjectsScreenerQuestionNotFound: 'PROJECTS_SCREENER_QUESTION_NOT_FOUND',
  ProjectsSignedUrlGenerationFailed: 'PROJECTS_SIGNED_URL_GENERATION_FAILED',
  ProjectsTemplateConversionHasResponses:
    'PROJECTS_TEMPLATE_CONVERSION_HAS_RESPONSES',
  ProjectsTemplateConversionUserEmailRequired:
    'PROJECTS_TEMPLATE_CONVERSION_USER_EMAIL_REQUIRED',
  ProjectsTemplateFeatureNotEnabled: 'PROJECTS_TEMPLATE_FEATURE_NOT_ENABLED',
  ProjectsTemplateNotFound: 'PROJECTS_TEMPLATE_NOT_FOUND',
  ProjectsTemplateUserEmailRequired: 'PROJECTS_TEMPLATE_USER_EMAIL_REQUIRED',
  ProjectsThemeDailyLimitReached: 'PROJECTS_THEME_DAILY_LIMIT_REACHED',
  ProjectsThemeNotFound: 'PROJECTS_THEME_NOT_FOUND',
  ProjectsThemeProcessingTriggerFailed:
    'PROJECTS_THEME_PROCESSING_TRIGGER_FAILED',
  ProjectsThemeSettingsSaveFailed: 'PROJECTS_THEME_SETTINGS_SAVE_FAILED',
  ProjectsTypeRequired: 'PROJECTS_TYPE_REQUIRED',
  ProjectsWidgetConfigSaveFailed: 'PROJECTS_WIDGET_CONFIG_SAVE_FAILED',
  ProjectsWidgetImageInvalidGcsKey: 'PROJECTS_WIDGET_IMAGE_INVALID_GCS_KEY',
  ProjectsWidgetImageInvalidMimeType: 'PROJECTS_WIDGET_IMAGE_INVALID_MIME_TYPE',
  ProjectsWidgetImageMissingGcsKey: 'PROJECTS_WIDGET_IMAGE_MISSING_GCS_KEY',
  ProjectsWidgetImageNotFound: 'PROJECTS_WIDGET_IMAGE_NOT_FOUND',
  ProjectSettingsAgeOutOfRange: 'PROJECT_SETTINGS_AGE_OUT_OF_RANGE',
  ProjectSettingsAgeRangeInverted: 'PROJECT_SETTINGS_AGE_RANGE_INVERTED',
  ProjectSettingsIntroVideoNotInProject:
    'PROJECT_SETTINGS_INTRO_VIDEO_NOT_IN_PROJECT',
  ProjectSettingsModeratorVoiceNotInOrg:
    'PROJECT_SETTINGS_MODERATOR_VOICE_NOT_IN_ORG',
  ProjectSettingsNotFound: 'PROJECT_SETTINGS_NOT_FOUND',
  ProjectSettingsPersonalityRangeInverted:
    'PROJECT_SETTINGS_PERSONALITY_RANGE_INVERTED',
  ProjectSettingsPersonalityValueOutOfRange:
    'PROJECT_SETTINGS_PERSONALITY_VALUE_OUT_OF_RANGE',
  ProjectSettingsProjectNotFound: 'PROJECT_SETTINGS_PROJECT_NOT_FOUND',
  QuestionsAiConvoDepthNegative: 'QUESTIONS_AI_CONVO_DEPTH_NEGATIVE',
  QuestionsAiConvoDepthTooLarge: 'QUESTIONS_AI_CONVO_DEPTH_TOO_LARGE',
  QuestionsAiOptionsAlreadyPresent: 'QUESTIONS_AI_OPTIONS_ALREADY_PRESENT',
  QuestionsAiOptionsUnsupportedType: 'QUESTIONS_AI_OPTIONS_UNSUPPORTED_TYPE',
  QuestionsGenerationFailed: 'QUESTIONS_GENERATION_FAILED',
  QuestionsGenerationForbidden: 'QUESTIONS_GENERATION_FORBIDDEN',
  QuestionsInvalidOptionRenderType: 'QUESTIONS_INVALID_OPTION_RENDER_TYPE',
  QuestionsInvalidSubQuestions: 'QUESTIONS_INVALID_SUB_QUESTIONS',
  QuestionsMatrixRequiresSubQuestion: 'QUESTIONS_MATRIX_REQUIRES_SUB_QUESTION',
  QuestionsMatrixUnsupportedType: 'QUESTIONS_MATRIX_UNSUPPORTED_TYPE',
  QuestionsMaxSelectionsOnlyForMultipleChoice:
    'QUESTIONS_MAX_SELECTIONS_ONLY_FOR_MULTIPLE_CHOICE',
  QuestionsMaxSelectionsOutOfRange: 'QUESTIONS_MAX_SELECTIONS_OUT_OF_RANGE',
  QuestionsMediaOptionsLimitExceeded: 'QUESTIONS_MEDIA_OPTIONS_LIMIT_EXCEEDED',
  QuestionsMinSelectionsExceedsMax: 'QUESTIONS_MIN_SELECTIONS_EXCEEDS_MAX',
  QuestionsMinSelectionsOnlyForMultipleChoice:
    'QUESTIONS_MIN_SELECTIONS_ONLY_FOR_MULTIPLE_CHOICE',
  QuestionsMinSelectionsOutOfRange: 'QUESTIONS_MIN_SELECTIONS_OUT_OF_RANGE',
  QuestionsMobileAppFileTooLarge: 'QUESTIONS_MOBILE_APP_FILE_TOO_LARGE',
  QuestionsMobileAppGcsReadFailed: 'QUESTIONS_MOBILE_APP_GCS_READ_FAILED',
  QuestionsMobileAppInvalidFileType: 'QUESTIONS_MOBILE_APP_INVALID_FILE_TYPE',
  QuestionsMobileAppInvalidFileTypeAab:
    'QUESTIONS_MOBILE_APP_INVALID_FILE_TYPE_AAB',
  QuestionsMobileAppInvalidFileTypeIpa:
    'QUESTIONS_MOBILE_APP_INVALID_FILE_TYPE_IPA',
  QuestionsMobileAppInvalidGcsKey: 'QUESTIONS_MOBILE_APP_INVALID_GCS_KEY',
  QuestionsNotApplicableOnlyForMatrix:
    'QUESTIONS_NOT_APPLICABLE_ONLY_FOR_MATRIX',
  QuestionsOpenEndedNoOptions: 'QUESTIONS_OPEN_ENDED_NO_OPTIONS',
  QuestionsOptionsRequired: 'QUESTIONS_OPTIONS_REQUIRED',
  QuestionsOrderInvalid: 'QUESTIONS_ORDER_INVALID',
  QuestionsOrganizationNotFound: 'QUESTIONS_ORGANIZATION_NOT_FOUND',
  QuestionsPollProjectContactTagRequired:
    'QUESTIONS_POLL_PROJECT_CONTACT_TAG_REQUIRED',
  QuestionsPollProjectNoRanking: 'QUESTIONS_POLL_PROJECT_NO_RANKING',
  QuestionsPollProjectQuestionLimit: 'QUESTIONS_POLL_PROJECT_QUESTION_LIMIT',
  QuestionsProjectNotFound: 'QUESTIONS_PROJECT_NOT_FOUND',
  QuestionsProjectOrgMismatch: 'QUESTIONS_PROJECT_ORG_MISMATCH',
  QuestionsProjectWithInsightsCreateBlocked:
    'QUESTIONS_PROJECT_WITH_INSIGHTS_CREATE_BLOCKED',
  QuestionsProjectWithInsightsDeleteBlocked:
    'QUESTIONS_PROJECT_WITH_INSIGHTS_DELETE_BLOCKED',
  QuestionsProjectWithInsightsOptionDeleteBlocked:
    'QUESTIONS_PROJECT_WITH_INSIGHTS_OPTION_DELETE_BLOCKED',
  QuestionsProjectWithInsightsSubtypeChangeBlocked:
    'QUESTIONS_PROJECT_WITH_INSIGHTS_SUBTYPE_CHANGE_BLOCKED',
  QuestionsProjectWithInsightsTaskFollowupChangeBlocked:
    'QUESTIONS_PROJECT_WITH_INSIGHTS_TASK_FOLLOWUP_CHANGE_BLOCKED',
  QuestionsProjectWithInsightsTypeChangeBlocked:
    'QUESTIONS_PROJECT_WITH_INSIGHTS_TYPE_CHANGE_BLOCKED',
  QuestionsQuestionMissingAfterUpdate:
    'QUESTIONS_QUESTION_MISSING_AFTER_UPDATE',
  QuestionsQuestionNotFound: 'QUESTIONS_QUESTION_NOT_FOUND',
  QuestionsRatingOptionsInvalidNumbers:
    'QUESTIONS_RATING_OPTIONS_INVALID_NUMBERS',
  QuestionsRatingOptionsInvalidScale: 'QUESTIONS_RATING_OPTIONS_INVALID_SCALE',
  QuestionsRatingOptionsRequired: 'QUESTIONS_RATING_OPTIONS_REQUIRED',
  QuestionsTaskFollowupOnlyForTask: 'QUESTIONS_TASK_FOLLOWUP_ONLY_FOR_TASK',
  QuestionAssetsNotFound: 'QUESTION_ASSETS_NOT_FOUND',
  QuestionAssetsQuestionNotFound: 'QUESTION_ASSETS_QUESTION_NOT_FOUND',
  QuestionOptionAssetsNotFound: 'QUESTION_OPTION_ASSETS_NOT_FOUND',
  QuestionOptionAssetsOptionNotFound: 'QUESTION_OPTION_ASSETS_OPTION_NOT_FOUND',
  RecruitingAudiencesAudienceNotFound:
    'RECRUITING_AUDIENCES_AUDIENCE_NOT_FOUND',
  RecruitingAudiencesDescriptionNothingToDescribe:
    'RECRUITING_AUDIENCES_DESCRIPTION_NOTHING_TO_DESCRIBE',
  RecruitingAudiencesDescriptionTooLong:
    'RECRUITING_AUDIENCES_DESCRIPTION_TOO_LONG',
  RecruitingAudiencesDescriptionUnavailable:
    'RECRUITING_AUDIENCES_DESCRIPTION_UNAVAILABLE',
  RecruitingAudiencesHumanIncentiveNotWholeDollars:
    'RECRUITING_AUDIENCES_HUMAN_INCENTIVE_NOT_WHOLE_DOLLARS',
  RecruitingAudiencesHumanIncentiveOutOfRange:
    'RECRUITING_AUDIENCES_HUMAN_INCENTIVE_OUT_OF_RANGE',
  RecruitingAudiencesInvalidQualifications:
    'RECRUITING_AUDIENCES_INVALID_QUALIFICATIONS',
  RecruitingAudiencesInvalidRange: 'RECRUITING_AUDIENCES_INVALID_RANGE',
  RecruitingAudiencesNameRequired: 'RECRUITING_AUDIENCES_NAME_REQUIRED',
  RecruitingAudiencesProfileRequired: 'RECRUITING_AUDIENCES_PROFILE_REQUIRED',
  RecruitingOrdersAmountInvariantViolated:
    'RECRUITING_ORDERS_AMOUNT_INVARIANT_VIOLATED',
  RecruitingOrdersAudienceNameTooLong:
    'RECRUITING_ORDERS_AUDIENCE_NAME_TOO_LONG',
  RecruitingOrdersCheckoutExpired: 'RECRUITING_ORDERS_CHECKOUT_EXPIRED',
  RecruitingOrdersCheckoutInProgress: 'RECRUITING_ORDERS_CHECKOUT_IN_PROGRESS',
  RecruitingOrdersCheckoutStateUnconfirmed:
    'RECRUITING_ORDERS_CHECKOUT_STATE_UNCONFIRMED',
  RecruitingOrdersCheckoutSupersededCompleted:
    'RECRUITING_ORDERS_CHECKOUT_SUPERSEDED_COMPLETED',
  RecruitingOrdersClientRequestIdInvalid:
    'RECRUITING_ORDERS_CLIENT_REQUEST_ID_INVALID',
  RecruitingOrdersClientRequestIdReused:
    'RECRUITING_ORDERS_CLIENT_REQUEST_ID_REUSED',
  RecruitingOrdersCohortJobCancelFailed:
    'RECRUITING_ORDERS_COHORT_JOB_CANCEL_FAILED',
  RecruitingOrdersCohortMissingRepdataIds:
    'RECRUITING_ORDERS_COHORT_MISSING_REPDATA_IDS',
  RecruitingOrdersCohortNotCancellable:
    'RECRUITING_ORDERS_COHORT_NOT_CANCELLABLE',
  RecruitingOrdersCohortPauseFailed: 'RECRUITING_ORDERS_COHORT_PAUSE_FAILED',
  RecruitingOrdersCohortReconcilePending:
    'RECRUITING_ORDERS_COHORT_RECONCILE_PENDING',
  RecruitingOrdersCohortStopFailed: 'RECRUITING_ORDERS_COHORT_STOP_FAILED',
  RecruitingOrdersCurrencyInvalid: 'RECRUITING_ORDERS_CURRENCY_INVALID',
  RecruitingOrdersIncentiveAboveMaximum:
    'RECRUITING_ORDERS_INCENTIVE_ABOVE_MAXIMUM',
  RecruitingOrdersIncentiveBelowFloor:
    'RECRUITING_ORDERS_INCENTIVE_BELOW_FLOOR',
  RecruitingOrdersIncentiveNotWholeDollars:
    'RECRUITING_ORDERS_INCENTIVE_NOT_WHOLE_DOLLARS',
  RecruitingOrdersInvalidIncentiveAmount:
    'RECRUITING_ORDERS_INVALID_INCENTIVE_AMOUNT',
  RecruitingOrdersInvalidQualifications:
    'RECRUITING_ORDERS_INVALID_QUALIFICATIONS',
  RecruitingOrdersInvalidQuantity: 'RECRUITING_ORDERS_INVALID_QUANTITY',
  RecruitingOrdersLineItemsRequired: 'RECRUITING_ORDERS_LINE_ITEMS_REQUIRED',
  RecruitingOrdersLineItemNotFound: 'RECRUITING_ORDERS_LINE_ITEM_NOT_FOUND',
  RecruitingOrdersOrderNotFound: 'RECRUITING_ORDERS_ORDER_NOT_FOUND',
  RecruitingOrdersOrderNotPlaced: 'RECRUITING_ORDERS_ORDER_NOT_PLACED',
  RecruitingOrdersPaymentInProgress: 'RECRUITING_ORDERS_PAYMENT_IN_PROGRESS',
  RecruitingOrdersProfileMismatch: 'RECRUITING_ORDERS_PROFILE_MISMATCH',
  RecruitingOrdersProjectNotFound: 'RECRUITING_ORDERS_PROJECT_NOT_FOUND',
  RecruitingOrdersProjectNotPublished:
    'RECRUITING_ORDERS_PROJECT_NOT_PUBLISHED',
  RecruitingOrdersQualificationsRequired:
    'RECRUITING_ORDERS_QUALIFICATIONS_REQUIRED',
  RecruitingOrdersRepdataReconcileRequired:
    'RECRUITING_ORDERS_REPDATA_RECONCILE_REQUIRED',
  RecruitingOrdersSourceAudienceNotFound:
    'RECRUITING_ORDERS_SOURCE_AUDIENCE_NOT_FOUND',
  RecruitingOrdersTooManyLineItems: 'RECRUITING_ORDERS_TOO_MANY_LINE_ITEMS',
  RecruitingOrdersTotalAmountTooLarge:
    'RECRUITING_ORDERS_TOTAL_AMOUNT_TOO_LARGE',
  RecruitingPricingInvalidQualifications:
    'RECRUITING_PRICING_INVALID_QUALIFICATIONS',
  RecruitingPricingProjectNotFound: 'RECRUITING_PRICING_PROJECT_NOT_FOUND',
  SettingsAlreadyExist: 'SETTINGS_ALREADY_EXIST',
  SettingsDefaultIntroVideoInvalid: 'SETTINGS_DEFAULT_INTRO_VIDEO_INVALID',
  SettingsDefaultModeratorVoiceInvalid:
    'SETTINGS_DEFAULT_MODERATOR_VOICE_INVALID',
  SettingsNotFound: 'SETTINGS_NOT_FOUND',
  SettingsSelectedBackgroundInvalid: 'SETTINGS_SELECTED_BACKGROUND_INVALID',
  SettingsUnknownError: 'SETTINGS_UNKNOWN_ERROR',
  SharedBrowserPoolCreateSessionFailed:
    'SHARED_BROWSER_POOL_CREATE_SESSION_FAILED',
  SharedBrowserPoolInvalidStartUrl: 'SHARED_BROWSER_POOL_INVALID_START_URL',
  SharedBrowserPoolSessionIdRequired: 'SHARED_BROWSER_POOL_SESSION_ID_REQUIRED',
  SharedBrowserPoolTerminateSessionFailed:
    'SHARED_BROWSER_POOL_TERMINATE_SESSION_FAILED',
  SharedFileUploadMimeTypeNotAllowed:
    'SHARED_FILE_UPLOAD_MIME_TYPE_NOT_ALLOWED',
  SharedModeratorVoiceSynthesisFailed:
    'SHARED_MODERATOR_VOICE_SYNTHESIS_FAILED',
  SharedModeratorVoiceTextTooLong: 'SHARED_MODERATOR_VOICE_TEXT_TOO_LONG',
  SharedModeratorVoiceTextTooShort: 'SHARED_MODERATOR_VOICE_TEXT_TOO_SHORT',
  SharedRateLimitExceeded: 'SHARED_RATE_LIMIT_EXCEEDED',
  SkillsProjectNotFound: 'SKILLS_PROJECT_NOT_FOUND',
  SkillsResultNotFound: 'SKILLS_RESULT_NOT_FOUND',
  SkillsSkillNotEditable: 'SKILLS_SKILL_NOT_EDITABLE',
  SkillsSkillNotFound: 'SKILLS_SKILL_NOT_FOUND',
  SkillsSkillRefInvalid: 'SKILLS_SKILL_REF_INVALID',
  TagsAlreadyExists: 'TAGS_ALREADY_EXISTS',
  TagsNotFound: 'TAGS_NOT_FOUND',
  TempOrgDeleted: 'TEMP_ORG_DELETED',
  TempOrgExpired: 'TEMP_ORG_EXPIRED',
  TempOrgInvalid: 'TEMP_ORG_INVALID',
  TempOrgNotFound: 'TEMP_ORG_NOT_FOUND',
  Timeout: 'TIMEOUT',
  Unauthorized: 'UNAUTHORIZED',
  ValidationFailed: 'VALIDATION_FAILED',
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];
export type EstimateRecruitingIncentiveInput = {
  /** Country code (≤ 8 characters); defaults to US. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Project being recruited for: its type picks the rate-card column (Survey/Poll → surveys, else tests) and its estimated completion time sets the study-length adjustment. Omitted or null: priced from the tests column at base length (no study-length adjustment). */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** The human audience as qualification labels (≤ 30, each with 1–50 options, labels 1–200 characters); an empty list prices a general consumer audience. */
  qualifications: Array<RecruitingQualificationLabelInput>;
};

export type ExtractedSubQuestionAnswer = {
  __typename?: 'ExtractedSubQuestionAnswer';
  subQuestionId: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type FormMessagePreviewResponse = {
  __typename?: 'FormMessagePreviewResponse';
  /** The user message preview */
  message: MessageV2;
  /** Progress of the survey based on completed questions (0-1) */
  surveyProgress?: Maybe<Scalars['Float']['output']>;
};

export type FormMessagesPreviewResponse = {
  __typename?: 'FormMessagesPreviewResponse';
  /** The user message previews for the given questions */
  messages: Array<MessageV2>;
  /** Progress of the survey based on completed questions (0-1) */
  surveyProgress?: Maybe<Scalars['Float']['output']>;
};

export type FormQuestionAnswerPreviewInput = {
  assets?: InputMaybe<Array<MessageAssetInput>>;
  /** Answer payload. OpenEnded: free text. Rating: the option value. MultipleChoice/Ranking: comma-joined option values. Matrix: send subQuestionAnswers instead; this field is ignored for matrix questions. */
  content: Scalars['String']['input'];
  questionId: Scalars['UUID']['input'];
  /** Required for matrix questions. Per-row answers; BE serialises to the canonical wire format and overwrites content. */
  subQuestionAnswers?: InputMaybe<Array<SubQuestionAnswerPreviewInput>>;
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type FormatTranscriptInput = {
  /** The not-applicable label for matrix questions (e.g. "N/A", "Don't know") */
  notApplicableLabel?: InputMaybe<Scalars['String']['input']>;
  /** Available options for the question */
  options?: InputMaybe<Array<VoiceTranscriptOptionInput>>;
  /** The type of question being answered */
  questionType: QuestionType;
  /** Sub-questions for a matrix question. When provided, the transcript is parsed as one-shot matrix answers and returned in extractedSubQuestionAnswers. */
  subQuestions?: InputMaybe<Array<VoiceTranscriptSubQuestionInput>>;
  /** The voice transcript to format */
  transcript: Scalars['String']['input'];
};

export type FormatTranscriptResponse = {
  __typename?: 'FormatTranscriptResponse';
  /** The extracted options from the transcript */
  extractedOptions?: Maybe<Array<Scalars['String']['output']>>;
  /** Per-sub-question answers extracted from a matrix transcript. Populated only when subQuestions was provided in the input. */
  extractedSubQuestionAnswers?: Maybe<Array<ExtractedSubQuestionAnswer>>;
  /** The formatted transcript result */
  formattedTranscript: Scalars['String']['output'];
};

export type GenerateFollowUpQuestionInput = {
  questionId: Scalars['ID']['input'];
  userAnswer: Scalars['String']['input'];
};

export type GenerateFollowUpQuestionResponse = {
  __typename?: 'GenerateFollowUpQuestionResponse';
  followUpQuestion: Scalars['String']['output'];
};

export type GenerateFollowUpQuestionStatelessInput = {
  /** Optional target language for the generated follow-up question */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Optional project ID for context */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Question option labels (e.g. for multiple choice or ranking) */
  questionOptionsLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The question text */
  questionText: Scalars['String']['input'];
  /** The question type */
  questionType: QuestionType;
  /** The user answer to generate a follow-up from */
  userAnswer: Scalars['String']['input'];
};

export type GenerateLearningGoalInput = {
  projectId: Scalars['ID']['input'];
};

export type GenerateModeratorSpeechV2Input = {
  projectId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type GenerateModeratorVoiceAudioInput = {
  mood?: InputMaybe<VoiceMood>;
  text: Scalars['String']['input'];
  voiceAssetId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateModeratorVoiceTestPhraseInput = {
  language?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateOpenEndedQuestionResponse = {
  __typename?: 'GenerateOpenEndedQuestionResponse';
  responses: Array<Scalars['String']['output']>;
};

export type GenerateOptionsInput = {
  questionId: Scalars['ID']['input'];
};

export type GenerateProjectHighlightVideoInput = {
  /** Project highlight video id (project_assets row with assetType=highlight) — queues clip or reel generation based on videoType */
  projectHighlightVideoId: Scalars['UUID']['input'];
};

export type GenerateProjectInput = {
  /** Suggestion for generating AI project */
  suggestion: Scalars['String']['input'];
};

export type GenerateProjectNameInput = {
  /** Type of project (survey, usability test, etc). */
  projectType: ProjectType;
  /** Draft questions used as context for the generated project name. */
  questions: Array<GeneratedQuestionInput>;
};

export type GenerateProjectObjectivesInput = {
  /** Optional URL of a file already uploaded to the public GCS bucket (e.g. via signedUrl). Supported MIME types: application/pdf, text/plain, text/markdown, text/rtf, text/csv, application/msword (.doc), application/vnd.openxmlformats-officedocument.wordprocessingml.document (.docx). PDF/text/csv files are sent to Gemini directly; Word documents have their text extracted and inlined as additional context for the generation. */
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optional target language for the generated objectives (e.g. "French", "Spanish", "Japanese"). When provided, the objectives are written in this language; when omitted, they follow the language of the prompt. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** User prompt describing the project; objectives will be generated from it. */
  suggestion: Scalars['String']['input'];
};

export type GenerateProjectPromptSuggestionInput = {
  /** Optional target language for the suggested prompt (e.g. "French", "Spanish", "Japanese"). When provided, the suggestion is written in this language; when omitted, it follows the language of the available context. */
  language?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateQuestionV3Input = {
  /** Optional existing question text to ground the generation (e.g. its language). */
  currentQuestion?: InputMaybe<Scalars['String']['input']>;
  isForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set true to force a matrix (rating) question. The generator otherwise only infers matrix intent from the learning goal wording, so a neutral goal returns a plain rating. */
  isMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  isPoll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional target language for the generated question (e.g. "French"). When set the question is written in this language; when omitted it follows the language of the learning goal. */
  language?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectType?: InputMaybe<ProjectType>;
  /** Preferred question type; the model may override it if the learning goal conflicts. */
  questionType?: InputMaybe<QuestionType>;
  /** Learning goal / guidance the question should answer. */
  suggestion?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateQuestionsInput = {
  isForm?: InputMaybe<Scalars['Boolean']['input']>;
  isPoll?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectType?: InputMaybe<ProjectType>;
  /** Suggestion for generating AI questions */
  suggestion: Scalars['String']['input'];
};

export type GenerateRatingLabelsInput = {
  /** Existing high label to improve upon */
  highLabel?: InputMaybe<Scalars['String']['input']>;
  /** Existing low label to improve upon */
  lowLabel?: InputMaybe<Scalars['String']['input']>;
  /** Project ID for context */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** The question text for which to generate rating labels */
  questionText: Scalars['String']['input'];
};

export type GeneratedOptions = {
  __typename?: 'GeneratedOptions';
  options: Array<Scalars['String']['output']>;
};

export type GeneratedProject = {
  __typename?: 'GeneratedProject';
  draftResult: Array<GeneratedQuestion>;
  projectType: ProjectType;
};

export type GeneratedQuestion = {
  __typename?: 'GeneratedQuestion';
  /** Browser-redirect target for a url question (a message with a URL). */
  contentUrl?: Maybe<Scalars['String']['output']>;
  hasGeneratedQuestionSuccessful?: Maybe<Scalars['String']['output']>;
  isMatrix?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use options array to determine max rating label instead */
  maxRatingLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use options array to determine min rating label instead */
  minRatingLabel?: Maybe<Scalars['String']['output']>;
  notApplicableLabel?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<GeneratedQuestionOption>>;
  subQuestions?: Maybe<Array<Scalars['String']['output']>>;
  tag?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: QuestionType;
};

export type GeneratedQuestionInput = {
  options?: InputMaybe<Array<GeneratedQuestionOptionInput>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  type: QuestionType;
};

export type GeneratedQuestionOption = {
  __typename?: 'GeneratedQuestionOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GeneratedQuestionOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type GeneratedRatingLabels = {
  __typename?: 'GeneratedRatingLabels';
  /** The generated high rating label */
  highLabel: Scalars['String']['output'];
  /** The generated low rating label */
  lowLabel: Scalars['String']['output'];
};

export type GetSignedUrlInput = {
  /** The file path in the bucket (e.g., org-assets/org-id/filename) */
  filePath: Scalars['String']['input'];
};

export type HyperbeamSession = {
  __typename?: 'HyperbeamSession';
  /** The admin token for advanced control (optional) */
  adminToken?: Maybe<Scalars['String']['output']>;
  /** The embed URL for the frontend SDK */
  embedUrl: Scalars['String']['output'];
  /** The Hyperbeam session ID */
  sessionId: Scalars['String']['output'];
};

export const ImportSurveyMethod = {
  File: 'FILE',
  Text: 'TEXT',
  Url: 'URL',
} as const;

export type ImportSurveyMethod =
  (typeof ImportSurveyMethod)[keyof typeof ImportSurveyMethod];
export type ImproveQuestionInput = {
  /** The existing question text to improve. */
  currentQuestion: Scalars['String']['input'];
  isForm?: InputMaybe<Scalars['Boolean']['input']>;
  isMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  isPoll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional target language for the improved question (e.g. "French"). When set the question is improved in this language; when omitted it follows the language of the existing question. */
  language?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectType?: InputMaybe<ProjectType>;
  /** The existing question type; the improved question keeps this type. */
  questionType?: InputMaybe<QuestionType>;
};

export type InitiateSurveyInput = {
  channel?: InputMaybe<Channel>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['UUID']['input'];
  sessionKey?: InputMaybe<Scalars['String']['input']>;
};

export type InitiateSurveyResponseV3 = {
  __typename?: 'InitiateSurveyResponseV3';
  firstQuestion: QuestionV2WithTextForVoice;
  sessionId: Scalars['String']['output'];
};

export type InsightActivityFilterInput = {
  /** Only include projects with at most this many insights in the window. */
  maxCount?: InputMaybe<Scalars['Int']['input']>;
  /** Only include projects with at least this many insights in the window. Defaults to 1 when neither minCount nor maxCount is set. */
  minCount?: InputMaybe<Scalars['Int']['input']>;
  /** Only count insights created at or after this UTC instant. Callers own day/timezone boundaries. */
  since?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only count insights created at or before this UTC instant. */
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InsightOrder = {
  direction: OrderDirection;
  field: InsightOrderField;
};

/** Fields to order insights by */
export const InsightOrderField = {
  ContactName: 'CONTACT_NAME',
  CreatedAt: 'CREATED_AT',
  LastResponseDate: 'LAST_RESPONSE_DATE',
} as const;

export type InsightOrderField =
  (typeof InsightOrderField)[keyof typeof InsightOrderField];
/** Evaluated quality bucket for an insight response (low/medium/high). Low quality insights are archived and excluded from analytics. */
export const InsightQuality = {
  High: 'High',
  Low: 'Low',
  Medium: 'Medium',
} as const;

export type InsightQuality =
  (typeof InsightQuality)[keyof typeof InsightQuality];
export type InsightQuestionFilter = {
  questionId: Scalars['UUID']['input'];
  selectedOptions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InsightQuestionPhraseFilterInput = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  questionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type InsightQuestionPhraseModel = {
  __typename?: 'InsightQuestionPhraseModel';
  createdAt: Scalars['DateTime']['output'];
  /** ID of the insight_question_phrases row */
  id: Scalars['UUID']['output'];
  /** The extracted phrase (canonical text) */
  phrase: Scalars['String']['output'];
  /** Canonical question_phrases row id this occurrence links to */
  phraseId: Scalars['UUID']['output'];
  /** Question this phrase was extracted under */
  questionId: Scalars['UUID']['output'];
  /** Exact sentence from the user message that triggered the extraction, with the matched keyword wrapped in Markdown bold (**...**). NULL for rows extracted before this field existed. */
  supportingQuote?: Maybe<Scalars['String']['output']>;
};

export type InsightRecordingBreakpointModel = {
  __typename?: 'InsightRecordingBreakpointModel';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  label: Scalars['String']['output'];
  question?: Maybe<InsightRecordingQuestionModel>;
  questionId: Scalars['UUID']['output'];
  time: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InsightRecordingEventModel = {
  __typename?: 'InsightRecordingEventModel';
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Carried over from legacy breakpoints. Will be removed after FE migration. */
  description?: Maybe<Scalars['String']['output']>;
  /** Child events within this breakpoint (events whose time falls between this PrimaryQuestion and the next). Empty for non-PrimaryQuestion events. */
  events?: Maybe<Array<InsightRecordingEventModel>>;
  id: Scalars['UUID']['output'];
  /** @deprecated Carried over from legacy breakpoints. Will be removed after FE migration. */
  label?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['UUID']['output'];
  /** Resolved question for this event, derived from the linked message metadata. */
  question?: Maybe<InsightRecordingQuestionModel>;
  time: Scalars['Float']['output'];
  type: InsightRecordingEventType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of event on an insight recording timeline */
export const InsightRecordingEventType = {
  AiFollowUp: 'AIFollowUp',
  PrimaryQuestion: 'PrimaryQuestion',
  UserTypedResponse: 'UserTypedResponse',
  UserVoiceResponse: 'UserVoiceResponse',
} as const;

export type InsightRecordingEventType =
  (typeof InsightRecordingEventType)[keyof typeof InsightRecordingEventType];
export type InsightRecordingModel = {
  __typename?: 'InsightRecordingModel';
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  gcsKey: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** GCS key for the recording thumbnail image */
  thumbnailGcsKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InsightRecordingQuestionModel = {
  __typename?: 'InsightRecordingQuestionModel';
  id: Scalars['UUID']['output'];
  text: Scalars['String']['output'];
  type: QuestionType;
};

export type InsightSummaryModel = {
  __typename?: 'InsightSummaryModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InsightTagModel = {
  __typename?: 'InsightTagModel';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InsightV2 = {
  __typename?: 'InsightV2';
  /** Question reports (answered questions) for this insight */
  answeredQuestions?: Maybe<Array<AnsweredQuestionModel>>;
  /** Signed URL for the AI tester's avatar (AIT insights only; null for human responders / older insights). Safe to use directly in an <img>. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer populated */
  chatSize?: Maybe<ChatSize>;
  contact?: Maybe<Contact>;
  convoDepth?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** First message from the assistant */
  firstAssistantMessage?: Maybe<MessageV2>;
  /** First message from the user */
  firstUserResponse?: Maybe<MessageV2>;
  hasMessages?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  /** Important phrases extracted for this insight, optionally filtered by questionId or keyword. */
  insightQuestionPhrases?: Maybe<Array<InsightQuestionPhraseModel>>;
  insightRead?: Maybe<Scalars['Boolean']['output']>;
  lastUserResponse?: Maybe<MessageV2>;
  lastUserResponseDate?: Maybe<Scalars['DateTime']['output']>;
  msgRead?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  project?: Maybe<ProjectModel>;
  /** AI-evaluated response quality bucket (low/medium/high) */
  quality?: Maybe<InsightQuality>;
  recording?: Maybe<InsightRecordingModel>;
  /**
   * Video breakpoints for this insight recording
   * @deprecated Use recordingEvents instead. Will be removed after FE migration.
   */
  recordingBreakpoints?: Maybe<Array<InsightRecordingBreakpointModel>>;
  /** Transcript and breakpoint events for this insight recording */
  recordingEvents?: Maybe<Array<InsightRecordingEventModel>>;
  /** Synthetic for AI testers, Human otherwise */
  responderType: ResponderType;
  /** Channel the response is shown under: TheySaid panel and AI tester responses are Recruit */
  responseChannel: ResponseChannel;
  shareId?: Maybe<Scalars['UUID']['output']>;
  signal?: Maybe<Signal>;
  summaries?: Maybe<Array<InsightSummaryModel>>;
  /** @deprecated Use summaries field instead */
  summary?: Maybe<Scalars['String']['output']>;
  summaryTitle?: Maybe<Scalars['String']['output']>;
  /** Tags associated with this insight */
  tags?: Maybe<Array<InsightTagModel>>;
  /** summaryTitle translated into the project language (non-English projects only) */
  translatedSummaryTitle?: Maybe<Scalars['String']['output']>;
  /** Snapshot of the AI persona that generated this insight (ux-agent-panel channel only; null for human respondents) */
  uxAgentPersona?: Maybe<UxAgentPersonaModel>;
};

export type InsightV2InsightQuestionPhrasesArgs = {
  filter?: InputMaybe<InsightQuestionPhraseFilterInput>;
};

export type InsightV2RecordingEventsArgs = {
  types?: InputMaybe<Array<InsightRecordingEventType>>;
};

export type InsightV2ListFilterInput = {
  /** Filter by the channel a response is shown under (IS / IS_NOT). Recruit covers both panels. */
  channelsV2?: InputMaybe<ResponseChannelFilterInput>;
  /** @deprecated No longer applied */
  chatSizes?: InputMaybe<Array<ChatSize>>;
  /** Filter by insight createdAt. IS matches the whole UTC day of each value; AFTER and BEFORE compare against the exact instant. */
  dateV2?: InputMaybe<DateFilterInput>;
  /** Filter by contact email. IS / IS_NOT compare with exact equality (case-insensitive); CONTAINS does a substring match. */
  emailV2?: InputMaybe<StringFilterInput>;
  maxProgress?: InputMaybe<Scalars['Float']['input']>;
  minProgress?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by contact name (firstName/lastName/nickname). IS / IS_NOT compare against the joined full name. CONTAINS matches as a substring against each of nickname, "firstName lastName", and "lastName firstName". */
  nameV2?: InputMaybe<StringFilterInput>;
  projectId: Scalars['UUID']['input'];
  /** Filter insights by quality bucket. Omit (or pass null/empty) to include every quality, archived rows included. Provide values to narrow the result; archived rows remain reachable so Low can be selected. */
  qualities?: InputMaybe<Array<InsightQuality>>;
  /** Filter insights by questions and their responses */
  questionFilters?: InputMaybe<Array<InsightQuestionFilter>>;
  /** Filter by primary-question answers from insight_question_reports (isFollowup = false). Each entry has its own matchingType (IS / IS_NOT) and a `value` tuple [questionId, answeredValue]; an empty answeredValue matches any answer. Entries are AND-combined. */
  questionsV2?: InputMaybe<Array<QuestionAnsweredFilter>>;
  /** Filter by Human / Synthetic responder (IS / IS_NOT). */
  responderTypesV2?: InputMaybe<ResponderTypeFilterInput>;
  /** Search in email, name and summary. Minimum 2 characters required. */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  signals?: InputMaybe<Array<InputMaybe<Signal>>>;
  /** Filter by signal values (IS / IS_NOT). Preferred over `signals`. */
  signalsV2?: InputMaybe<SignalFilterInput>;
  /** Filter insights created after this date */
  since?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter insights created before this date */
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntRange = {
  __typename?: 'IntRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type IntRangeInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type IntegrationProviderModel = {
  __typename?: 'IntegrationProviderModel';
  defaultSlackNotificationChannel?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  isConnected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Fetches project-specific integration settings for a provider. Returns null if projectId is not provided. */
  projectSettings?: Maybe<ProjectIntegrationSettingModel>;
  providerData?: Maybe<ProviderData>;
  providerKey: Scalars['String']['output'];
  pushInsights?: Maybe<Scalars['Boolean']['output']>;
  status: OrgNangoConnectionStatus;
};

export type IntegrationProviderModelProjectSettingsArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationProvidersFilter = {
  integrationOrder?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** How a responder interacts with the survey. voice or text */
export const InteractionType = {
  Text: 'Text',
  Voice: 'Voice',
} as const;

export type InteractionType =
  (typeof InteractionType)[keyof typeof InteractionType];
/** Where a project intro sources its video: org or project */
export const IntroSource = {
  Org: 'Org',
  Project: 'Project',
} as const;

export type IntroSource = (typeof IntroSource)[keyof typeof IntroSource];
/** Where a project sources its intro video from: its own project-level default or the org-level default */
export const IntroVideoLevel = {
  OrgLevel: 'OrgLevel',
  ProjectLevel: 'ProjectLevel',
} as const;

export type IntroVideoLevel =
  (typeof IntroVideoLevel)[keyof typeof IntroVideoLevel];
export type Invitation = {
  __typename?: 'Invitation';
  /** The email address of the recipient. */
  email: Scalars['EmailAddress']['output'];
  /** The unique ID of the invitation. */
  id: Scalars['ID']['output'];
};

export type InviteInput = {
  /** The email address of the recipient. */
  email: Scalars['EmailAddress']['input'];
  /** The role to assign to the invited user. */
  role?: Role;
};

/** Project type for filtering the projects list. Derived from the type/is_poll/is_form column combination. */
export const ListProjectsType = {
  Interview: 'Interview',
  Poll: 'Poll',
  Survey: 'Survey',
  UsabilityTesting: 'UsabilityTesting',
} as const;

export type ListProjectsType =
  (typeof ListProjectsType)[keyof typeof ListProjectsType];
export type MarketingFeature = {
  __typename?: 'MarketingFeature';
  name: Scalars['String']['output'];
};

/** How filter values match against a field. Concrete inputs may restrict which subset is accepted (see each filter input description). */
export const MatchingType = {
  After: 'AFTER',
  Before: 'BEFORE',
  Contains: 'CONTAINS',
  Is: 'IS',
  IsNot: 'IS_NOT',
} as const;

export type MatchingType = (typeof MatchingType)[keyof typeof MatchingType];
export type MessageAssetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gcsKey?: InputMaybe<Scalars['String']['input']>;
  mimetype: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use gcsKey instead for private bucket storage */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MessageAssetModel = {
  __typename?: 'MessageAssetModel';
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimetype: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type MessageListByQuestionFilterInputV2 = {
  insightId: Scalars['UUID']['input'];
  questionId: Scalars['UUID']['input'];
  shareId?: InputMaybe<Scalars['UUID']['input']>;
};

export type MessageListFilterInputV2 = {
  insightId: Scalars['UUID']['input'];
};

export type MessageMetadataV2 = {
  __typename?: 'MessageMetadataV2';
  assistantQuestion?: Maybe<Scalars['Boolean']['output']>;
  isConversationOver?: Maybe<Scalars['Boolean']['output']>;
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `maxSelections` instead. */
  multipleSelect?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<MessageQuestionOptionV2>>;
  questionId?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: QuestionType;
};

export type MessagePreviewPairV2 = {
  __typename?: 'MessagePreviewPairV2';
  reply: MessageV2;
  replyFeedback?: Maybe<MessageV2>;
  sent: MessageV2;
  sessionId: Scalars['String']['output'];
  surveyProgress?: Maybe<Scalars['Float']['output']>;
};

export type MessageQuestionOptionV2 = {
  __typename?: 'MessageQuestionOptionV2';
  assets?: Maybe<Array<QuestionOptionAssetModel>>;
  label: Scalars['String']['output'];
  /** English translation of the option label */
  translatedLabel?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** The sender of the message */
export const MessageSender = {
  Assistant: 'assistant',
  System: 'system',
  User: 'user',
} as const;

export type MessageSender = (typeof MessageSender)[keyof typeof MessageSender];
export type MessageV2 = {
  __typename?: 'MessageV2';
  assets?: Maybe<Array<QuestionAssetModel>>;
  /**
   * The message content (deprecated - use text instead)
   * @deprecated Use text field instead
   */
  content?: Maybe<Scalars['String']['output']>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** The message creation date */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  messageAssets?: Maybe<Array<MessageAssetModel>>;
  metadata?: Maybe<MessageMetadataV2>;
  /** Appetize.io embed URL for Mobile App question messages. Loaded by the survey FE to render the iframe. */
  mobileAppEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** Original filename of the uploaded mobile app. Display only. */
  mobileAppFileName?: Maybe<Scalars['String']['output']>;
  /** The type of option render */
  optionRenderType?: Maybe<OptionRenderType>;
  /** The sender of the message */
  sender: MessageSender;
  subQuestions?: Maybe<Array<SubQuestionModel>>;
  /** The message content */
  text: Scalars['String']['output'];
  /** Unformatted answer (transcript for voice messages) */
  transcript?: Maybe<Scalars['String']['output']>;
  /** English translation of the message, when the project language is not English */
  translatedText?: Maybe<Scalars['String']['output']>;
};

export type ModeratorVoiceAsset = {
  __typename?: 'ModeratorVoiceAsset';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isBuiltin: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  mood: VoiceMood;
  name?: Maybe<Scalars['String']['output']>;
  provider: ModeratorVoiceProvider;
  status: AssetStatus;
};

export type ModeratorVoicePreviewHandle = {
  __typename?: 'ModeratorVoicePreviewHandle';
  previewId: Scalars['ID']['output'];
  status: AssetStatus;
};

export type ModeratorVoicePreviewResult = {
  __typename?: 'ModeratorVoicePreviewResult';
  audioData?: Maybe<Scalars['String']['output']>;
  previewId: Scalars['ID']['output'];
  status: AssetStatus;
};

/** Provider for a moderator voice (inworld, or the virtual built-in) */
export const ModeratorVoiceProvider = {
  Builtin: 'Builtin',
  Inworld: 'Inworld',
} as const;

export type ModeratorVoiceProvider =
  (typeof ModeratorVoiceProvider)[keyof typeof ModeratorVoiceProvider];
export type Mutation = {
  __typename?: 'Mutation';
  /** Add a background image to the organization */
  addBackgroundImage: Array<Scalars['String']['output']>;
  /** Create a clip (project video + clip row). Set autoTriggerGeneration to queue generation. */
  addClip: ProjectHighlightVideoModel;
  addConnectionRule: QuestionConnectionRuleModel;
  /** Add a document to the organization. The document will be processed asynchronously and added to the organization knowledge base. */
  addDocument: DocumentAsset;
  addFormMessagePreview: FormMessagePreviewResponse;
  addFormMessagesPreview: FormMessagesPreviewResponse;
  /** Create a new Hyperbeam session for usability testing */
  addHyperbeamSession: HyperbeamSession;
  /** Add a tag to an insight */
  addInsightTag: InsightTagModel;
  addKey: Apikey;
  addMessagePreviewV3: MessagePreviewPairV2;
  addModeratorVoice: ModeratorVoiceAsset;
  /** Create a user-authored observation (origin=user, auto-approved). */
  addObservation: ProjectThemeModel;
  addOptionAsset: QuestionOptionAssetModel;
  addProject: ProjectModel;
  /** Add a document to a project. The document is processed asynchronously and added to the project knowledge base. */
  addProjectDocument: ProjectDocumentAsset;
  /** Create a project intro. */
  addProjectIntro: ProjectIntroModel;
  /** Adds a screener to a project. Add its questions with `addScreenerQuestion` using the returned id. */
  addProjectScreener: ProjectScreenerModel;
  addQuestion: QuestionV2Model;
  addQuestionAsset: QuestionAssetModel;
  /** Runs one turn of a preview question session with the user message. */
  addQuestionMessagePreview: AddQuestionMessagePreviewResponse;
  /** Create a reel (project video + reel row + ordered scenes). Clip scenes reference existing clips; transitions use black hold + optional text. autoTriggerGeneration requires all clip videos to be generated first. */
  addReel: ProjectHighlightVideoModel;
  /** Answers the current question of a preview screener run. Returns the next question, a disqualification, or the one-time `previewSessionKey` that unlocks previewing the project itself. */
  addScreenerPreviewAnswer: ScreenerPreviewAnswerResponse;
  /** Appends a question to a screener. */
  addScreenerQuestion: ScreenerQuestionModel;
  /** Create an org skill owned by the caller. */
  addSkill: SkillModel;
  /** Add a new tag for the organization. */
  addTag: Tag;
  /** Generate AssemblyAI streaming token */
  assemblyAIToken: SharedAssemblyAiTokenResponse;
  /** Cancel a download */
  cancelDownload?: Maybe<Scalars['UUID']['output']>;
  /** Cancel every active cohort of a project, refunding each one's undelivered testers to account credit (see cancelRecruitingCohort), so the project can then be deleted, closed or archived. Stops at the first cohort that cannot be cancelled and returns its error; cohorts already cancelled keep their refund and a retry skips them. Returns the cancelled cohorts (empty when none was active). */
  cancelProjectRecruiting: Array<RecruitingOrderLineItem>;
  /** Cancel (stop) one cohort and refund its undelivered testers — quantity minus completed, times the incentive — to account credit in the order currency. Human: a collecting cohort has its RepData survey paused first (a failed pause leaves it collecting: retry). Synthetic: a placed or collecting cohort has its queued and running jobs cancelled first. A completed or expired cohort is not cancellable; a stopped one is returned unchanged. */
  cancelRecruitingCohort: RecruitingOrderLineItem;
  /** Changes the role of a user in the current organization. */
  changeUserRole: Scalars['ID']['output'];
  /** Save a free-survey (temporary organization) project into your organization: copies its settings, theme, intros, intro videos, screener, questions and logic in one transaction. Created as Unpublished. */
  claimTempProject: ProjectModel;
  /** Create or update the ticket-agent setup for a provider connection (scope + starting status), registering or moving the native provider webhook. */
  configureTicketAgent: TicketAgentSubscriptionModel;
  /** Record an artifact the client detected for a session. */
  createCompanionArtifact: CompanionArtifact;
  /** Create a new (empty) companion session. */
  createCompanionSession: CompanionSession;
  createConnectionRules: Array<QuestionConnectionRuleModel>;
  /** Create a new tag and add it to an insight */
  createInsightTag: InsightTagModel;
  createMobileAppSignedUploadUrl: SignedUrl;
  /** Register an uploaded intro video for the organization. Upload the file to GCS first (via signedUrl), then pass its gcsKey here. */
  createOrgIntroVideo: OrgIntroVideoAsset;
  /**
   * Create organization settings
   * @deprecated Org settings will be created when a new account is called
   */
  createOrgSettings: OrganizationSettings;
  /** Register an uploaded intro video for a project. Upload the file to GCS first (via signedUrl), then pass its gcsKey here. */
  createProjectIntroVideo: ProjectIntroVideoAsset;
  /** Create a new recruiting audience for the organization. */
  createRecruitingAudience: RecruitingAudience;
  /** Create a signed URL for file upload */
  createSignedUploadUrl: SignedUrl;
  /** Register an uploaded widget intercept image. Upload the file to the private bucket first (createSignedUploadUrl with isPublic: false), then pass its gcsKey here. Use the returned id as imageAssetId on saveProjectWidgetConfig. */
  createWidgetImage: WidgetImageAsset;
  /** Create a new WorkOS organization and add company info */
  createWorkosOrgAndCompany: Organization;
  /** Delete a companion session and all its messages and artifacts. */
  deleteCompanionSession: Scalars['Boolean']['output'];
  /** Delete a document. */
  deleteDocument: Scalars['Boolean']['output'];
  /** Delete an organization intro video. */
  deleteOrgIntroVideo: Scalars['Boolean']['output'];
  /** Delete a project document. */
  deleteProjectDocument: Scalars['Boolean']['output'];
  /** Deletes a single channel from a project integration setting. */
  deleteProjectIntegrationChannel: Scalars['Boolean']['output'];
  /** Delete a project intro video. */
  deleteProjectIntroVideo: Scalars['Boolean']['output'];
  /** Removes a project's screener along with its questions. */
  deleteProjectScreener: Scalars['Boolean']['output'];
  /** Delete a recruiting audience. */
  deleteRecruitingAudience: Scalars['Boolean']['output'];
  deleteScreenerQuestion: Scalars['Boolean']['output'];
  /** Permanently deletes a user in the current organization with role-based permissions. It cannot be undone. */
  deleteUserV2: Scalars['ID']['output'];
  deploySyntheticAgents: DeploySyntheticAgentsResult;
  /** Disconnect an integration provider */
  disconnectIntegration: Scalars['Boolean']['output'];
  /** Hide a research recommendation for everyone in the org. */
  dismissResearchRecommendation: Scalars['Boolean']['output'];
  /** Create a deep copy of an existing project, including settings, questions, options, conditional logic, theme, integrations, and synthetic configuration. The duplicated project is always created as Unpublished and never copies insights or responses. */
  duplicateProject: ProjectModel;
  /** Fork any skill (system or org) into a new editable org skill owned by the caller. */
  duplicateSkill: SkillModel;
  /** Edit clip timing and/or highlight video title/description. Set `autoTriggerGeneration` when sending `startTime` and/or `endTime` to enqueue clip generation after the update. */
  editClip: ProjectHighlightVideoModel;
  editConnectionRule: QuestionConnectionRuleModel;
  editModeratorVoice: ModeratorVoiceAsset;
  editOptionAsset: QuestionOptionAssetModel;
  /** @deprecated Use updateOrganization instead. */
  editOrganization: Organization;
  editProject: ProjectModel;
  /** Update a project intro. */
  editProjectIntro: ProjectIntroModel;
  /** Updates a screener's settings, e.g. where disqualified respondents go. */
  editProjectScreener: ProjectScreenerModel;
  /** Update project tags only. Uses the same logic as editProject for tag handling. */
  editProjectTags: Array<Tag>;
  editQuestion: QuestionV2Model;
  editQuestionAsset: QuestionAssetModel;
  /** Replaces an answer of the latest answered preview question, discarding everything after it, and re-runs the turn on the new answer. */
  editQuestionMessagePreview: AddQuestionMessagePreviewResponse;
  /** Edit a reel: optional name/description on the highlight asset, and/or replace all scenes. Replacing scenes resets generation and clears the composed video until generateProjectVideo is run (or use autoTriggerGeneration). */
  editReel: ProjectHighlightVideoModel;
  /** Edits a screener question. Passing `options` replaces the whole option set. */
  editScreenerQuestion: ScreenerQuestionModel;
  /** Edit an org skill (creator only). System skills are immutable. */
  editSkill: SkillModel;
  /** Edit an existing tag. */
  editTag: Tag;
  /** Create a new download */
  exportInsights: Download;
  /** @deprecated The Generate Options flow is being retired and will be removed in a future version. */
  generateAIOptionsV2: GeneratedOptions;
  generateAIProjectV2: GeneratedProject;
  /** Generate a single AI question from a learning goal using tool-calling (non-streaming). Supports an optional target language. */
  generateAIQuestionV3: GeneratedQuestion;
  generateFollowUpQuestion: GenerateFollowUpQuestionResponse;
  /** @deprecated Use generateFollowUpQuestion instead. Will be removed after FE migration. */
  generateFollowUpQuestionV2: GenerateFollowUpQuestionResponse;
  generateLearningGoal: Scalars['String']['output'];
  /** Generate moderator speech for live survey playback. Resolves the effective voice for the project (project override → org default → built-in) and synthesizes. */
  generateModeratorSpeechV2: SharedGenerateSpeechResponse;
  generateModeratorVoiceAudio: SharedGenerateSpeechResponse;
  generateModeratorVoiceTestPhrase: Scalars['String']['output'];
  /** Queue video generation for a project video: clip (ffmpeg trim/upload) or reel (compose scenes + upload), based on videoType */
  generateProjectHighlightVideo: ProjectHighlightVideoModel;
  /** Generate a meaningful project name from the draft questions and project type. */
  generateProjectName: Scalars['String']['output'];
  /** Generate a list of project objectives (learning goals) from a user prompt. Does not persist anything. */
  generateProjectObjectives: Array<Scalars['String']['output']>;
  /** Suggest a project-objectives prompt grounded in the caller org's most recent asset summaries (capped at 3). Does not persist anything. */
  generateProjectPromptSuggestion: Scalars['String']['output'];
  generateRatingLabels: GeneratedRatingLabels;
  /**
   * Generate speech from text using ElevenLabs
   * @deprecated Use generateModeratorSpeechV2 instead. Will be removed after FE migration.
   */
  generateSpeech: SharedGenerateSpeechResponse;
  /** Improve an existing question using tool-calling (non-streaming). Keeps the question type and supports an optional target language. */
  improveQuestion: GeneratedQuestion;
  initiateSurveyV3: InitiateSurveyResponseV3;
  /** Invites an user to the organization. */
  inviteUser: Invitation;
  /** Leave the specified organization. */
  leaveOrganization: Scalars['Boolean']['output'];
  /** Mark multiple insights as read */
  markInsightsAsRead: Array<Scalars['UUID']['output']>;
  /** Mark this project's observations as seen for the current user (clears the "new" pill on next visit) */
  markObservationsSeen: Scalars['Boolean']['output'];
  /** Marks a project's problem feed as seen by the current user, clearing its warning flag. */
  markProblemReportsSeen: Scalars['Boolean']['output'];
  openCustomerPortal: CheckoutSession;
  /** Pin an audience to the top of the organization's audience list. Pinning a pinned audience keeps its original pin time. */
  pinRecruitingAudience: RecruitingAudience;
  /** Place a recruiting order of human and/or synthetic cohorts for a project. Amounts are computed server-side; when requiresPayment is true the client must redirect to checkoutUrl. */
  placeRecruitingOrder: PlaceRecruitingOrderResult;
  /** Start an unsaved-recording preview: queues a throwaway clone+synth and returns a previewId to poll via moderatorVoicePreview. Persists nothing. */
  previewModeratorVoiceRecording: ModeratorVoicePreviewHandle;
  /** Publish a project to the panel (sets publishedAt to now) */
  publishPanel: ProjectPanelConfigModel;
  /** Re-interpret an observation with reviewer-provided context ("Add Context"): the AI re-reads the evidence with the context applied and rewrites the observation; the review decision resets to pending. */
  refineObservation: ProjectThemeModel;
  /** Remove a background image from the organization */
  removeBackgroundImage: Array<Scalars['String']['output']>;
  removeConnectionRule: Scalars['Boolean']['output'];
  /** Terminate a Hyperbeam session */
  removeHyperbeamSession: Scalars['Boolean']['output'];
  /** Remove an insight */
  removeInsight: Scalars['Boolean']['output'];
  /** Remove a tag from an insight */
  removeInsightTag: InsightTagModel;
  removeModeratorVoice: Scalars['Boolean']['output'];
  removeOptionAsset: Scalars['Boolean']['output'];
  /** Remove the specified organization. This action cannot be undone. */
  removeOrganization: Scalars['Boolean']['output'];
  removeProject: Scalars['Boolean']['output'];
  /** Delete a project video (and its clip/reel row) by project video ID */
  removeProjectHighlightVideo: Scalars['Boolean']['output'];
  /** Delete a project intro. */
  removeProjectIntro: Scalars['Boolean']['output'];
  /** Remove an analysis tab: deletes the skill's results on that project and drops its project skill. */
  removeProjectSkillResult: Scalars['Boolean']['output'];
  removeQuestion: Scalars['Boolean']['output'];
  removeQuestionAsset: Scalars['Boolean']['output'];
  /** Delete an org skill (creator, or org owner/admin). */
  removeSkill: Scalars['Boolean']['output'];
  /** Remove a tag. */
  removeTag: Scalars['Boolean']['output'];
  /** Remove a ticket-agent subscription and deregister its native provider webhook. */
  removeTicketAgentSubscription: Scalars['Boolean']['output'];
  /**
   * Rename a companion session.
   * @deprecated Use updateCompanionSession, which also sets the output persona.
   */
  renameCompanionSession: CompanionSession;
  /** Sets the order respondents answer the screener questions in. */
  reorderScreenerQuestions: Array<ScreenerQuestionModel>;
  replaceModeratorVoiceRecording: ModeratorVoiceAsset;
  /** Reprocess a document by refreshing its content. */
  reprocessDocument: DocumentAsset;
  /** Reprocess a project document by refreshing its content. */
  reprocessProjectDocument: ProjectDocumentAsset;
  /** Resends an existing invitation. */
  resendInvitation: Invitation;
  retrainModeratorVoice: ModeratorVoiceAsset;
  /** Re-run fulfillment for a placed order: restarts failed cohorts and ones left mid-fulfillment by a crashed run. Returns the order with its derived statuses. */
  retryRecruitingOrderFulfillment: RecruitingOrder;
  /** Approve/reject an observation (or set pending to undo). Rejected observations are excluded from generated skill results. */
  reviewObservation: ProjectThemeModel;
  revokeApiKey: Scalars['Boolean']['output'];
  /** Revokes an existing invitation. It cannot be undone. */
  revokeInvitation: Scalars['ID']['output'];
  saveDefaultModeratorVoice: ModeratorVoiceAsset;
  /** Save a project draft to cache with 1 day TTL. Cache key format: orgId-draftProjectType. The draft type is automatically determined from project type and isPoll/isForm flags. */
  saveProjectDraft: Scalars['Boolean']['output'];
  saveProjectModeratorVoice: Scalars['Boolean']['output'];
  /** Save or update panel configuration for a project */
  saveProjectPanelConfig: ProjectPanelConfigModel;
  saveProjectThemeSettings: ProjectFrontendThemeSettings;
  /** Save or update widget configuration for a project */
  saveProjectWidgetConfig: ProjectWidgetConfigModel;
  /** Save organization settings */
  saveSettings: OrganizationSettings;
  /** Mark/unmark an org skill as the org-wide default analysis skill (unique per org). */
  setDefaultSkill: SkillModel;
  /** Mark a project as favorite (or remove it) for the current user */
  setProjectFavorite: Scalars['Boolean']['output'];
  /** Enable/disable a skill as one of the project's default analyses — enabled results auto-refresh after theme processing. */
  setProjectSkill: Scalars['Boolean']['output'];
  /** Pin/unpin a skill (org or system) so it sorts first in the list. Purely visual; no effect on generation. */
  setSkillPinned: SkillModel;
  setupCompany: Organization;
  /** Setup a new organization. */
  setupOrganization: OrganizationMembership;
  /** Generate a sharing ID for an insight and return the insight */
  shareInsight: InsightV2;
  /** Closes a non-required (or already answered) preview question and returns the next question. */
  skipQuestionPreview: QuestionTurnPreviewResponse;
  startCheckout: CheckoutSession;
  /** Start integration setup by creating a Nango connect session for OAuth flow */
  startIntegrationSetup: ConnectSessionResponse;
  /** Starts a preview run of a project's screener and returns the first question. Unlike the respondent flow this works on drafts and does not count against the response limit. */
  startScreenerPreview: ScreenerPreviewSession;
  /** Starts a preview run of a unified project (project.type IS NULL) and returns the first question. */
  startUnifiedPreview: StartUnifiedPreviewResponse;
  /** Trigger regeneration of the project-wide aiLearntText rollup over all objectives. Returns a job identifier. */
  triggerAiLearntTextProcessing: Scalars['String']['output'];
  /** Trigger theme processing for a project. Returns a job identifier. `all` (the default) runs the full pipeline — extraction plus both consolidation passes — and is rate-limited to every 3 hours. `project` rebuilds only the observations by replaying the project-wide consolidation over the existing question-scoped themes: no extraction, no rate limit. */
  triggerThemeProcessing: Scalars['String']['output'];
  /** Unpin an audience; unpinning an unpinned audience is a no-op. */
  unpinRecruitingAudience: RecruitingAudience;
  /** Update a companion session's name and/or output persona. */
  updateCompanionSession: CompanionSession;
  /** @deprecated This mutation is deprecated and will be removed in a future version. */
  updateCompanyInfo: Organization;
  /** @deprecated This mutation is deprecated. Use editConnectionRule instead. */
  updateConnectionRule: QuestionConnectionRuleModel;
  /** Update an existing document in the organization. The document will be reprocessed asynchronously. */
  updateDocument: DocumentAsset;
  /** Update an insight's quality bucket. Toggles archivedAt when the new value crosses the Low boundary. */
  updateInsightQuality: InsightV2;
  /**
   * Bulk update insights
   * @deprecated This mutation is deprecated. Use markInsightsAsRead instead.
   */
  updateInsightsV2: Array<Scalars['UUID']['output']>;
  /** Update integration settings for a provider */
  updateIntegrationSettings: Scalars['Boolean']['output'];
  /** Update the last insight read timestamp for a project */
  updateLastInsightRead: Scalars['Boolean']['output'];
  updateLastLogin: UserActivity;
  /** Update the current user's onboarding-checklist flags for the active organization. Replaces the stored set (send the full desired object). */
  updateOnboardingSteps: OnboardingStepsModel;
  /** @deprecated This mutation is deprecated. Use editOptionAsset instead. */
  updateOptionAsset: QuestionOptionAssetModel;
  /** Rename an organization intro video. */
  updateOrgIntroVideo: OrgIntroVideoAsset;
  /** Update organization */
  updateOrganization: Organization;
  /** Update an existing project document. The document is reprocessed asynchronously. */
  updateProjectDocument: ProjectDocumentAsset;
  /** Update project integration settings */
  updateProjectIntegrationSettings: ProjectIntegrationSettingModel;
  /** Rename a project intro video. */
  updateProjectIntroVideo: ProjectIntroVideoAsset;
  /** @deprecated Use `editProject` for project-level settings or `deploySyntheticAgents` for synthetic-tab settings. */
  updateProjectSettings: ProjectSettingsModel;
  updateQuestionOrder: Array<QuestionV2Model>;
  /** Update an existing recruiting audience. */
  updateRecruitingAudience: RecruitingAudience;
  uploadQuestionMobileApp: QuestionV2Model;
};

export type MutationAddBackgroundImageArgs = {
  input: AddBackgroundImageInput;
};

export type MutationAddClipArgs = {
  input: AddClipInput;
};

export type MutationAddConnectionRuleArgs = {
  input: CreateConnectionRuleInput;
};

export type MutationAddDocumentArgs = {
  input: AddDocumentInput;
};

export type MutationAddFormMessagePreviewArgs = {
  input: AddFormMessagePreviewInput;
};

export type MutationAddFormMessagesPreviewArgs = {
  input: AddFormMessagesPreviewInput;
};

export type MutationAddHyperbeamSessionArgs = {
  input: AddHyperbeamSessionInput;
};

export type MutationAddInsightTagArgs = {
  input: AddInsightTagInput;
};

export type MutationAddKeyArgs = {
  input: ApikeyAddInput;
};

export type MutationAddMessagePreviewV3Args = {
  input: AddMessagePreviewInput;
};

export type MutationAddModeratorVoiceArgs = {
  input: AddModeratorVoiceInput;
};

export type MutationAddObservationArgs = {
  input: AddObservationInput;
};

export type MutationAddOptionAssetArgs = {
  input: CreateOptionAssetInput;
};

export type MutationAddProjectArgs = {
  input: CreateProjectInput;
};

export type MutationAddProjectDocumentArgs = {
  input: AddProjectDocumentInput;
};

export type MutationAddProjectIntroArgs = {
  input: CreateProjectIntroInput;
};

export type MutationAddProjectScreenerArgs = {
  input: ProjectScreenerInput;
};

export type MutationAddQuestionArgs = {
  input: CreateQuestionV2Input;
};

export type MutationAddQuestionAssetArgs = {
  input: CreateQuestionAssetInput;
};

export type MutationAddQuestionMessagePreviewArgs = {
  input: AddQuestionMessagePreviewInput;
};

export type MutationAddReelArgs = {
  input: AddReelInput;
};

export type MutationAddScreenerPreviewAnswerArgs = {
  input: AddScreenerPreviewAnswerInput;
};

export type MutationAddScreenerQuestionArgs = {
  input: AddScreenerQuestionInput;
};

export type MutationAddSkillArgs = {
  input: AddSkillInput;
};

export type MutationAddTagArgs = {
  input: CreateTagV2Input;
};

export type MutationAssemblyAiTokenArgs = {
  input: SharedAssemblyAiTokenInput;
};

export type MutationCancelDownloadArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationCancelProjectRecruitingArgs = {
  projectId: Scalars['UUID']['input'];
};

export type MutationCancelRecruitingCohortArgs = {
  lineItemId: Scalars['UUID']['input'];
};

export type MutationChangeUserRoleArgs = {
  input: ChangeUserRoleInput;
};

export type MutationClaimTempProjectArgs = {
  input: ClaimTempProjectInput;
};

export type MutationConfigureTicketAgentArgs = {
  input: ConfigureTicketAgentInput;
};

export type MutationCreateCompanionArtifactArgs = {
  input: CreateCompanionArtifactInput;
};

export type MutationCreateCompanionSessionArgs = {
  personaId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateConnectionRulesArgs = {
  input: CreateConnectionRulesInput;
};

export type MutationCreateInsightTagArgs = {
  input: CreateInsightTagInput;
};

export type MutationCreateMobileAppSignedUploadUrlArgs = {
  input: CreateMobileAppSignedUploadUrlInput;
};

export type MutationCreateOrgIntroVideoArgs = {
  input: CreateOrgIntroVideoInput;
};

export type MutationCreateOrgSettingsArgs = {
  input: CreateOrganizationSettingsInput;
};

export type MutationCreateProjectIntroVideoArgs = {
  input: CreateProjectIntroVideoInput;
};

export type MutationCreateRecruitingAudienceArgs = {
  input: CreateRecruitingAudienceInput;
};

export type MutationCreateSignedUploadUrlArgs = {
  input: CreateSignedUrlInput;
};

export type MutationCreateWidgetImageArgs = {
  input: CreateWidgetImageInput;
};

export type MutationCreateWorkosOrgAndCompanyArgs = {
  input: WorkosAndCompanyCreateInput;
};

export type MutationDeleteCompanionSessionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};

export type MutationDeleteOrgIntroVideoArgs = {
  input: DeleteOrgIntroVideoInput;
};

export type MutationDeleteProjectDocumentArgs = {
  input: DeleteProjectDocumentInput;
};

export type MutationDeleteProjectIntegrationChannelArgs = {
  input: DeleteProjectIntegrationChannelInput;
};

export type MutationDeleteProjectIntroVideoArgs = {
  input: DeleteProjectIntroVideoInput;
};

export type MutationDeleteProjectScreenerArgs = {
  input: ProjectScreenerInput;
};

export type MutationDeleteRecruitingAudienceArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteScreenerQuestionArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteUserV2Args = {
  id: Scalars['ID']['input'];
};

export type MutationDeploySyntheticAgentsArgs = {
  input: DeploySyntheticAgentsInput;
};

export type MutationDisconnectIntegrationArgs = {
  providerKey: Scalars['String']['input'];
};

export type MutationDismissResearchRecommendationArgs = {
  id: Scalars['String']['input'];
};

export type MutationDuplicateProjectArgs = {
  input: DuplicateProjectInput;
};

export type MutationDuplicateSkillArgs = {
  ref: SkillRefInput;
};

export type MutationEditClipArgs = {
  input: EditClipInput;
};

export type MutationEditConnectionRuleArgs = {
  input: UpdateConnectionRuleInput;
};

export type MutationEditModeratorVoiceArgs = {
  input: EditModeratorVoiceInput;
};

export type MutationEditOptionAssetArgs = {
  input: UpdateOptionAssetInput;
};

export type MutationEditOrganizationArgs = {
  input: V2OrganizationUpdateInput;
};

export type MutationEditProjectArgs = {
  input: UpdateProjectInput;
};

export type MutationEditProjectIntroArgs = {
  input: UpdateProjectIntroInput;
};

export type MutationEditProjectScreenerArgs = {
  input: UpdateProjectScreenerInput;
};

export type MutationEditProjectTagsArgs = {
  input: EditProjectTagsInput;
};

export type MutationEditQuestionArgs = {
  input: UpdateQuestionV2Input;
};

export type MutationEditQuestionAssetArgs = {
  input: UpdateQuestionAssetInput;
};

export type MutationEditQuestionMessagePreviewArgs = {
  input: EditQuestionMessagePreviewInput;
};

export type MutationEditReelArgs = {
  input: EditReelInput;
};

export type MutationEditScreenerQuestionArgs = {
  input: EditScreenerQuestionInput;
};

export type MutationEditSkillArgs = {
  input: EditSkillInput;
};

export type MutationEditTagArgs = {
  input: UpdateTagV2Input;
};

export type MutationExportInsightsArgs = {
  input: CreateProjectInsightsDownloadInput;
};

export type MutationGenerateAiOptionsV2Args = {
  input: GenerateOptionsInput;
};

export type MutationGenerateAiProjectV2Args = {
  input: GenerateProjectInput;
};

export type MutationGenerateAiQuestionV3Args = {
  input: GenerateQuestionV3Input;
};

export type MutationGenerateFollowUpQuestionArgs = {
  input: GenerateFollowUpQuestionStatelessInput;
};

export type MutationGenerateFollowUpQuestionV2Args = {
  input: GenerateFollowUpQuestionInput;
};

export type MutationGenerateLearningGoalArgs = {
  input: GenerateLearningGoalInput;
};

export type MutationGenerateModeratorSpeechV2Args = {
  input: GenerateModeratorSpeechV2Input;
};

export type MutationGenerateModeratorVoiceAudioArgs = {
  input: GenerateModeratorVoiceAudioInput;
};

export type MutationGenerateModeratorVoiceTestPhraseArgs = {
  input: GenerateModeratorVoiceTestPhraseInput;
};

export type MutationGenerateProjectHighlightVideoArgs = {
  input: GenerateProjectHighlightVideoInput;
};

export type MutationGenerateProjectNameArgs = {
  input: GenerateProjectNameInput;
};

export type MutationGenerateProjectObjectivesArgs = {
  input: GenerateProjectObjectivesInput;
};

export type MutationGenerateProjectPromptSuggestionArgs = {
  input?: InputMaybe<GenerateProjectPromptSuggestionInput>;
};

export type MutationGenerateRatingLabelsArgs = {
  input: GenerateRatingLabelsInput;
};

export type MutationGenerateSpeechArgs = {
  input: SharedGenerateSpeechInput;
};

export type MutationImproveQuestionArgs = {
  input: ImproveQuestionInput;
};

export type MutationInitiateSurveyV3Args = {
  input: InitiateSurveyInput;
};

export type MutationInviteUserArgs = {
  input: InviteInput;
};

export type MutationLeaveOrganizationArgs = {
  orgId: Scalars['String']['input'];
};

export type MutationMarkInsightsAsReadArgs = {
  input: UpdateInsightsV2Input;
};

export type MutationMarkObservationsSeenArgs = {
  projectId: Scalars['UUID']['input'];
};

export type MutationMarkProblemReportsSeenArgs = {
  projectId: Scalars['UUID']['input'];
};

export type MutationPinRecruitingAudienceArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationPlaceRecruitingOrderArgs = {
  input: PlaceRecruitingOrderInput;
};

export type MutationPreviewModeratorVoiceRecordingArgs = {
  input: PreviewModeratorVoiceInput;
};

export type MutationPublishPanelArgs = {
  input: PublishPanelInput;
};

export type MutationRefineObservationArgs = {
  input: RefineObservationInput;
};

export type MutationRemoveBackgroundImageArgs = {
  input: RemoveBackgroundImageInput;
};

export type MutationRemoveConnectionRuleArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveHyperbeamSessionArgs = {
  input: RemoveHyperbeamSessionInput;
};

export type MutationRemoveInsightArgs = {
  input: DeleteInsightV2Input;
};

export type MutationRemoveInsightTagArgs = {
  input: RemoveInsightTagInput;
};

export type MutationRemoveModeratorVoiceArgs = {
  input: RemoveModeratorVoiceInput;
};

export type MutationRemoveOptionAssetArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRemoveOrganizationArgs = {
  input: DeleteOrganizationInput;
};

export type MutationRemoveProjectArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRemoveProjectHighlightVideoArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRemoveProjectIntroArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRemoveProjectSkillResultArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRemoveQuestionArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRemoveQuestionAssetArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationRemoveSkillArgs = {
  skillId: Scalars['UUID']['input'];
};

export type MutationRemoveTagArgs = {
  input: DeleteTagV2Input;
};

export type MutationRemoveTicketAgentSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};

export type MutationRenameCompanionSessionArgs = {
  input: RenameCompanionSessionInput;
};

export type MutationReorderScreenerQuestionsArgs = {
  input: ReorderScreenerQuestionsInput;
};

export type MutationReplaceModeratorVoiceRecordingArgs = {
  input: ReplaceModeratorVoiceRecordingInput;
};

export type MutationReprocessDocumentArgs = {
  input: RefreshDocumentInput;
};

export type MutationReprocessProjectDocumentArgs = {
  input: RefreshProjectDocumentInput;
};

export type MutationResendInvitationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetrainModeratorVoiceArgs = {
  input: RetrainModeratorVoiceInput;
};

export type MutationRetryRecruitingOrderFulfillmentArgs = {
  orderId: Scalars['UUID']['input'];
};

export type MutationReviewObservationArgs = {
  input: ReviewObservationInput;
};

export type MutationRevokeApiKeyArgs = {
  input: DeleteApiKeyInput;
};

export type MutationRevokeInvitationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSaveDefaultModeratorVoiceArgs = {
  input: SaveDefaultModeratorVoiceInput;
};

export type MutationSaveProjectDraftArgs = {
  input: CreateProjectInput;
};

export type MutationSaveProjectModeratorVoiceArgs = {
  input: SaveProjectModeratorVoiceInput;
};

export type MutationSaveProjectPanelConfigArgs = {
  input: SaveProjectPanelConfigInput;
};

export type MutationSaveProjectThemeSettingsArgs = {
  input: SaveProjectThemeSettingsInput;
};

export type MutationSaveProjectWidgetConfigArgs = {
  input: SaveProjectWidgetConfigInput;
};

export type MutationSaveSettingsArgs = {
  input: UpdateOrganizationSettingsInput;
};

export type MutationSetDefaultSkillArgs = {
  input: SetDefaultSkillInput;
};

export type MutationSetProjectFavoriteArgs = {
  isFavorite: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
};

export type MutationSetProjectSkillArgs = {
  input: SetProjectSkillInput;
};

export type MutationSetSkillPinnedArgs = {
  input: SetPinnedSkillInput;
};

export type MutationSetupCompanyArgs = {
  input: OrganizationCreateInput;
};

export type MutationSetupOrganizationArgs = {
  input: CreateOrganizationInput;
};

export type MutationShareInsightArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationSkipQuestionPreviewArgs = {
  input: SkipQuestionPreviewInput;
};

export type MutationStartCheckoutArgs = {
  priceId: Scalars['String']['input'];
};

export type MutationStartIntegrationSetupArgs = {
  providerKey: Scalars['String']['input'];
};

export type MutationStartScreenerPreviewArgs = {
  input: StartScreenerPreviewInput;
};

export type MutationStartUnifiedPreviewArgs = {
  input: StartUnifiedPreviewInput;
};

export type MutationTriggerAiLearntTextProcessingArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationTriggerThemeProcessingArgs = {
  id: Scalars['UUID']['input'];
  scope?: InputMaybe<ThemeProcessingScope>;
};

export type MutationUnpinRecruitingAudienceArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationUpdateCompanionSessionArgs = {
  input: UpdateCompanionSessionInput;
};

export type MutationUpdateCompanyInfoArgs = {
  input: OrganizationUpdateInput;
};

export type MutationUpdateConnectionRuleArgs = {
  input: UpdateConnectionRuleInput;
};

export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};

export type MutationUpdateInsightQualityArgs = {
  input: UpdateInsightQualityInput;
};

export type MutationUpdateInsightsV2Args = {
  input: UpdateInsightsV2Input;
};

export type MutationUpdateIntegrationSettingsArgs = {
  input: UpdateIntegrationSettingsInput;
};

export type MutationUpdateLastInsightReadArgs = {
  projectId: Scalars['UUID']['input'];
};

export type MutationUpdateOnboardingStepsArgs = {
  input: OnboardingStepsInput;
};

export type MutationUpdateOptionAssetArgs = {
  input: UpdateOptionAssetInput;
};

export type MutationUpdateOrgIntroVideoArgs = {
  input: UpdateOrgIntroVideoInput;
};

export type MutationUpdateOrganizationArgs = {
  input: V2OrganizationUpdateInput;
};

export type MutationUpdateProjectDocumentArgs = {
  input: UpdateProjectDocumentInput;
};

export type MutationUpdateProjectIntegrationSettingsArgs = {
  input: UpdateProjectIntegrationSettingsInput;
};

export type MutationUpdateProjectIntroVideoArgs = {
  input: UpdateProjectIntroVideoInput;
};

export type MutationUpdateProjectSettingsArgs = {
  input: UpdateProjectSettingsInput;
};

export type MutationUpdateQuestionOrderArgs = {
  input: UpdateQuestionOrderInput;
};

export type MutationUpdateRecruitingAudienceArgs = {
  input: UpdateRecruitingAudienceInput;
};

export type MutationUploadQuestionMobileAppArgs = {
  input: UploadQuestionMobileAppInput;
};

/** The criterion that made an observation Critical */
export const ObservationCriticalCategory = {
  Blocker: 'Blocker',
  DataLoss: 'DataLoss',
  DealBreaker: 'DealBreaker',
  InScopeEdgeCase: 'InScopeEdgeCase',
  Money: 'Money',
  Security: 'Security',
} as const;

export type ObservationCriticalCategory =
  (typeof ObservationCriticalCategory)[keyof typeof ObservationCriticalCategory];
/** Impact of an observation, evaluated by AI from its evidence and the project context */
export const ObservationImpact = {
  Critical: 'Critical',
  High: 'High',
  Low: 'Low',
  Medium: 'Medium',
} as const;

export type ObservationImpact =
  (typeof ObservationImpact)[keyof typeof ObservationImpact];
export type OnboardingStepsInput = {
  createProject?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleDemo?: InputMaybe<Scalars['Boolean']['input']>;
  setupMcp?: InputMaybe<Scalars['Boolean']['input']>;
  startGatheringResponses?: InputMaybe<Scalars['Boolean']['input']>;
  startNewAiChat?: InputMaybe<Scalars['Boolean']['input']>;
  teachAi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingStepsModel = {
  __typename?: 'OnboardingStepsModel';
  createProject?: Maybe<Scalars['Boolean']['output']>;
  scheduleDemo?: Maybe<Scalars['Boolean']['output']>;
  setupMcp?: Maybe<Scalars['Boolean']['output']>;
  startGatheringResponses?: Maybe<Scalars['Boolean']['output']>;
  startNewAiChat?: Maybe<Scalars['Boolean']['output']>;
  teachAi?: Maybe<Scalars['Boolean']['output']>;
};

export type OpenEndedQuestionPhraseModel = {
  __typename?: 'OpenEndedQuestionPhraseModel';
  phrase: Scalars['String']['output'];
};

/** The type of option render */
export const OptionRenderType = {
  Emoji: 'Emoji',
  Media: 'Media',
  Star: 'Star',
  Text: 'Text',
} as const;

export type OptionRenderType =
  (typeof OptionRenderType)[keyof typeof OptionRenderType];
/** Specifies an order for a given orderBy argument. */
export const OrderDirection = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;

export type OrderDirection =
  (typeof OrderDirection)[keyof typeof OrderDirection];
export type OrgIntroVideoAsset = {
  __typename?: 'OrgIntroVideoAsset';
  createdAt: Scalars['DateTime']['output'];
  /** Duration of the intro video in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  gcsKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: AssetStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrgIntroVideoLink = {
  __typename?: 'OrgIntroVideoLink';
  /** The temporary signed URL that can be used to access the intro video. Valid for 5 minutes. */
  url: Scalars['String']['output'];
};

/** The status of the organization nango connection */
export const OrgNangoConnectionStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Revoked: 'Revoked',
} as const;

export type OrgNangoConnectionStatus =
  (typeof OrgNangoConnectionStatus)[keyof typeof OrgNangoConnectionStatus];
/** Aggregate statistics across all projects in an organization. */
export type OrgStatsModel = {
  __typename?: 'OrgStatsModel';
  /** The organization's running recruitment (human and synthetic cohorts still recruiting): totals, how many orders have a running cohort, and one row per project. */
  activeRecruitment: ActiveRecruitment;
  /**
   * Aggregate order and responder counts across the org's most recently active published panels, with projectCount of how many panels were aggregated.
   * @deprecated Counts legacy published panels only, not recruiting orders. Use activeRecruitment.
   */
  recentPanelCount: RecentPanelStat;
  /** Total number of insights across all projects in the organization. */
  totalInsights?: Maybe<Scalars['Int']['output']>;
  /** Total number of projects in the organization. */
  totalProjects: Scalars['Int']['output'];
};

/** Aggregate statistics across all projects in an organization. */
export type OrgStatsModelRecentPanelCountArgs = {
  projectLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Aggregate statistics across all projects in an organization. */
export type OrgStatsModelTotalInsightsArgs = {
  filter?: InputMaybe<TotalInsightsFilterInput>;
};

export type Organization = {
  __typename?: 'Organization';
  /** Array of background image paths */
  backgroundImages?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated This field is deprecated and will be removed in a future release. */
  category?: Maybe<Scalars['String']['output']>;
  /** When the organization was created. */
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated This field is deprecated and will be removed in a future release. */
  description?: Maybe<Scalars['String']['output']>;
  hasOnboarded: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insightsCount?: Maybe<Scalars['Int']['output']>;
  /** Number of members in the organization */
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Completion flags for the dashboard onboarding checklist.
   * @deprecated Onboarding is per-user, not per-org. Use `currentUser.onboardingSteps` instead.
   */
  onboardingSteps?: Maybe<OnboardingStepsModel>;
  orgSettings?: Maybe<OrganizationSettings>;
  /** Aggregate statistics across all projects in this organization. */
  orgStats: OrgStatsModel;
  planDetails?: Maybe<PlanDetails>;
  /** @deprecated This field is deprecated and will be removed in a future release. */
  productServices?: Maybe<Array<ProductService>>;
  /** The role of the current user within this organization. */
  role?: Maybe<Role>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is deprecated and will be removed in a future release. */
  website?: Maybe<Scalars['String']['output']>;
  workosId: Scalars['ID']['output'];
};

export type OrganizationInsightsCountArgs = {
  filter?: InputMaybe<DashboardFilterInput>;
};

export type OrganizationCreateInput = {
  /** Whether the organization consents to TheySaid using its survey data to train and improve TheySaid's AI models */
  aiTrainingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Who the company sells to, in the user's words; stored as the organization's target customers. Omitted or blank: not stored. */
  targetCustomers?: InputMaybe<Scalars['String']['input']>;
  tempOrgId?: InputMaybe<Scalars['String']['input']>;
  /** The company's website (a URL or bare domain), added to Teach AI as a link (https:// is assumed when no scheme is given). Omitted or blank: not added. Malformed: rejected with COMPANY_INFO_INVALID_WEBSITE. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  /** The unique ID of the organization. */
  id: Scalars['ID']['output'];
  /** The name of the organization. */
  name: Scalars['String']['output'];
};

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  /** Whether the organization consents to TheySaid using its survey data to train and improve TheySaid's AI models */
  aiTrainingConsent?: Maybe<Scalars['Boolean']['output']>;
  /** URL of the organization avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Background color */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Array of background image URLs */
  backgroundImages?: Maybe<Array<Scalars['String']['output']>>;
  /** Primary brand color in hex format (e.g. #FF0000) */
  brandColor?: Maybe<Scalars['HexColorCode']['output']>;
  /** Organization category */
  category?: Maybe<Scalars['String']['output']>;
  /** ID of the organization_assets intro video used as the org-level default intro video */
  defaultIntroVideoAssetId?: Maybe<Scalars['UUID']['output']>;
  /** ID of the organization_assets moderator voice used as the org-level default moderator voice (null uses the built-in ElevenLabs default) */
  defaultModeratorVoiceAssetId?: Maybe<Scalars['UUID']['output']>;
  /** Font family name */
  font?: Maybe<Scalars['String']['output']>;
  /** Whether to hide the TheySaid logo */
  hideTheysaidLogo?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier */
  id: Scalars['UUID']['output'];
  /** Organization industry */
  industry?: Maybe<Scalars['String']['output']>;
  /** Default language code for new projects in this organization (e.g. 'en', 'fr') */
  language?: Maybe<Scalars['String']['output']>;
  /** URL of the organization logo */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Selected background image URL (must be one of the backgrounds in backgroundImages) */
  selectedBackground?: Maybe<Scalars['String']['output']>;
  /** Target customers */
  targetCustomers?: Maybe<Scalars['String']['output']>;
  /** Theme mode (dark or light) */
  themeMode?: Maybe<ThemeMode>;
  /** Transparency level (0-100) */
  transparency?: Maybe<Scalars['Int']['output']>;
  /** Maximum widget popups per device per month (null = no limit) */
  widgetMaxPopupsPerMonth?: Maybe<Scalars['Int']['output']>;
  /** Seconds between widget popups for the same device (null = no limit) */
  widgetTimeBetweenPopupsSeconds?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationUpdateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the organization to update. */
  id: Scalars['ID']['input'];
  /** The name of the organization to update. */
  name?: InputMaybe<Scalars['String']['input']>;
  productServices?: InputMaybe<Array<ProductServiceCreateInput>>;
};

export type OrganizationWithRole = {
  __typename?: 'OrganizationWithRole';
  /** Array of background image paths */
  backgroundImages?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated This field is deprecated and will be removed in a future release. */
  category?: Maybe<Scalars['String']['output']>;
  /** When the organization was created. */
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated This field is deprecated and will be removed in a future release. */
  description?: Maybe<Scalars['String']['output']>;
  hasOnboarded: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insightsCount?: Maybe<Scalars['Int']['output']>;
  /** Number of members in the organization */
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Completion flags for the dashboard onboarding checklist.
   * @deprecated Onboarding is per-user, not per-org. Use `currentUser.onboardingSteps` instead.
   */
  onboardingSteps?: Maybe<OnboardingStepsModel>;
  orgSettings?: Maybe<OrganizationSettings>;
  /** Aggregate statistics across all projects in this organization. */
  orgStats: OrgStatsModel;
  planDetails?: Maybe<PlanDetails>;
  /** @deprecated This field is deprecated and will be removed in a future release. */
  productServices?: Maybe<Array<ProductService>>;
  /** The role of the current user in this organization. */
  role?: Maybe<Role>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is deprecated and will be removed in a future release. */
  website?: Maybe<Scalars['String']['output']>;
  workosId: Scalars['ID']['output'];
};

export type OrganizationWithRoleInsightsCountArgs = {
  filter?: InputMaybe<DashboardFilterInput>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
  /** Identifies the total count of items in the connection. */
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedCompanionArtifacts = {
  __typename?: 'PaginatedCompanionArtifacts';
  /** A list of CompanionArtifact items. */
  items: Array<CompanionArtifact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedCompanionMessages = {
  __typename?: 'PaginatedCompanionMessages';
  /** A list of CompanionMessage items. */
  items: Array<CompanionMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedCompanionSessions = {
  __typename?: 'PaginatedCompanionSessions';
  /** A list of CompanionSession items. */
  items: Array<CompanionSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedContacts = {
  __typename?: 'PaginatedContacts';
  /** A list of ContactSummaryModel items. */
  items: Array<ContactSummaryModel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedCreditLedgerEntries = {
  __typename?: 'PaginatedCreditLedgerEntries';
  /** A list of CreditLedgerEntryModel items. */
  items: Array<CreditLedgerEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedDocuments = {
  __typename?: 'PaginatedDocuments';
  /** A list of DocumentAsset items. */
  items: Array<DocumentAsset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedInsightsV2 = {
  __typename?: 'PaginatedInsightsV2';
  /** A list of InsightV2 items. */
  items: Array<InsightV2>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedInvitations = {
  __typename?: 'PaginatedInvitations';
  /** A list of Invitation items. */
  items: Array<Invitation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedMessagesV2 = {
  __typename?: 'PaginatedMessagesV2';
  /** A list of MessageV2 items. */
  items: Array<MessageV2>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedProjectDocuments = {
  __typename?: 'PaginatedProjectDocuments';
  /** A list of ProjectDocumentAsset items. */
  items: Array<ProjectDocumentAsset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedProjects = {
  __typename?: 'PaginatedProjects';
  /** A list of ProjectModel items. */
  items: Array<ProjectModel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedQuestionReports = {
  __typename?: 'PaginatedQuestionReports';
  /** A list of QuestionReportModel items. */
  items: Array<QuestionReportModel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedQuestionThemeMessages = {
  __typename?: 'PaginatedQuestionThemeMessages';
  /** A list of QuestionThemeMessageModel items. */
  items: Array<QuestionThemeMessageModel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedQuestionThemes = {
  __typename?: 'PaginatedQuestionThemes';
  /** A list of QuestionThemeItemModel items. */
  items: Array<QuestionThemeItemModel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedRecruitingAudiences = {
  __typename?: 'PaginatedRecruitingAudiences';
  /** A list of RecruitingAudienceModel items. */
  items: Array<RecruitingAudience>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedRecruitingOrderLineItems = {
  __typename?: 'PaginatedRecruitingOrderLineItems';
  /** A list of RecruitingOrderLineItemListItemModel items. */
  items: Array<RecruitingOrderLineItemListItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedRecruitingOrders = {
  __typename?: 'PaginatedRecruitingOrders';
  /** A list of RecruitingOrderModel items. */
  items: Array<RecruitingOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedTemplates = {
  __typename?: 'PaginatedTemplates';
  /** A list of TemplateModel items. */
  items: Array<TemplateModel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedThemeMessages = {
  __typename?: 'PaginatedThemeMessages';
  /** A list of ThemeMessage items. */
  items: Array<ThemeMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedType = {
  __typename?: 'PaginatedType';
  /** A list of ProjectHighlightVideoModel items. */
  items: Array<ProjectHighlightVideoModel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  /** A list of User items. */
  items: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PanelQualificationFilterInput = {
  allowedOptionIds: Array<Scalars['StringOrInt']['input']>;
  questionId: Scalars['Int']['input'];
};

export type PanelQualificationFilterModel = {
  __typename?: 'PanelQualificationFilterModel';
  allowedOptionIds: Array<Scalars['StringOrInt']['output']>;
  questionId: Scalars['Int']['output'];
};

export type PersonalityDimensionCatalog = {
  __typename?: 'PersonalityDimensionCatalog';
  dimension: SyntheticPersonalityDimension;
  options: Array<PersonalityOption>;
};

export type PersonalityOption = {
  __typename?: 'PersonalityOption';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type PersonalityRange = {
  __typename?: 'PersonalityRange';
  dimension: SyntheticPersonalityDimension;
  max: Scalars['Int']['output'];
  maxLabel: Scalars['String']['output'];
  min: Scalars['Int']['output'];
  minLabel: Scalars['String']['output'];
};

export type PersonalityRangeInput = {
  dimension: SyntheticPersonalityDimension;
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type PlaceRecruitingOrderInput = {
  /** Apply available account credit to this order (default; null means true). False applies none and charges the full total by card. Ignored when replaying a clientRequestId: the original order is returned as placed. */
  applyCredit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Client-generated uuid, one per checkout attempt. Re-sending the same value returns the order it already placed instead of placing a second one. */
  clientRequestId: Scalars['UUID']['input'];
  lineItems: Array<RecruitingOrderLineItemInput>;
  projectId: Scalars['UUID']['input'];
  /** The pending order whose checkout this cart started before it changed. Its checkout is expired and the order cancelled (releasing its credit) before the new order is placed; refused with RECRUITING_ORDERS_CHECKOUT_SUPERSEDED_COMPLETED if that checkout was already paid. Ignored for an order of another project, one no longer pending, and when replaying a clientRequestId. */
  supersedesOrderId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PlaceRecruitingOrderResult = {
  __typename?: 'PlaceRecruitingOrderResult';
  /** Stripe Checkout URL; null when no payment is required. */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  order: RecruitingOrder;
  /** True when the client must redirect to checkoutUrl to pay. */
  requiresPayment: Scalars['Boolean']['output'];
};

export type PlanDetails = {
  __typename?: 'PlanDetails';
  planCode: Scalars['String']['output'];
};

export type PollResultOutput = {
  __typename?: 'PollResultOutput';
  distribution: Array<DistributionItem>;
  totalResponses: Scalars['Int']['output'];
};

export type PreviewModeratorVoiceInput = {
  gcsKey: Scalars['String']['input'];
  langCode?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  mood: VoiceMood;
  text: Scalars['String']['input'];
  transcript: Scalars['String']['input'];
};

export type ProductService = {
  __typename?: 'ProductService';
  benefits: Array<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  uniqueSellingPoints: Array<Scalars['String']['output']>;
};

export type ProductServiceCreateInput = {
  benefits: Array<Scalars['String']['input']>;
  features: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  uniqueSellingPoints: Array<Scalars['String']['input']>;
};

export type ProjectChannelSetting = {
  __typename?: 'ProjectChannelSetting';
  channel: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
};

export type ProjectDocumentAsset = {
  __typename?: 'ProjectDocumentAsset';
  createdAt: Scalars['DateTime']['output'];
  gcsKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['UUID']['output'];
  status: AssetStatus;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ProjectDocumentLink = {
  __typename?: 'ProjectDocumentLink';
  /** The temporary signed URL that can be used to access the document. Valid for 5 minutes. */
  url: Scalars['String']['output'];
};

export type ProjectDocumentListFilterInput = {
  status?: InputMaybe<Array<AssetStatus>>;
  types?: InputMaybe<Array<AssetType>>;
};

export type ProjectDocumentOrder = {
  direction?: OrderDirection;
  field: ProjectDocumentOrderField;
};

export const ProjectDocumentOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  Status: 'STATUS',
  UpdatedAt: 'UPDATED_AT',
} as const;

export type ProjectDocumentOrderField =
  (typeof ProjectDocumentOrderField)[keyof typeof ProjectDocumentOrderField];
export type ProjectDraft = {
  __typename?: 'ProjectDraft';
  /** @deprecated Use `settings.anonymous` instead. */
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.calendarLink` instead. */
  calendarLink?: Maybe<Scalars['String']['output']>;
  /** Whether responders may jump forward to later questions. Redesigned builder. */
  canJumpForward?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.contactEmail` instead. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.contactPhone` instead. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device types this project supports (computer | phone). Redesigned builder. */
  deviceTypes?: Maybe<Array<DeviceType>>;
  /** Estimated time in seconds to complete the survey, derived from question types and AI follow-up depth. Rough upper-bound estimate; branching rules may shorten the actual path. */
  estimatedCompletionTime?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `settings.inAppPopupMessage` instead. */
  inAppPopupMessage?: Maybe<Scalars['String']['output']>;
  /** Insight count within the `filter.insightActivity` window. Only populated by the projects list query when that filter is set; null otherwise. */
  insightActivityCount?: Maybe<Scalars['Int']['output']>;
  /** How responders interact with the survey (voice | text). Redesigned builder. */
  interactionType?: Maybe<InteractionType>;
  /** @deprecated Use `settings.introText` instead. */
  introText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.isAIFormAssistanceEnabled` instead. */
  isAIFormAssistanceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isAiVoiceEnabled` instead. */
  isAiVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isAnalyticsPublic` instead. */
  isAnalyticsPublic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isForm?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isPoll?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isThankyouEnabled` instead. */
  isThankyouEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isUserVoiceEnabled` instead. */
  isUserVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `objectives` instead */
  learningGoal?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.maxResponses` instead. */
  maxResponses?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `interactionType` instead. Redesigned builder (868gc1px2). */
  mode?: Maybe<ProjectMode>;
  objectives?: Maybe<Array<ProjectObjectiveModel>>;
  /** Total responses from the TheySaid panel (RepData) for this project. */
  panelTotalInsights?: Maybe<Scalars['Int']['output']>;
  publicTitle?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<ProjectDraftQuestion>>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.reviewLink` instead. */
  reviewLink?: Maybe<Scalars['String']['output']>;
  /** Screener respondents must pass before taking this project. Null when the project has none. */
  screener?: Maybe<ProjectScreenerModel>;
  status?: Maybe<ProjectStatus>;
  /** @deprecated Use `settings.supportEmail` instead. */
  supportEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.supportLink` instead. */
  supportLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.supportPhone` instead. */
  supportPhone?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<ProjectDraftTag>>;
  /** @deprecated Use `settings.thankyouText` instead. */
  thankyouText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** `aiLearntText` translated into the project language (non-English projects only) */
  translatedAiLearntText?: Maybe<Scalars['String']['output']>;
  /**
   * NULL = redesigned builder experience
   * @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field; NULL still discriminates the new experience.
   */
  type?: Maybe<ProjectType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectDraftQuestion = {
  __typename?: 'ProjectDraftQuestion';
  aiConvoDepth?: Maybe<Scalars['Int']['output']>;
  aiInsights?: Maybe<Scalars['Boolean']['output']>;
  assets?: Maybe<Array<ProjectDraftQuestionAsset>>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Per-question voice|text override; null inherits the project. */
  interactionType?: Maybe<InteractionType>;
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  /** Appetize.io embed URL for Mobile App questions (UT projects). Loaded by survey FE at runtime. */
  mobileAppEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** Original filename of the uploaded mobile app. Display only. */
  mobileAppFileName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `maxSelections` instead. */
  multipleSelect?: Maybe<Scalars['Boolean']['output']>;
  notApplicableLabel?: Maybe<Scalars['String']['output']>;
  optionRenderType?: Maybe<OptionRenderType>;
  options?: Maybe<Array<ProjectDraftQuestionOption>>;
  questionOrder: Scalars['Int']['output'];
  randomize?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  showLiveDistribution?: Maybe<Scalars['Boolean']['output']>;
  subQuestions?: Maybe<Array<ProjectDraftSubQuestion>>;
  tags?: Maybe<Array<ProjectDraftTag>>;
  text: Scalars['String']['output'];
  /** English translation of the question text */
  translatedText?: Maybe<Scalars['String']['output']>;
  type: QuestionType;
};

export type ProjectDraftQuestionAsset = {
  __typename?: 'ProjectDraftQuestionAsset';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ProjectDraftQuestionOption = {
  __typename?: 'ProjectDraftQuestionOption';
  assets?: Maybe<Array<QuestionOptionAssetModel>>;
  label: Scalars['String']['output'];
  /** English translation of the option label */
  translatedLabel?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ProjectDraftSubQuestion = {
  __typename?: 'ProjectDraftSubQuestion';
  questionOrder?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
};

export type ProjectDraftTag = {
  __typename?: 'ProjectDraftTag';
  color?: Maybe<Scalars['HexColorCode']['output']>;
  name: Scalars['String']['output'];
};

export type ProjectFrontendThemeSettings = {
  __typename?: 'ProjectFrontendThemeSettings';
  /** Which background style wins: solid, gradient or image. */
  backgroundType?: Maybe<BackgroundType>;
  bgColor?: Maybe<Scalars['String']['output']>;
  bgGradient?: Maybe<ThemeGradient>;
  bgImage?: Maybe<Scalars['String']['output']>;
  font?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mode?: Maybe<ThemeMode>;
  /** Background overlay opacity (0-100). Distinct from transparency (surface opacity). */
  overlayOpacity?: Maybe<Scalars['Int']['output']>;
  primaryColor?: Maybe<Scalars['HexColorCode']['output']>;
  projectId: Scalars['UUID']['output'];
  secondaryColor?: Maybe<Scalars['HexColorCode']['output']>;
  titleFont?: Maybe<Scalars['String']['output']>;
  titleFontWeight?: Maybe<TitleFontWeight>;
  transparency?: Maybe<Scalars['Int']['output']>;
};

/** Clip-specific data; use parent ProjectHighlightVideo id for the asset row. Resolve `insight` for the source insight. */
export type ProjectHighlightVideoClip = {
  __typename?: 'ProjectHighlightVideoClip';
  endTime?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  /** Source insight for this clip (same organization as the authenticated user) */
  insight?: Maybe<InsightV2>;
  startTime?: Maybe<Scalars['Float']['output']>;
};

export type ProjectHighlightVideoModel = {
  __typename?: 'ProjectHighlightVideoModel';
  /** Clip-specific row when videoType is clip */
  clip?: Maybe<ProjectHighlightVideoClip>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  /** GCS key for the generated video, if any */
  gcsKey?: Maybe<Scalars['String']['output']>;
  /** Video generation pipeline status */
  generationStatus: AssetStatus;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['UUID']['output'];
  publishStatus: VideoPublishStatus;
  /** Reel row and scenes when videoType is reel */
  reel?: Maybe<ProjectReelModel>;
  updatedAt: Scalars['DateTime']['output'];
  videoType: ProjectVideoType;
};

export type ProjectHighlightVideoOrder = {
  direction: OrderDirection;
  field: ProjectHighlightVideoOrderField;
};

/** Fields to order project highlight videos by */
export const ProjectHighlightVideoOrderField = {
  CreatedAt: 'CREATED_AT',
  Duration: 'DURATION',
  Name: 'NAME',
  StartTime: 'START_TIME',
  UpdatedAt: 'UPDATED_AT',
} as const;

export type ProjectHighlightVideoOrderField =
  (typeof ProjectHighlightVideoOrderField)[keyof typeof ProjectHighlightVideoOrderField];
export type ProjectHighlightVideosListFilterInput = {
  /** Filter rows that have a generated video object in storage */
  hasVideo?: InputMaybe<Scalars['Boolean']['input']>;
  /** When set, only videos linked to a clip on this insight are returned */
  insightId?: InputMaybe<Scalars['UUID']['input']>;
  /** Maximum clip end time (seconds); applies to clip-backed videos only */
  maxEndTime?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum clip start time (seconds); applies to clip-backed videos only */
  minStartTime?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by project ID */
  projectId: Scalars['UUID']['input'];
  /** Filter by publish status */
  publishStatuses?: InputMaybe<Array<VideoPublishStatus>>;
  /** Search in video name and description */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Filter by generation pipeline status */
  statuses?: InputMaybe<Array<AssetStatus>>;
  /** Filter by video kind (clip vs reel). Omit to include both. */
  videoType?: InputMaybe<ProjectVideoType>;
};

export type ProjectInsightsDownloadsFilterInput = {
  /** The ID of the project to filter by. If not provided, downloads for all projects will be returned. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProjectIntegrationSettingModel = {
  __typename?: 'ProjectIntegrationSettingModel';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  projectId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  slackNotificationChannels?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProjectIntroModel = {
  __typename?: 'ProjectIntroModel';
  /** Channels this intro is shown on. */
  audience: Array<Channel>;
  id: Scalars['UUID']['output'];
  introSource?: Maybe<IntroSource>;
  /** Whether the responder shows this intro. */
  isEnabled: Scalars['Boolean']['output'];
  /** Whether the intro instructions (title/subtitle) are shown. */
  isInstructionsEnabled: Scalars['Boolean']['output'];
  /** Whether the intro video is shown. */
  isVideoEnabled: Scalars['Boolean']['output'];
  /** Org-level intro video asset. Null falls back to the org settings default. */
  orgAssetId?: Maybe<Scalars['UUID']['output']>;
  /** Project-level intro video asset. Null falls back to the project settings default. */
  projectAssetId?: Maybe<Scalars['UUID']['output']>;
  projectId: Scalars['UUID']['output'];
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProjectIntroVideoAsset = {
  __typename?: 'ProjectIntroVideoAsset';
  createdAt: Scalars['DateTime']['output'];
  /** Duration of the intro video in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  gcsKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['UUID']['output'];
  status: AssetStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectIntroVideoLink = {
  __typename?: 'ProjectIntroVideoLink';
  /** The temporary signed URL that can be used to access the intro video. Valid for 5 minutes. */
  url: Scalars['String']['output'];
};

export type ProjectListFilterInput = {
  /** Only include projects whose insight count within the given created-at window matches the thresholds. Archived insights are excluded unless `qualities` includes LOW. Also populates `insightActivityCount` on returned projects. */
  insightActivity?: InputMaybe<InsightActivityFilterInput>;
  /** Filter by the current user's favorite state: true = only favorites, false = only non-favorites, omitted = all. */
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only include projects whose lastActivityAt is at or before this timestamp. */
  maxLastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only include projects whose lastActivityAt is at or after this timestamp. */
  minLastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  qualities?: InputMaybe<Array<InsightQuality>>;
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ProjectStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<ListProjectsType>>;
};

/** Mode of the project. chat or hands-free */
export const ProjectMode = {
  Chat: 'Chat',
  HandsFree: 'HandsFree',
} as const;

export type ProjectMode = (typeof ProjectMode)[keyof typeof ProjectMode];
export type ProjectModel = {
  __typename?: 'ProjectModel';
  /** Global learnt-text summary rolled up over all of the project’s objectives */
  aiLearntText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.anonymous` instead. */
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  /** Average message depth for the project */
  avgMessageDepth?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `settings.calendarLink` instead. */
  calendarLink?: Maybe<Scalars['String']['output']>;
  /** Whether responders may jump forward to later questions. Redesigned builder. */
  canJumpForward?: Maybe<Scalars['Boolean']['output']>;
  canTriggerThemeProcessing?: Maybe<ThemeTriggerProcessingValidationResult>;
  /** @deprecated Use `settings.contactEmail` instead. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.contactPhone` instead. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device types this project supports (computer | phone). Redesigned builder. */
  deviceTypes?: Maybe<Array<DeviceType>>;
  /** Estimated time in seconds to complete the survey, derived from question types and AI follow-up depth. Rough upper-bound estimate; branching rules may shorten the actual path. */
  estimatedCompletionTime?: Maybe<Scalars['Int']['output']>;
  /** Whether a problem was reported since the current user last opened the problem feed. */
  hasUnseenProblemReports: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use `settings.inAppPopupMessage` instead. */
  inAppPopupMessage?: Maybe<Scalars['String']['output']>;
  /** The project's type, derived from its internal project-type tag (redesigned builder). Null when the project has no type tag. Use this instead of the deprecated `type` field. */
  inferredType?: Maybe<ProjectType>;
  /** Insight count within the `filter.insightActivity` window. Only populated by the projects list query when that filter is set; null otherwise. */
  insightActivityCount?: Maybe<Scalars['Int']['output']>;
  /** How responders interact with the survey (voice | text). Redesigned builder. */
  interactionType?: Maybe<InteractionType>;
  /** @deprecated Use `settings.introText` instead. */
  introText?: Maybe<Scalars['String']['output']>;
  /** The intro video in force for this project: the project's own when introVideoLevel is ProjectLevel, otherwise the org-level default. Null when none is configured at the effective level. */
  introVideo?: Maybe<ResolvedIntroVideo>;
  /** Intros configured for this project. */
  intros: Array<ProjectIntroModel>;
  /** @deprecated Use `settings.isAIFormAssistanceEnabled` instead. */
  isAIFormAssistanceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isAiVoiceEnabled` instead. */
  isAiVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isAnalyticsPublic` instead. */
  isAnalyticsPublic?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isCameraEnabled` instead. */
  isCameraEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the current user has marked this project as a favorite */
  isFavorite: Scalars['Boolean']['output'];
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isForm?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isPoll?: Maybe<Scalars['Boolean']['output']>;
  isProcessingAiLearntText?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the work `triggerThemeProcessing(scope)` would enqueue is already in flight. Takes the same scope: `project` watches the observations rebuild only, `all` (the default) watches both. */
  isProcessingThemes?: Maybe<Scalars['Boolean']['output']>;
  isSample?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isThankyouEnabled` instead. */
  isThankyouEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isUserVoiceEnabled` instead. */
  isUserVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** Most recent activity on the project: the latest of createdAt, updatedAt and lastResponseDate. */
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of when the current user last read this project's insights, or null if never. */
  lastInsightRead?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of when the current user last viewed this project's observations, or null if never. The FE marks an observation "new" when its createdAt is after this. */
  lastObservationsSeen?: Maybe<Scalars['DateTime']['output']>;
  lastResponseDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `objectives` instead */
  learningGoal?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.maxResponses` instead. */
  maxResponses?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `interactionType` instead. Redesigned builder (868gc1px2). */
  mode?: Maybe<ProjectMode>;
  objectives?: Maybe<Array<ProjectObjectiveModel>>;
  /** Panel configuration for this project */
  panelConfig?: Maybe<ProjectPanelConfigModel>;
  /** Total responses from the TheySaid panel (RepData) for this project. */
  panelTotalInsights?: Maybe<Scalars['Int']['output']>;
  /** Number of problems respondents reported on this project. */
  problemReportsCount: Scalars['Int']['output'];
  projectThemes?: Maybe<Array<ProjectThemeModel>>;
  /** Sizes of `projectThemes` for the same filter: `total` ignores `minEvidence`, `matching` applies it; neither applies `limit`. */
  projectThemesCounts: ProjectThemesCountsModel;
  publicTitle?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<QuestionV2Model>>;
  /** Recruiting progress for the project: completed testers (each cohort capped at its quantity) over total ordered, where a stopped or failed cohort counts only its capped completes since it will never fill. activeOnly false (default): every cohort of placed and completed orders. activeOnly true: only running cohorts (the recruitingOrderLineItems activeOnly set), zero/zero once nothing is running. Zero/zero when the project has no such cohorts. */
  recruitingRollup: RecruitingProjectRollup;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.reviewLink` instead. */
  reviewLink?: Maybe<Scalars['String']['output']>;
  /** Screener respondents must pass before taking this project. Null when the project has none. */
  screener?: Maybe<ProjectScreenerModel>;
  settings?: Maybe<ProjectSettingsModel>;
  /** Statistics for this project (same data as the top-level projectStats query). */
  stats: ProjectStatsModel;
  status?: Maybe<ProjectStatus>;
  /** @deprecated Use `settings.supportEmail` instead. */
  supportEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.supportLink` instead. */
  supportLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.supportPhone` instead. */
  supportPhone?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tag>>;
  /** @deprecated Use `settings.thankyouText` instead. */
  thankyouText?: Maybe<Scalars['String']['output']>;
  themeSettings?: Maybe<ProjectFrontendThemeSettings>;
  title?: Maybe<Scalars['String']['output']>;
  /** Total number of growth signals for the project */
  totalGrowthSignals?: Maybe<Scalars['Int']['output']>;
  /** Total number of insights for the project */
  totalInsights?: Maybe<Scalars['Int']['output']>;
  /** Total number of risk signals for the project */
  totalRiskSignals?: Maybe<Scalars['Int']['output']>;
  /** Total number of unread insights for the project */
  totalUnreadInsights?: Maybe<Scalars['Int']['output']>;
  /** `aiLearntText` translated into the project language (non-English projects only) */
  translatedAiLearntText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field; NULL still discriminates the new experience. */
  type?: Maybe<ProjectType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Widget configuration for this project */
  widgetConfig?: Maybe<ProjectWidgetConfigModel>;
};

export type ProjectModelIsProcessingThemesArgs = {
  scope?: InputMaybe<ThemeProcessingScope>;
};

export type ProjectModelProjectThemesArgs = {
  filter?: InputMaybe<ProjectThemeFilterInput>;
};

export type ProjectModelProjectThemesCountsArgs = {
  filter?: InputMaybe<ProjectThemeFilterInput>;
};

export type ProjectModelQuestionsArgs = {
  filter?: InputMaybe<QuestionsFilterInput>;
};

export type ProjectModelRecruitingRollupArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectModelStatsArgs = {
  filters?: InputMaybe<ProjectStatsFilterInput>;
};

export type ProjectModelTotalInsightsArgs = {
  filter?: InputMaybe<TotalInsightsFilterInput>;
};

export type ProjectObjectiveModel = {
  __typename?: 'ProjectObjectiveModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** AI-generated learnt text answering this objective, derived from project themes. */
  learntText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  /** `learntText` translated into the project language (non-English projects only). */
  translatedLearntText?: Maybe<Scalars['String']['output']>;
  /** Objective title (`text`) translated into English (non-English projects only). */
  translatedText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order projects by. */
  field: ProjectOrderField;
};

/** Fields to order projects by */
export const ProjectOrderField = {
  CreatedAt: 'CREATED_AT',
  InsightActivityCount: 'INSIGHT_ACTIVITY_COUNT',
  IsTemplate: 'IS_TEMPLATE',
  LastActivityDate: 'LAST_ACTIVITY_DATE',
  LastResponseDate: 'LAST_RESPONSE_DATE',
  Status: 'STATUS',
  Title: 'TITLE',
  TotalInsights: 'TOTAL_INSIGHTS',
  Type: 'TYPE',
} as const;

export type ProjectOrderField =
  (typeof ProjectOrderField)[keyof typeof ProjectOrderField];
export type ProjectPanelConfigModel = {
  __typename?: 'ProjectPanelConfigModel';
  /** Country code for panel survey (e.g. US, GB). Defaults to US when not set. */
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  projectId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  qualifications?: Maybe<Array<PanelQualificationFilterModel>>;
  repdataProjectId?: Maybe<Scalars['String']['output']>;
  repdataSurveyId?: Maybe<Scalars['String']['output']>;
  targetCompletes: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A problem a respondent reported while taking a project. */
export type ProjectProblemReportModel = {
  __typename?: 'ProjectProblemReportModel';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The response it was reported from; null when reported before the response was saved. */
  insightId?: Maybe<Scalars['UUID']['output']>;
  /** The question on screen when reported; null outside the question phase or once deleted. */
  questionId?: Maybe<Scalars['UUID']['output']>;
  /** Position of the question in the project, for ordering groups. */
  questionOrder?: Maybe<Scalars['Int']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  questionType?: Maybe<QuestionType>;
  responderEmail?: Maybe<Scalars['String']['output']>;
  responderName?: Maybe<Scalars['String']['output']>;
};

export type ProjectReelModel = {
  __typename?: 'ProjectReelModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  projectHighlightVideoId: Scalars['UUID']['output'];
  /** Ordered composition of the reel */
  scenes: Array<ProjectReelSceneModel>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectReelSceneModel = {
  __typename?: 'ProjectReelSceneModel';
  /** Referenced clip (slim) when sceneType is clip */
  clip?: Maybe<ProjectHighlightVideoClip>;
  createdAt: Scalars['DateTime']['output'];
  /** Playback duration in the reel (seconds). For transitions, required. For clips, optional snapshot — may differ from clip endTime − startTime after the clip is edited. */
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  /** Order of the scene within the reel (0-based index) */
  sceneOrder: Scalars['Int']['output'];
  sceneType: SceneType;
  transitionText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectScreenerInput = {
  /** The project to add the screener to. */
  projectId: Scalars['UUID']['input'];
};

export type ProjectScreenerModel = {
  __typename?: 'ProjectScreenerModel';
  /** Publishing methods the screener applies to. A project taken through a channel outside it skips the screener. */
  audience: Array<Channel>;
  createdAt: Scalars['DateTime']['output'];
  /** Where a disqualified respondent is sent. Null shows your own screen instead. */
  disqualificationRedirectUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When off, the screener is bypassed and its project can be taken directly. */
  isEnabled: Scalars['Boolean']['output'];
  /** The project this screener screens for. */
  projectId: Scalars['ID']['output'];
  /** Screening questions, in the order respondents answer them. */
  questions: Array<ScreenerQuestionModel>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectSettingsModel = {
  __typename?: 'ProjectSettingsModel';
  /** @deprecated Use `syntheticAge`. */
  age?: Maybe<IntRange>;
  /** @deprecated Use `syntheticAiTesters`. */
  aiTesters?: Maybe<Scalars['Int']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `syntheticBiologicalSex`. */
  biologicalSex?: Maybe<BiologicalSex>;
  calendarLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `syntheticCompanyIndustry`. */
  companyIndustry?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `syntheticCompanySize`. */
  companySize?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** ID of the project_assets intro video used as this project's default intro video */
  defaultIntroVideoAssetId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  inAppPopupMessage?: Maybe<Scalars['String']['output']>;
  /** @deprecated Redesigned builder (868gc1px2): intro content now lives in project intros. */
  introText?: Maybe<Scalars['String']['output']>;
  /** Whether this project uses its own intro video or the org-level default */
  introVideoLevel?: Maybe<IntroVideoLevel>;
  isAIFormAssistanceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isAiVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isAnalyticsPublic?: Maybe<Scalars['Boolean']['output']>;
  isCameraEnabled?: Maybe<Scalars['Boolean']['output']>;
  isThankyouEnabled?: Maybe<Scalars['Boolean']['output']>;
  isUserVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `syntheticKnowledgebase`. */
  knowledgebase?: Maybe<Scalars['String']['output']>;
  maxResponses?: Maybe<Scalars['Int']['output']>;
  /** ID of the organization_assets moderator voice used as this project's moderator voice override (null inherits org default) */
  moderatorVoiceAssetId?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Use `syntheticMotivation`. */
  motivation?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `syntheticPersonality`. */
  personality: Array<PersonalityRange>;
  projectId: Scalars['ID']['output'];
  reviewLink?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportLink?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  syntheticAge?: Maybe<IntRange>;
  syntheticAiTesters?: Maybe<Scalars['Int']['output']>;
  syntheticBiologicalSex?: Maybe<BiologicalSex>;
  syntheticCompanyIndustry?: Maybe<Scalars['String']['output']>;
  syntheticCompanySize?: Maybe<Scalars['String']['output']>;
  syntheticKnowledgebase?: Maybe<Scalars['String']['output']>;
  syntheticMotivation?: Maybe<Scalars['String']['output']>;
  syntheticPersonality: Array<PersonalityRange>;
  syntheticSpeakerBoost?: Maybe<Scalars['Boolean']['output']>;
  syntheticTitles?: Maybe<Scalars['String']['output']>;
  syntheticUseProxy?: Maybe<Scalars['Boolean']['output']>;
  syntheticVoiceIds?: Maybe<Array<Scalars['String']['output']>>;
  syntheticVoiceSimilarityBoost?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceSpeed?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceStability?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceStyle?: Maybe<Scalars['Float']['output']>;
  syntheticWorldview?: Maybe<Scalars['String']['output']>;
  thankyouDescription?: Maybe<Scalars['String']['output']>;
  thankyouText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `syntheticTitles`. */
  titles?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `syntheticWorldview`. */
  worldview?: Maybe<Scalars['String']['output']>;
};

/** A skill pinned to a project as one of its default analyses: its result auto-refreshes after theme processing. Exists independently of whether a result has been generated yet. */
export type ProjectSkillModel = {
  __typename?: 'ProjectSkillModel';
  id: Scalars['ID']['output'];
  /** When the background queue last regenerated this analysis; null if it never ran. */
  lastGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set for org skills; null for system skills. */
  skillId?: Maybe<Scalars['UUID']['output']>;
  /** Set for system skills; null for org skills. */
  systemSkillSlug?: Maybe<Scalars['String']['output']>;
};

/** The data window a skill result was generated over; either bound may be open. */
export type ProjectSkillResultFiltersModel = {
  __typename?: 'ProjectSkillResultFiltersModel';
  since?: Maybe<Scalars['DateTime']['output']>;
  until?: Maybe<Scalars['DateTime']['output']>;
};

/** A generated analysis result for a project: the persisted generative-UI document produced by one skill run (latest per skill). documentJson parses to { theme, blocks[] } — see docs/skill-result-ui-contract.md. */
export type ProjectSkillResultModel = {
  __typename?: 'ProjectSkillResultModel';
  /** Null for background (auto-refresh) generations. */
  createdByUserId?: Maybe<Scalars['UUID']['output']>;
  /** JSON-encoded ViewDocument: { theme, blocks[] }. */
  documentJson: Scalars['String']['output'];
  /** Date window the run was limited to; null = all data. Filtered results are not auto-refreshed. */
  filters?: Maybe<ProjectSkillResultFiltersModel>;
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** A ProjectSkill row exists for this skill on this project — the result auto-refreshes after theme processing. */
  isProjectDefault: Scalars['Boolean']['output'];
  projectId: Scalars['UUID']['output'];
  skillId?: Maybe<Scalars['UUID']['output']>;
  systemSkillSlug?: Maybe<Scalars['String']['output']>;
  /** Total LLM tokens consumed by the generating run. */
  tokensUsed?: Maybe<Scalars['Int']['output']>;
  /** The skill version (skills_audit row) that produced this result; null for system skills. */
  versionId?: Maybe<Scalars['UUID']['output']>;
};

export type ProjectStatsFilterInput = {
  insight?: InputMaybe<QuestionFilterInput>;
  signal?: InputMaybe<Signal>;
  /** Filter insights based on user's read status */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectStatsModel = {
  __typename?: 'ProjectStatsModel';
  /** Global learnt-text summary rolled up over all of the project’s objectives */
  aiLearntText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.anonymous` instead. */
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  /** Average message depth for the project */
  avgMessageDepth?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `settings.calendarLink` instead. */
  calendarLink?: Maybe<Scalars['String']['output']>;
  /** Whether responders may jump forward to later questions. Redesigned builder. */
  canJumpForward?: Maybe<Scalars['Boolean']['output']>;
  canTriggerThemeProcessing?: Maybe<ThemeTriggerProcessingValidationResult>;
  /** Statistics about insights grouped by channel */
  channelStats?: Maybe<Array<ChannelStats>>;
  /** @deprecated Use `settings.contactEmail` instead. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.contactPhone` instead. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Device types this project supports (computer | phone). Redesigned builder. */
  deviceTypes?: Maybe<Array<DeviceType>>;
  /** Estimated time in seconds to complete the survey, derived from question types and AI follow-up depth. Rough upper-bound estimate; branching rules may shorten the actual path. */
  estimatedCompletionTime?: Maybe<Scalars['Int']['output']>;
  /** Date of the first insight after applying filters */
  firstInsightDate?: Maybe<Scalars['DateTime']['output']>;
  /** Whether a problem was reported since the current user last opened the problem feed. */
  hasUnseenProblemReports: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use `settings.inAppPopupMessage` instead. */
  inAppPopupMessage?: Maybe<Scalars['String']['output']>;
  /** Insight count within the `filter.insightActivity` window. Only populated by the projects list query when that filter is set; null otherwise. */
  insightActivityCount?: Maybe<Scalars['Int']['output']>;
  /** How responders interact with the survey (voice | text). Redesigned builder. */
  interactionType?: Maybe<InteractionType>;
  /** @deprecated Use `settings.introText` instead. */
  introText?: Maybe<Scalars['String']['output']>;
  /** The intro video in force for this project: the project's own when introVideoLevel is ProjectLevel, otherwise the org-level default. Null when none is configured at the effective level. */
  introVideo?: Maybe<ResolvedIntroVideo>;
  /** Intros configured for this project. */
  intros: Array<ProjectIntroModel>;
  /** @deprecated Use `settings.isAIFormAssistanceEnabled` instead. */
  isAIFormAssistanceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isAiVoiceEnabled` instead. */
  isAiVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isAnalyticsPublic` instead. */
  isAnalyticsPublic?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the current user has marked this project as a favorite */
  isFavorite: Scalars['Boolean']['output'];
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isForm?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isPoll?: Maybe<Scalars['Boolean']['output']>;
  isProcessingAiLearntText?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the work `triggerThemeProcessing(scope)` would enqueue is already in flight. Takes the same scope: `project` watches the observations rebuild only, `all` (the default) watches both. */
  isProcessingThemes?: Maybe<Scalars['Boolean']['output']>;
  isSample?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isThankyouEnabled` instead. */
  isThankyouEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `settings.isUserVoiceEnabled` instead. */
  isUserVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** Most recent activity on the project: the latest of createdAt, updatedAt and lastResponseDate. */
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of when the current user last read this project's insights, or null if never. */
  lastInsightRead?: Maybe<Scalars['DateTime']['output']>;
  lastResponseDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `objectives` instead */
  learningGoal?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.maxResponses` instead. */
  maxResponses?: Maybe<Scalars['Int']['output']>;
  /** Project-wide median completion progress (0–1) across all channels, after filters. Null when there are no classified insights. */
  medianCompletionRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `interactionType` instead. Redesigned builder (868gc1px2). */
  mode?: Maybe<ProjectMode>;
  objectives?: Maybe<Array<ProjectObjectiveModel>>;
  /** Panel configuration for this project */
  panelConfig?: Maybe<ProjectPanelConfigModel>;
  /** Total responses from the TheySaid panel (RepData) for this project. */
  panelTotalInsights?: Maybe<Scalars['Int']['output']>;
  /** Number of problems respondents reported on this project. */
  problemReportsCount: Scalars['Int']['output'];
  projectThemes?: Maybe<Array<ProjectThemeModel>>;
  /** Sizes of `projectThemes` for the same filter: `total` ignores `minEvidence`, `matching` applies it; neither applies `limit`. */
  projectThemesCounts: ProjectThemesCountsModel;
  publicTitle?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<QuestionV2Model>>;
  /** Recruiting progress for the project: completed testers (each cohort capped at its quantity) over total ordered, where a stopped or failed cohort counts only its capped completes since it will never fill. activeOnly false (default): every cohort of placed and completed orders. activeOnly true: only running cohorts (the recruitingOrderLineItems activeOnly set), zero/zero once nothing is running. Zero/zero when the project has no such cohorts. */
  recruitingRollup: RecruitingProjectRollup;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Statistics about insights grouped by Human / Synthetic responder */
  responderStats?: Maybe<Array<ResponderStats>>;
  /** Statistics about insights grouped by the channel they are shown under (Recruit covers both panels) */
  responseChannelStats?: Maybe<Array<ResponseChannelStats>>;
  /** @deprecated Use `settings.reviewLink` instead. */
  reviewLink?: Maybe<Scalars['String']['output']>;
  /** Screener respondents must pass before taking this project. Null when the project has none. */
  screener?: Maybe<ProjectScreenerModel>;
  settings?: Maybe<ProjectSettingsModel>;
  /** Statistics for this project (same data as the top-level projectStats query). */
  stats: ProjectStatsModel;
  status?: Maybe<ProjectStatus>;
  /** @deprecated Use `settings.supportEmail` instead. */
  supportEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.supportLink` instead. */
  supportLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `settings.supportPhone` instead. */
  supportPhone?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tag>>;
  /** @deprecated Use `settings.thankyouText` instead. */
  thankyouText?: Maybe<Scalars['String']['output']>;
  themeSettings?: Maybe<ProjectFrontendThemeSettings>;
  title?: Maybe<Scalars['String']['output']>;
  /** Total number of growth signals for the project */
  totalGrowthSignals?: Maybe<Scalars['Int']['output']>;
  /** Total number of insights for the project */
  totalInsights?: Maybe<Scalars['Int']['output']>;
  /** Total number of risk signals for the project */
  totalRiskSignals?: Maybe<Scalars['Int']['output']>;
  /** Total number of unread insights for the project */
  totalUnreadInsights?: Maybe<Scalars['Int']['output']>;
  /** `aiLearntText` translated into the project language (non-English projects only) */
  translatedAiLearntText?: Maybe<Scalars['String']['output']>;
  /**
   * NULL = redesigned builder experience
   * @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field; NULL still discriminates the new experience.
   */
  type?: Maybe<ProjectType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Widget configuration for this project */
  widgetConfig?: Maybe<ProjectWidgetConfigModel>;
};

export type ProjectStatsModelIsProcessingThemesArgs = {
  scope?: InputMaybe<ThemeProcessingScope>;
};

export type ProjectStatsModelProjectThemesArgs = {
  filter?: InputMaybe<ProjectThemeFilterInput>;
};

export type ProjectStatsModelProjectThemesCountsArgs = {
  filter?: InputMaybe<ProjectThemeFilterInput>;
};

export type ProjectStatsModelQuestionsArgs = {
  filter?: InputMaybe<QuestionsFilterInput>;
};

export type ProjectStatsModelRecruitingRollupArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectStatsModelStatsArgs = {
  filters?: InputMaybe<ProjectStatsFilterInput>;
};

export type ProjectStatsModelTotalInsightsArgs = {
  filter?: InputMaybe<TotalInsightsFilterInput>;
};

/** The status of the project */
export const ProjectStatus = {
  Archived: 'Archived',
  Published: 'Published',
  Unpublished: 'Unpublished',
} as const;

export type ProjectStatus = (typeof ProjectStatus)[keyof typeof ProjectStatus];
export type ProjectThemeFilterInput = {
  /** Return at most this many observations (after ordering); null returns all. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Only observations backed by at least this many distinct responses. Critical and user-authored observations are always kept. */
  minEvidence?: InputMaybe<Scalars['Int']['input']>;
  /** Consolidation scope to list. Defaults to `question` — observations consolidated within a single question, the historical behaviour of this field. `project` returns the project-wide consolidation of the same evidence. */
  scope?: InputMaybe<ThemeScope>;
  /** Filter themes that have messages created after this date */
  since?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter themes that have messages created before this date */
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectThemeModel = {
  __typename?: 'ProjectThemeModel';
  /** Deprecated: use `impact`. Evidence-volume-derived confidence; null for user-created observations. */
  confidence?: Maybe<ThemeConfidence>;
  counterTheme?: Maybe<CounterThemeModel>;
  /** DB row creation time of this observation. The FE shows a "new" pill when this is after the project's lastObservationsSeen. Note: this is row createdAt, not a per-user "first surfaced" time — it does not account for observations crossing the evidence floor later, and resets when observations are rebuilt. */
  createdAt: Scalars['DateTime']['output'];
  /** Why the observation is Critical; null unless `impact` is critical. */
  criticalCategory?: Maybe<ObservationCriticalCategory>;
  /** A short one-to-three sentence description of the theme (concise counterpart to `summary`). */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** AI-evaluated impact; evidence-volume fallback until the observation is classified. Null for user-created observations. */
  impact?: Maybe<ObservationImpact>;
  /** The AI's reason for `impact`; null until classified. */
  impactReason?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** AI-generated vs user-created observation. */
  origin: ThemeOrigin;
  /** Set when the observation was re-interpreted with user context. */
  refinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Latest user-provided context from the refine ("Add Context") flow. */
  reviewContext?: Maybe<Scalars['String']['output']>;
  /** Observation review decision; rejected observations are excluded from generated skill results. */
  reviewStatus: ThemeReviewStatus;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether this observation was consolidated within one question or across the project. */
  scope: ThemeScope;
  sentiment?: Maybe<Signal>;
  strategicRecos?: Maybe<Array<ProjectThemeStrategicRecoModel>>;
  summary?: Maybe<Scalars['String']['output']>;
  totalInsights: Scalars['Int']['output'];
  /** `description` translated into the project language (non-English projects only) */
  translatedDescription?: Maybe<Scalars['String']['output']>;
  /** `name` translated into the project language (non-English projects only) */
  translatedName?: Maybe<Scalars['String']['output']>;
  /** `summary` translated into the project language (non-English projects only) */
  translatedSummary?: Maybe<Scalars['String']['output']>;
};

export type ProjectThemeStrategicRecoModel = {
  __typename?: 'ProjectThemeStrategicRecoModel';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  /** `text` translated into the project language (non-English projects only) */
  translatedText?: Maybe<Scalars['String']['output']>;
};

export type ProjectThemesCountsModel = {
  __typename?: 'ProjectThemesCountsModel';
  /** Observations passing `minEvidence`, before `limit`. */
  matching: Scalars['Int']['output'];
  /** Observations in scope, before `minEvidence` and `limit`. */
  total: Scalars['Int']['output'];
};

/** The type of project */
export const ProjectType = {
  Interview: 'Interview',
  Poll: 'Poll',
  Pulse: 'Pulse',
  Survey: 'Survey',
  UsabilityTesting: 'UsabilityTesting',
} as const;

export type ProjectType = (typeof ProjectType)[keyof typeof ProjectType];
/** Whether a project video row backs a clip or a reel */
export const ProjectVideoType = {
  Clip: 'Clip',
  Reel: 'Reel',
} as const;

export type ProjectVideoType =
  (typeof ProjectVideoType)[keyof typeof ProjectVideoType];
export type ProjectWidgetConfigModel = {
  __typename?: 'ProjectWidgetConfigModel';
  allowedFilters: Array<WidgetConfigFilter>;
  createdAt: Scalars['DateTime']['output'];
  deviceTypes: Array<WidgetDeviceType>;
  id: Scalars['ID']['output'];
  /** The intercept image (asset info + signed URL), or null if none is set. */
  imageAsset?: Maybe<WidgetImageAsset>;
  importance: WidgetImportance;
  isEnabled: Scalars['Boolean']['output'];
  pageLocationType: WidgetPageLocationType;
  pageLocationUrl?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  triggerCssSelector?: Maybe<Scalars['String']['output']>;
  triggerType: WidgetTriggerType;
  updatedAt: Scalars['DateTime']['output'];
  userSegments?: Maybe<Array<Scalars['String']['output']>>;
  utInWidgetEnabled: Scalars['Boolean']['output'];
};

export type ProviderData = {
  __typename?: 'ProviderData';
  email?: Maybe<Scalars['String']['output']>;
};

export type PublishPanelInput = {
  projectId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  apiDoc: ApiDoc;
  apiKeys: Array<Apikey>;
  /** Returns every possible errorCode this GraphQL surface can return on an error response. Use for tooling / explorer enumeration. */
  availableErrorCodes: Array<ErrorCode>;
  /** Get all companies associated with the current user */
  companies: Array<Organization>;
  /**
   * Get all companies associated with the current user
   * @deprecated Use companies instead
   */
  companiesV2: Array<OrganizationWithRole>;
  /** A session's artifacts. */
  companionArtifacts: PaginatedCompanionArtifacts;
  /** A session's chain-of-thought messages in chronological order. */
  companionMessages: PaginatedCompanionMessages;
  /** The output personas the client can offer for a companion turn. Each changes only the narration STYLE (tone/voice); send the chosen id back as CompanionMessageInput.personaId. The default persona leaves the base voice unchanged. */
  companionPersonas: Array<CompanionPersona>;
  /** Starter prompts for the companion: a fixed static catalog plus, when enabled for the org, dynamic suggestions computed from the org's live activity. Scoped to the authenticated organization. */
  companionPromptSuggestions: Array<CompanionPromptSuggestion>;
  /** One companion session owned by the caller. */
  companionSession: CompanionSession;
  /** Suggest a short conversation name from the session's history. Read-only — does not persist; the client decides whether to save it via updateCompanionSession. */
  companionSessionNameSuggestion?: Maybe<Scalars['String']['output']>;
  /** The caller's companion sessions in the current organization, most recent first. */
  companionSessions: PaginatedCompanionSessions;
  /** @deprecated This query is deprecated and will be removed in a future version. Use companies query instead. */
  companyInfo: Organization;
  /** Get all connected and active integration providers for the organization */
  connectedIntegrationProviders: Array<IntegrationProviderModel>;
  connectionRule: QuestionConnectionRuleModel;
  /** One contact (respondent) of the organization with response stats and their most recent responses — the data behind the contact detail panel opened from a skill result. */
  contact: ContactDetailModel;
  /** Paginated list of the organization's contacts (respondents), most recently active first, with per-contact response counts. Supports a name/email search. */
  contacts: PaginatedContacts;
  /** Get the current authenticated user. */
  currentUser: CurrentUser;
  /** Get all project-specific integration settings for a provider that have custom channels. */
  customizedProjectIntegrationSettings: Array<ProjectChannelSetting>;
  /** Curated default voice catalog (50 hand-picked voices). Same shape as syntheticVoices; ids are re-validated against ElevenLabs once a day and stale ones are dropped. */
  defaultSyntheticVoices: SyntheticVoicePage;
  /** Get a document by id for the current organization */
  document: DocumentAsset;
  /** Get a signed URL for accessing a document */
  documentLink: DocumentLink;
  /** List documents for an organization */
  documents: PaginatedDocuments;
  /** Get one download by id (org-scoped). Poll while status is pending/processing; url is a fresh signed link once complete. */
  download: Download;
  /** Get all downloads for the organization */
  downloads: Array<Download>;
  /** Advisory suggested incentive range for a human audience. Never blocks placement. */
  estimateRecruitingIncentive: RecruitingIncentiveEstimate;
  /** Format voice transcript for specific question type */
  formattedTranscriptAnswer: FormatTranscriptResponse;
  generateOpenEndedQuestionResponse: GenerateOpenEndedQuestionResponse;
  /** Get list of URLs that should be excluded from iframes */
  iframeExcludedUrls: Array<Scalars['String']['output']>;
  importSurvey: SharedImportSurveyResponse;
  /** Get insight by message ID */
  insightByMessageId?: Maybe<InsightV2>;
  insightV2: InsightV2;
  /** Get all insights for the project */
  insightsV2: PaginatedInsightsV2;
  /** Get all available integration providers with their connection and active status */
  integrationProviders: Array<IntegrationProviderModel>;
  /** Get a paginated list of users. */
  invitations: PaginatedInvitations;
  /** List messages for a specific question within an insight */
  messagesByQuestionV2: PaginatedMessagesV2;
  /** List messages for an insight */
  messagesV2: PaginatedMessagesV2;
  /** Poll a preview started by previewModeratorVoiceRecording. Returns status (processing/complete/error) and, once complete, the synthesized audio. */
  moderatorVoicePreview: ModeratorVoicePreviewResult;
  moderatorVoices: Array<ModeratorVoiceAsset>;
  /**
   * Return a list of recommended questions for new users.
   * @deprecated Use `onboardingQuestionTemplatesV2` instead. This endpoint will be removed in a future release.
   */
  onboardingQuestionTemplates: Array<QuestionTemplate>;
  /** Return a list of recommended questions for new users with V2 structure. */
  onboardingQuestionTemplatesV2: Array<QuestionTemplateV2Model>;
  /** Word frequencies for open ended questions */
  openEndedQuestionPhrases?: Maybe<Array<OpenEndedQuestionPhraseModel>>;
  optionAsset: QuestionOptionAssetModel;
  /** Get a signed URL for accessing an organization intro video. */
  orgIntroVideoLink: OrgIntroVideoLink;
  /** List intro videos for the organization. */
  orgIntroVideos: Array<OrgIntroVideoAsset>;
  /** Get organization settings */
  orgSettings?: Maybe<OrganizationSettings>;
  /** The organization's account credit available for new recruiting orders in one currency, in its minor units (cents): the ledger balance minus credit reserved by orders awaiting payment, both in that currency only. */
  organizationCreditBalance: Scalars['Int']['output'];
  /** The organization's account credit history, newest first: top-ups, credit applied to recruiting orders, refunds of cancelled cohorts and manual adjustments, each with a signed amount in minor units. */
  organizationCreditLedger: PaginatedCreditLedgerEntries;
  pollResults?: Maybe<PollResultOutput>;
  /** Get Open Graph preview data for a URL */
  previewUrl: UrlPreview;
  /** Return a project by ID. */
  project: ProjectModel;
  /** Get a project document by id. */
  projectDocument: ProjectDocumentAsset;
  /** Get a signed URL for accessing a project document. */
  projectDocumentLink: ProjectDocumentLink;
  /** List documents for a project. */
  projectDocuments: PaginatedProjectDocuments;
  /** Retrieve a cached project draft by draft project type. Use DraftProjectType to distinguish between survey, poll, form, and usability testing drafts. Returns null if no draft exists or if it has expired. */
  projectDraft?: Maybe<ProjectDraft>;
  /** Get a single project video by ID (includes slim clip or reel with scenes) */
  projectHighlightVideo?: Maybe<ProjectHighlightVideoModel>;
  /** Paginated project videos (clips and reels). Filter videoType=clip for clips only. Requires filter.projectId. */
  projectHighlightVideos: PaginatedType;
  /** Get a signed URL for accessing a project intro video. */
  projectIntroVideoLink: ProjectIntroVideoLink;
  /** List intro videos for a project. */
  projectIntroVideos: Array<ProjectIntroVideoAsset>;
  /** Panel configuration for a specific project */
  projectPanelConfig?: Maybe<ProjectPanelConfigModel>;
  /** Problems respondents reported on a project, newest first (the project's problem feed). */
  projectProblemReports: Array<ProjectProblemReportModel>;
  /** A project's analysis results: the latest generated result per skill, newest first. */
  projectSkillResults: Array<ProjectSkillResultModel>;
  /** Skills pinned to this project (a ProjectSkill row exists), whether or not a result has been generated yet. */
  projectSkills: Array<ProjectSkillModel>;
  /** Get statistics for a specific project */
  projectStats: ProjectStatsModel;
  /** Get widget configuration for a specific project */
  projectWidgetConfig?: Maybe<ProjectWidgetConfigModel>;
  /** Return a paginated list of projects. */
  projects: PaginatedProjects;
  /** Get provider data for a specific provider */
  providerData?: Maybe<ProviderData>;
  /** RepData qualifications list for panel targeting (country, language, pagination) */
  qualifications: RepDataQualificationsResponseModel;
  questionAsset: QuestionAssetModel;
  /** Paginated insight question reports for a question. */
  questionReports: PaginatedQuestionReports;
  /**
   * Return a list of industry standard questions.
   * @deprecated Use `questionTemplatesV2` instead. This endpoint will be removed in a future release.
   */
  questionTemplates: Array<QuestionTemplate>;
  /** Return a list of industry standard questions with V2 structure. */
  questionTemplatesV2: Array<QuestionTemplateV2Model>;
  /** Paginated messages for a specific theme and question combination. Accepts the same optional insight-level filters as questionThemes so the drill-down stays scoped to the selected window. */
  questionThemeMessages: PaginatedQuestionThemeMessages;
  /** Paginated project themes for a question, with messages and strategic recommendations per theme. Accepts optional insight-level filters (date range, progress, channels) to scope themes to the same window as the respondent counter. */
  questionThemes: PaginatedQuestionThemes;
  questionsV2: Array<QuestionV2Model>;
  /** Return a single recruiting audience by id. */
  recruitingAudience: RecruitingAudience;
  /** Return a paginated list of the organization's recruiting audiences, newest first, filtered by side and name. */
  recruitingAudiences: PaginatedRecruitingAudiences;
  /** Return a single recruiting order with its cohorts. */
  recruitingOrder: RecruitingOrder;
  /** Return a paginated, flat list of the organization's cohorts (order line items) across orders, newest first, each with its order summary; filterable by project, order, audience type, derived cohort status and order status (activeOnly for running cohorts), searchable by project title or source audience name. */
  recruitingOrderLineItems: PaginatedRecruitingOrderLineItems;
  /** Return a paginated list of the organization's recruiting orders, newest first, with their cohorts; filterable by project and derived status (as returned), searchable by project title. */
  recruitingOrders: PaginatedRecruitingOrders;
  /** Research ideas for the caller's org, minus the dismissed ones: AI-generated from its company profile and project learnings, or the default ideas until the org has a generated set (at most 5). */
  researchRecommendations: Array<ResearchRecommendation>;
  /** Responses per local day across the organization's non-sample projects: this week and the last seven days, each with the matching days a week earlier. Served from a snapshot refreshed every few minutes. */
  responseActivity: ResponseActivityModel;
  /** Get current server time in ISO format */
  serverTime: Scalars['String']['output'];
  /** Get a signed URL for an existing file in storage */
  signedUrl: SignedUrl;
  /** The org's skills of one scope (analysis when omitted): system skills first, then org skills. */
  skills: Array<SkillModel>;
  /** Paginated list of Slack channels for the current org. Returns an empty page with no cursor when Slack is not connected. */
  slackChannels: SlackChannelsPage;
  stripeProduct: StripeProduct;
  stripeProducts: StripeProducts;
  /** Suggest a one-sentence description for an audience profile (saved or an unsaved draft) from its human filters and synthetic traits. Nothing is saved: send the text as description on create/update. RECRUITING_AUDIENCES_DESCRIPTION_UNAVAILABLE (503) when no suggestion can be made right now. */
  suggestRecruitingAudienceDescription: RecruitingAudienceDescriptionSuggestion;
  /** RepData survey object definitions (countries, time zones, statuses, etc.) for panel config UI. Cached 24h. */
  surveyObjectDefinitions: RepDataSurveyObjectDefinitionsModel;
  syntheticPersonalityCatalog: Array<PersonalityDimensionCatalog>;
  /** Paginated, searchable ElevenLabs voice catalog for the synthetic voice picker. */
  syntheticVoices: SyntheticVoicePage;
  /** GCS keys of the platform-default (system) intro videos. */
  systemIntroVideos: SystemIntroVideos;
  /** Return all tags for the organization. */
  tagsV2: Array<Tag>;
  /** Return a project by ID if it belongs to a temporary organization. */
  tempProject: ProjectModel;
  /** Return a template by ID. */
  template: TemplateModel;
  /** Return all template tags. */
  templateTags: Array<Tag>;
  /** Return a paginated list of templates. */
  templates: PaginatedTemplates;
  /** A single observation (theme) by id, scoped to the caller's organization — no project id needed. Errors with THEME_NOT_FOUND when the id is unknown or in another org. */
  theme: ProjectThemeModel;
  /** List messages for a specific theme */
  themeMessages: PaginatedThemeMessages;
  /** The connected ticketing account (the user the agent comments as). */
  ticketAgentAccount: TicketAgentAccountModel;
  /** List the ticketing scopes (spaces/projects/boards) the org can subscribe the ticket-agent to. */
  ticketAgentScopes: Array<TicketScopeModel>;
  /** Status names a ticket in the scope can move into — options for the status trigger. */
  ticketAgentStatuses: Array<Scalars['String']['output']>;
  /** List the org’s active ticket-agent subscriptions. */
  ticketAgentSubscriptions: Array<TicketAgentSubscriptionModel>;
  /** Required primary questions the preview run has not answered yet. */
  unifiedPreviewCompletionStatus: UnifiedPreviewCompletionStatus;
  /** Preview transcript for resume rendering, optionally filtered to one question. The preview twin of insightV2.messages(questionID). */
  unifiedPreviewMessages: Array<MessageV2>;
  /** Get a paginated list of users. */
  users: PaginatedUsers;
};

export type QueryCompanionArtifactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type QueryCompanionMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type QueryCompanionSessionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCompanionSessionNameSuggestionArgs = {
  sessionId: Scalars['ID']['input'];
};

export type QueryCompanionSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryConnectionRuleArgs = {
  id: Scalars['String']['input'];
};

export type QueryContactArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCustomizedProjectIntegrationSettingsArgs = {
  providerKey: Scalars['String']['input'];
};

export type QueryDefaultSyntheticVoicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDocumentLinkArgs = {
  id: Scalars['String']['input'];
};

export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DocumentListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentOrder>;
};

export type QueryDownloadArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryDownloadsArgs = {
  filter: ProjectInsightsDownloadsFilterInput;
};

export type QueryEstimateRecruitingIncentiveArgs = {
  input: EstimateRecruitingIncentiveInput;
};

export type QueryFormattedTranscriptAnswerArgs = {
  input: FormatTranscriptInput;
};

export type QueryGenerateOpenEndedQuestionResponseArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  questionText: Scalars['String']['input'];
};

export type QueryImportSurveyArgs = {
  method: ImportSurveyMethod;
  payload: Scalars['String']['input'];
};

export type QueryInsightByMessageIdArgs = {
  messageId: Scalars['UUID']['input'];
};

export type QueryInsightV2Args = {
  id: Scalars['UUID']['input'];
};

export type QueryInsightsV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter: InsightV2ListFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InsightOrder>;
};

export type QueryIntegrationProvidersArgs = {
  filter?: InputMaybe<IntegrationProvidersFilter>;
};

export type QueryInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMessagesByQuestionV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter: MessageListByQuestionFilterInputV2;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMessagesV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter: MessageListFilterInputV2;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryModeratorVoicePreviewArgs = {
  previewId: Scalars['String']['input'];
};

export type QueryOpenEndedQuestionPhrasesArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryOptionAssetArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryOrgIntroVideoLinkArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOrganizationCreditBalanceArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOrganizationCreditLedgerArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<CreditLedgerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPollResultsArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryPreviewUrlArgs = {
  input: UrlPreviewInput;
};

export type QueryProjectArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryProjectDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProjectDocumentLinkArgs = {
  id: Scalars['String']['input'];
};

export type QueryProjectDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProjectDocumentListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectDocumentOrder>;
  projectId: Scalars['ID']['input'];
};

export type QueryProjectDraftArgs = {
  draftType: DraftProjectType;
};

export type QueryProjectHighlightVideoArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryProjectHighlightVideosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter: ProjectHighlightVideosListFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectHighlightVideoOrder>;
};

export type QueryProjectIntroVideoLinkArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProjectIntroVideosArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryProjectPanelConfigArgs = {
  projectId: Scalars['UUID']['input'];
};

export type QueryProjectProblemReportsArgs = {
  projectId: Scalars['UUID']['input'];
};

export type QueryProjectSkillResultsArgs = {
  projectId: Scalars['UUID']['input'];
};

export type QueryProjectSkillsArgs = {
  projectId: Scalars['UUID']['input'];
};

export type QueryProjectStatsArgs = {
  filters?: InputMaybe<ProjectStatsFilterInput>;
  id: Scalars['UUID']['input'];
};

export type QueryProjectWidgetConfigArgs = {
  projectId: Scalars['UUID']['input'];
};

export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProjectListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectOrder>;
};

export type QueryProviderDataArgs = {
  providerKey: Scalars['String']['input'];
};

export type QueryQualificationsArgs = {
  filter: RepDataQualificationsFilterInput;
};

export type QueryQuestionAssetArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryQuestionReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters?: InputMaybe<QuestionFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFrustrated?: InputMaybe<Scalars['Boolean']['input']>;
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<QuestionReportOrder>;
  questionId: Scalars['UUID']['input'];
};

export type QueryQuestionThemeMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters?: InputMaybe<QuestionFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['UUID']['input'];
  themeId: Scalars['UUID']['input'];
};

export type QueryQuestionThemesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filters?: InputMaybe<QuestionFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minEvidence?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['UUID']['input'];
};

export type QueryQuestionsV2Args = {
  input: QuestionsV2Input;
};

export type QueryRecruitingAudienceArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryRecruitingAudiencesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<RecruitingAudienceListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRecruitingOrderArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryRecruitingOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<RecruitingOrderLineItemListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRecruitingOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<RecruitingOrderListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryResponseActivityArgs = {
  input: ResponseActivityInput;
};

export type QuerySignedUrlArgs = {
  input: GetSignedUrlInput;
};

export type QuerySkillsArgs = {
  scope?: InputMaybe<SkillScope>;
};

export type QuerySlackChannelsArgs = {
  input?: InputMaybe<SlackChannelsInput>;
};

export type QueryStripeProductArgs = {
  id: Scalars['String']['input'];
};

export type QueryStripeProductsArgs = {
  filter?: InputMaybe<StripeProductFilterInput>;
};

export type QuerySuggestRecruitingAudienceDescriptionArgs = {
  input: SuggestRecruitingAudienceDescriptionInput;
};

export type QuerySyntheticVoicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTempProjectArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryTemplateArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProjectListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectOrder>;
};

export type QueryThemeArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryThemeMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter: ThemeMessagesFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ThemeMessageOrder>;
};

export type QueryTicketAgentAccountArgs = {
  provider: Scalars['String']['input'];
};

export type QueryTicketAgentScopesArgs = {
  provider: Scalars['String']['input'];
};

export type QueryTicketAgentStatusesArgs = {
  provider: Scalars['String']['input'];
  scopeId: Scalars['String']['input'];
};

export type QueryUnifiedPreviewCompletionStatusArgs = {
  projectId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type QueryUnifiedPreviewMessagesArgs = {
  projectId: Scalars['UUID']['input'];
  questionID?: InputMaybe<Scalars['UUID']['input']>;
  sessionId: Scalars['UUID']['input'];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionAnsweredFilter = {
  /** Answers to match for this question. An empty list matches any answer (i.e., the question was answered at all). */
  answers: Array<Scalars['String']['input']>;
  /** Per-question matching. Accepted values: IS, IS_NOT. */
  matchingType: MatchingType;
  /** Question to filter against. */
  questionId: Scalars['UUID']['input'];
};

export type QuestionAssetModel = {
  __typename?: 'QuestionAssetModel';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type QuestionConnectionRuleModel = {
  __typename?: 'QuestionConnectionRuleModel';
  activationData?: Maybe<Scalars['String']['output']>;
  activationType: RuleActivationType;
  aiFollowup?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  postActivationActionData?: Maybe<Scalars['String']['output']>;
  postActivationActionType: RuleActionType;
  preActivationActionData?: Maybe<Scalars['String']['output']>;
  preActivationActionType?: Maybe<RuleActionType>;
  sourceQuestion: QuestionV2;
  targetQuestion?: Maybe<QuestionV2>;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionFilterInput = {
  channels?: InputMaybe<Array<Channel>>;
  /** @deprecated No longer applied */
  chatSizes?: InputMaybe<Array<ChatSize>>;
  insightRead?: InputMaybe<Scalars['Boolean']['input']>;
  maxProgress?: InputMaybe<Scalars['Float']['input']>;
  minProgress?: InputMaybe<Scalars['Float']['input']>;
  qualities?: InputMaybe<Array<InsightQuality>>;
  /** Filter by Human / Synthetic responder. */
  responderTypes?: InputMaybe<Array<ResponderType>>;
  /** Filter by the channel a response is shown under (Recruit covers both panels). */
  responseChannels?: InputMaybe<Array<ResponseChannel>>;
  /** Search in email, name and summary. Minimum 2 characters required. */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionFiltersInput = {
  insight?: InputMaybe<QuestionFilterInput>;
};

export type QuestionOptionAssetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type QuestionOptionAssetModel = {
  __typename?: 'QuestionOptionAssetModel';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type QuestionOptionInput = {
  assets?: InputMaybe<Array<QuestionOptionAssetInput>>;
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type QuestionOrderInput = {
  order: Scalars['Int']['input'];
  questionId: Scalars['ID']['input'];
};

export type QuestionReportModel = {
  __typename?: 'QuestionReportModel';
  answerTime?: Maybe<Scalars['Float']['output']>;
  /** Parsed sub-question answers for matrix questions. Null when the parent question is non-matrix or the stored value cannot be parsed. */
  answeredSubQuestions?: Maybe<Array<SubQuestionAnswer>>;
  /** Raw answer value. For non-matrix questions: a scalar string (e.g. "4" for Rating, comma-joined for MultipleChoice/Ranking, free text for OpenEnded). For matrix questions: a JSON string of the form [{"sqId":"<uuid>","v":"<rating|NA>"}, ...]. Prefer answeredSubQuestions for matrix consumers. */
  answeredValue?: Maybe<Scalars['String']['output']>;
  /** Signed URL for the AI tester's avatar (AIT insights only; null for humans/older insights). Safe to use directly in an <img>. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Contact associated with the insight for this question report */
  contact?: Maybe<Contact>;
  id: Scalars['UUID']['output'];
  /** Important phrases (insight word frequency) for this user/insight for the question */
  importantPhrases?: Maybe<Array<Scalars['String']['output']>>;
  insightId: Scalars['UUID']['output'];
  /**
   * Whether the user showed frustration on this question (based on negative signal in assistant-question messages)
   * @deprecated Frustration metrics are being removed. This field always returns null.
   */
  isFrustrated?: Maybe<Scalars['Boolean']['output']>;
  questionId?: Maybe<Scalars['UUID']['output']>;
  /** Who gave the response: Synthetic for AI testers, Human otherwise */
  responderType: ResponderType;
  /** Whether the user completed the task successfully (for Task questions, from success follow-up response) */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** English translation of answeredValue; set only for open-ended answers on non-English projects. */
  translatedAnsweredValue?: Maybe<Scalars['String']['output']>;
};

export type QuestionReportOrder = {
  direction: OrderDirection;
  field: QuestionReportOrderField;
};

/** Fields to order question reports by */
export const QuestionReportOrderField = {
  AnswerTime: 'ANSWER_TIME',
  CreatedAt: 'CREATED_AT',
} as const;

export type QuestionReportOrderField =
  (typeof QuestionReportOrderField)[keyof typeof QuestionReportOrderField];
export type QuestionTemplate = {
  __typename?: 'QuestionTemplate';
  primaryQuestion: Scalars['String']['output'];
  ratingLabels: Array<Scalars['String']['output']>;
  ratingMinValue: Scalars['Int']['output'];
  tagName: Scalars['String']['output'];
};

export type QuestionTemplateOptionV2Model = {
  __typename?: 'QuestionTemplateOptionV2Model';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionTemplateV2Model = {
  __typename?: 'QuestionTemplateV2Model';
  aiConvoDepth?: Maybe<Scalars['Int']['output']>;
  maxSelections?: Maybe<Scalars['Int']['output']>;
  optionRenderType: OptionRenderType;
  options?: Maybe<Array<QuestionTemplateOptionV2Model>>;
  randomize?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: QuestionType;
};

export type QuestionThemeItemModel = {
  __typename?: 'QuestionThemeItemModel';
  /** Impact of the theme: the AI rating when there is one, else derived from its evidence volume. */
  impact?: Maybe<ObservationImpact>;
  /** Theme sentiment */
  sentiment?: Maybe<Signal>;
  /** Strategic recommendations for this theme */
  strategicRecos: Array<QuestionThemeStrategicRecoModel>;
  /** Detailed LLM-generated summary of the theme */
  summary?: Maybe<Scalars['String']['output']>;
  /** Project theme id */
  themeId: Scalars['ID']['output'];
  /** Project theme name */
  themeName: Scalars['String']['output'];
  /** Total number of messages linked to this theme and question */
  totalMessages: Scalars['Int']['output'];
  /** English translation of the theme name */
  translatedName?: Maybe<Scalars['String']['output']>;
  /** English translation of the theme summary */
  translatedSummary?: Maybe<Scalars['String']['output']>;
};

export type QuestionThemeMessageModel = {
  __typename?: 'QuestionThemeMessageModel';
  /** The AI-processed message content */
  aiProcessedText?: Maybe<Scalars['String']['output']>;
  /** Offset in milliseconds from the recording start at which this response message began (its insight recording event). Fallback for recordingOffsetMs; null when the message has no recording event. */
  answerStartMs?: Maybe<Scalars['Int']['output']>;
  /** Time in seconds the user took to answer the question */
  answerTime?: Maybe<Scalars['Float']['output']>;
  assets?: Maybe<Array<QuestionAssetModel>>;
  /** Signed URL for the AI tester's avatar (AIT insights only; null for human responders / older insights). Safe to use directly in an <img>. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The message content (deprecated - use text instead)
   * @deprecated Use text field instead
   */
  content?: Maybe<Scalars['String']['output']>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** The message creation date */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The insight ID associated with this message */
  insightId?: Maybe<Scalars['UUID']['output']>;
  messageAssets?: Maybe<Array<MessageAssetModel>>;
  metadata?: Maybe<MessageMetadataV2>;
  /** Appetize.io embed URL for Mobile App question messages. Loaded by the survey FE to render the iframe. */
  mobileAppEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** Original filename of the uploaded mobile app. Display only. */
  mobileAppFileName?: Maybe<Scalars['String']['output']>;
  /** The type of option render */
  optionRenderType?: Maybe<OptionRenderType>;
  /** Offset in milliseconds from the recording start at which this quote was spoken; null when no timed transcript exists or the quote could not be located */
  recordingOffsetMs?: Maybe<Scalars['Int']['output']>;
  /** The sender of the message */
  sender: MessageSender;
  subQuestions?: Maybe<Array<SubQuestionModel>>;
  /** The message content */
  text: Scalars['String']['output'];
  /** Unformatted answer (transcript for voice messages) */
  transcript?: Maybe<Scalars['String']['output']>;
  /** English translation of the message, when the project language is not English */
  translatedText?: Maybe<Scalars['String']['output']>;
};

export type QuestionThemeStrategicRecoModel = {
  __typename?: 'QuestionThemeStrategicRecoModel';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  /** English translation of the strategic reco text */
  translatedText?: Maybe<Scalars['String']['output']>;
};

export type QuestionTurnPreviewResponse = {
  __typename?: 'QuestionTurnPreviewResponse';
  actions?: Maybe<SurveyActions>;
  /** Whether the whole survey is complete */
  isConversationOver: Scalars['Boolean']['output'];
  /** Whether this question session is complete */
  isQuestionComplete: Scalars['Boolean']['output'];
  /** The next primary question to open, set when the session completed and the survey continues */
  nextQuestion?: Maybe<QuestionV2>;
  /** The next prompt inside this question session (follow-up or re-ask) */
  reply?: Maybe<MessageV2>;
  /** Conversational feedback shown before the next prompt */
  replyFeedback?: Maybe<MessageV2>;
  /** Progress of the survey (0-1) */
  surveyProgress: Scalars['Float']['output'];
  /** Terminal thank-you message, set when the survey completed on this call */
  thankYouMessage?: Maybe<MessageV2>;
};

/** The type of question */
export const QuestionType = {
  Message: 'Message',
  MultipleChoice: 'MultipleChoice',
  OpenEnded: 'OpenEnded',
  Ranking: 'Ranking',
  Rating: 'Rating',
  Task: 'Task',
} as const;

export type QuestionType = (typeof QuestionType)[keyof typeof QuestionType];
export type QuestionV2 = {
  __typename?: 'QuestionV2';
  aiConvoDepth?: Maybe<Scalars['Int']['output']>;
  aiInsights?: Maybe<Scalars['Boolean']['output']>;
  assets?: Maybe<Array<QuestionAssetModel>>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Per-question voice|text override; null inherits the project. */
  interactionType?: Maybe<InteractionType>;
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  /** Appetize.io embed URL for Mobile App questions (UT projects). Loaded by survey FE at runtime. */
  mobileAppEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** Original filename of the uploaded mobile app. Display only. */
  mobileAppFileName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `maxSelections` instead. */
  multipleSelect?: Maybe<Scalars['Boolean']['output']>;
  notApplicableLabel?: Maybe<Scalars['String']['output']>;
  optionRenderType: OptionRenderType;
  options?: Maybe<Array<QuestionV2Option>>;
  questionOrder: Scalars['Int']['output'];
  randomize?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  showLiveDistribution?: Maybe<Scalars['Boolean']['output']>;
  subQuestions?: Maybe<Array<SubQuestionModel>>;
  tags?: Maybe<Array<Tag>>;
  text: Scalars['String']['output'];
  /** English translation of the question text */
  translatedText?: Maybe<Scalars['String']['output']>;
  type: QuestionType;
  /** Voice-ready rewrite of the question (options included) for moderator TTS. Null until the voice-text job has run; fall back to `text`. */
  voiceText?: Maybe<Scalars['String']['output']>;
};

export type QuestionV2Model = {
  __typename?: 'QuestionV2Model';
  aiConvoDepth?: Maybe<Scalars['Int']['output']>;
  aiInsights?: Maybe<Scalars['Boolean']['output']>;
  assets?: Maybe<Array<QuestionAssetModel>>;
  /** Average time (in seconds) the user took to answer the question (for usability-testing projects only) */
  avgAnswerTime?: Maybe<Scalars['Float']['output']>;
  /**
   * Proportion of insight question reports where the user was frustrated (frustrated count / total reports for this question)
   * @deprecated Frustration metrics are being removed. This field always returns null.
   */
  avgFrustration?: Maybe<Scalars['Float']['output']>;
  /** Average score for the question */
  avgScore?: Maybe<Scalars['Float']['output']>;
  /** Proportion of insight question reports where the user completed the task successfully (for Task questions: success count / total reports) */
  avgSuccess?: Maybe<Scalars['Float']['output']>;
  connectionRules?: Maybe<Array<QuestionConnectionRuleModel>>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Distribution of responses across options */
  distribution?: Maybe<Array<DistributionItem>>;
  /** For Task questions: whether feedback follow-up question is enabled (derived from connection rule) */
  feedbackQuestionEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Per-question voice|text override; null inherits the project. */
  interactionType?: Maybe<InteractionType>;
  /** Whether this is a matrix question */
  isMatrix?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a sub-question of a matrix */
  isSubQuestion?: Maybe<Scalars['Boolean']['output']>;
  /** Per-sub-question distribution for Matrix questions. Each row is one sub-question; each bucket is one rating value (or "NA" when the parent has notApplicableLabel set). Null for non-matrix questions. */
  matrixDistribution?: Maybe<Array<SubQuestionDistribution>>;
  maxSelections?: Maybe<Scalars['Int']['output']>;
  /** Median score for the question */
  medianScore?: Maybe<Scalars['Float']['output']>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  /** Appetize.io embed URL for Mobile App questions (UT projects). Loaded by survey FE at runtime. */
  mobileAppEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** Original filename of the uploaded mobile app. Display only. */
  mobileAppFileName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `maxSelections` instead. */
  multipleSelect?: Maybe<Scalars['Boolean']['output']>;
  notApplicableLabel?: Maybe<Scalars['String']['output']>;
  optionRenderType: OptionRenderType;
  options?: Maybe<Array<QuestionV2Option>>;
  /** Parent matrix question (if this is a sub-question) */
  parentQuestion?: Maybe<QuestionV2Model>;
  questionOrder: Scalars['Int']['output'];
  randomize?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  showLiveDistribution?: Maybe<Scalars['Boolean']['output']>;
  subQuestions?: Maybe<Array<SubQuestionModel>>;
  /** For Task questions: whether success follow-up question is enabled (derived from connection rule) */
  successQuestionEnabled?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Tag>>;
  text: Scalars['String']['output'];
  /** Total number of insights for the question */
  totalInsights?: Maybe<Scalars['Int']['output']>;
  /** Total number of question themes */
  totalQuestionThemes?: Maybe<Scalars['Int']['output']>;
  /** English translation of the question text */
  translatedText?: Maybe<Scalars['String']['output']>;
  type: QuestionType;
  /** Voice-ready rewrite of the question (options included) for moderator TTS. Null until the voice-text job has run; fall back to `text`. */
  voiceText?: Maybe<Scalars['String']['output']>;
};

export type QuestionV2Option = {
  __typename?: 'QuestionV2Option';
  assets?: Maybe<Array<QuestionOptionAssetModel>>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** English translation of the option label */
  translatedLabel?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type QuestionV2WithTextForVoice = {
  __typename?: 'QuestionV2WithTextForVoice';
  aiConvoDepth?: Maybe<Scalars['Int']['output']>;
  aiInsights?: Maybe<Scalars['Boolean']['output']>;
  assets?: Maybe<Array<QuestionAssetModel>>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Per-question voice|text override; null inherits the project. */
  interactionType?: Maybe<InteractionType>;
  maxSelections?: Maybe<Scalars['Int']['output']>;
  minSelections?: Maybe<Scalars['Int']['output']>;
  /** Appetize.io embed URL for Mobile App questions (UT projects). Loaded by survey FE at runtime. */
  mobileAppEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** Original filename of the uploaded mobile app. Display only. */
  mobileAppFileName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `maxSelections` instead. */
  multipleSelect?: Maybe<Scalars['Boolean']['output']>;
  notApplicableLabel?: Maybe<Scalars['String']['output']>;
  optionRenderType: OptionRenderType;
  options?: Maybe<Array<QuestionV2Option>>;
  questionOrder: Scalars['Int']['output'];
  randomize?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  showLiveDistribution?: Maybe<Scalars['Boolean']['output']>;
  subQuestions?: Maybe<Array<SubQuestionModel>>;
  tags?: Maybe<Array<Tag>>;
  text: Scalars['String']['output'];
  textForVoice?: Maybe<Scalars['String']['output']>;
  /** English translation of the question text */
  translatedText?: Maybe<Scalars['String']['output']>;
  type: QuestionType;
  /** Voice-ready rewrite of the question (options included) for moderator TTS. Null until the voice-text job has run; fall back to `text`. */
  voiceText?: Maybe<Scalars['String']['output']>;
};

export type QuestionsFilterInput = {
  /** Maximum number of questions to return */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Order direction for questions (ASC or DESC) */
  orderBy?: InputMaybe<OrderDirection>;
};

export type QuestionsV2Input = {
  /** Maximum number of questions to return */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Order direction for questions (ASC or DESC) */
  orderBy?: InputMaybe<OrderDirection>;
  projectId: Scalars['ID']['input'];
};

/** Aggregate order and responder counts across the org's most recently active published panels. */
export type RecentPanelStat = {
  __typename?: 'RecentPanelStat';
  /** Total panel users ordered (sum of panel config target completes across the panels). */
  orderCount: Scalars['Int']['output'];
  /** How many published-panel projects the order and responder counts were aggregated from. */
  projectCount: Scalars['Int']['output'];
  /** Total completed responses collected from RepData across the panels. */
  responderCount: Scalars['Int']['output'];
};

export type RecruitingAudience = {
  __typename?: 'RecruitingAudience';
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Short summary of who the audience is; null when none was written or generated. */
  description?: Maybe<Scalars['String']['output']>;
  /** Per-tester human incentive in cents (whole dollars, $1-$99); null when none is set. */
  humanIncentive?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** True when the system created the audience (e.g. generated at onboarding) rather than a user. Read-only; kept through edits and renames. */
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  /** When the audience was pinned; null when not pinned. Pinned audiences list first, most recently pinned first. */
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  qualifications?: Maybe<Array<PanelQualificationFilterModel>>;
  syntheticAgeMax?: Maybe<Scalars['Int']['output']>;
  syntheticAgeMin?: Maybe<Scalars['Int']['output']>;
  syntheticAiTesters?: Maybe<Scalars['Int']['output']>;
  syntheticBiologicalSex?: Maybe<BiologicalSex>;
  syntheticCompanyIndustry?: Maybe<Scalars['String']['output']>;
  syntheticCompanySize?: Maybe<Scalars['String']['output']>;
  syntheticCompletionMax?: Maybe<Scalars['Int']['output']>;
  syntheticCompletionMin?: Maybe<Scalars['Int']['output']>;
  syntheticDecisionMakingMax?: Maybe<Scalars['Int']['output']>;
  syntheticDecisionMakingMin?: Maybe<Scalars['Int']['output']>;
  syntheticDirectnessMax?: Maybe<Scalars['Int']['output']>;
  syntheticDirectnessMin?: Maybe<Scalars['Int']['output']>;
  syntheticEmotionalExpressivenessMax?: Maybe<Scalars['Int']['output']>;
  syntheticEmotionalExpressivenessMin?: Maybe<Scalars['Int']['output']>;
  syntheticKnowledgebase?: Maybe<Scalars['String']['output']>;
  syntheticLocation?: Maybe<Scalars['String']['output']>;
  syntheticMotivation?: Maybe<Scalars['String']['output']>;
  syntheticPatienceMax?: Maybe<Scalars['Int']['output']>;
  syntheticPatienceMin?: Maybe<Scalars['Int']['output']>;
  syntheticPerfectionMax?: Maybe<Scalars['Int']['output']>;
  syntheticPerfectionMin?: Maybe<Scalars['Int']['output']>;
  syntheticReadingTypeMax?: Maybe<Scalars['Int']['output']>;
  syntheticReadingTypeMin?: Maybe<Scalars['Int']['output']>;
  syntheticRiskMax?: Maybe<Scalars['Int']['output']>;
  syntheticRiskMin?: Maybe<Scalars['Int']['output']>;
  syntheticSpeakerBoost?: Maybe<Scalars['Boolean']['output']>;
  syntheticTechnologyTrustMax?: Maybe<Scalars['Int']['output']>;
  syntheticTechnologyTrustMin?: Maybe<Scalars['Int']['output']>;
  syntheticTitles?: Maybe<Scalars['String']['output']>;
  syntheticUseProxy?: Maybe<Scalars['Boolean']['output']>;
  syntheticVerbosityMax?: Maybe<Scalars['Int']['output']>;
  syntheticVerbosityMin?: Maybe<Scalars['Int']['output']>;
  syntheticVictorOrVictimMax?: Maybe<Scalars['Int']['output']>;
  syntheticVictorOrVictimMin?: Maybe<Scalars['Int']['output']>;
  syntheticVoiceIds?: Maybe<Array<Scalars['String']['output']>>;
  syntheticVoiceSimilarityBoost?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceSpeed?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceStability?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceStyle?: Maybe<Scalars['Float']['output']>;
  syntheticWorldview?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RecruitingAudienceDescriptionSuggestion = {
  __typename?: 'RecruitingAudienceDescriptionSuggestion';
  /** One-sentence audience summary, at most 280 characters. Not saved. */
  description: Scalars['String']['output'];
};

export type RecruitingAudienceListFilterInput = {
  /** Case-insensitive match anywhere in the audience name. */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Human: has qualifications. Synthetic: has syntheticAiTesters. All or omitted: no filter. */
  type?: InputMaybe<RecruitingAudienceTypeFilter>;
};

/** Whether a recruiting audience targets human (RepData panel) or synthetic (AI persona) testers */
export const RecruitingAudienceType = {
  Human: 'Human',
  Synthetic: 'Synthetic',
} as const;

export type RecruitingAudienceType =
  (typeof RecruitingAudienceType)[keyof typeof RecruitingAudienceType];
/** Recruiting audience list filter: All (no filter), Human (has qualifications) or Synthetic (has syntheticAiTesters); an audience with both sides matches both */
export const RecruitingAudienceTypeFilter = {
  All: 'All',
  Human: 'Human',
  Synthetic: 'Synthetic',
} as const;

export type RecruitingAudienceTypeFilter =
  (typeof RecruitingAudienceTypeFilter)[keyof typeof RecruitingAudienceTypeFilter];
/** Lifecycle of a single cohort (order line item) being recruited */
export const RecruitingCohortStatus = {
  Collecting: 'Collecting',
  Completed: 'Completed',
  Draft: 'Draft',
  Expired: 'Expired',
  Failed: 'Failed',
  Placed: 'Placed',
  Stopped: 'Stopped',
} as const;

export type RecruitingCohortStatus =
  (typeof RecruitingCohortStatus)[keyof typeof RecruitingCohortStatus];
export type RecruitingIncentiveEstimate = {
  __typename?: 'RecruitingIncentiveEstimate';
  /** Rate-card tier the audience was classified into; null when degraded. */
  archetype?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  /** True when no estimate could be produced and the range is the generic general-consumer suggestion. */
  degraded: Scalars['Boolean']['output'];
  /** Why the audience may need another sourcing method; null when repDataViable. */
  flagMessage?: Maybe<Scalars['String']['output']>;
  /** Suggested high end, cents (whole dollars). */
  highAmount: Scalars['Int']['output'];
  /** Suggested low end, cents (whole dollars). */
  lowAmount: Scalars['Int']['output'];
  /** False when the suggested high exceeds what RepData can practically fill. */
  repDataViable: Scalars['Boolean']['output'];
  /** Study length (minutes) used for the adjustment: the project's estimated completion time; null when no project was given (base length, no adjustment). */
  studyMinutes?: Maybe<Scalars['Int']['output']>;
};

export type RecruitingOrder = {
  __typename?: 'RecruitingOrder';
  /** Portion charged to card, in minor units (cents). */
  cardChargedAmount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Portion paid from account credit, in minor units (cents). */
  creditAppliedAmount: Scalars['Int']['output'];
  /** Lowercase ISO 4217 currency code every amount on the order is in (e.g. usd). */
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<RecruitingOrderLineItem>;
  organizationId: Scalars['ID']['output'];
  paymentStatus: RecruitingOrderPaymentStatus;
  /** Null until the order is placed (paid or fully covered by credit). */
  placedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Null once the project has been deleted; the order is kept. */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Account credit refunded for the order's cancelled cohorts, in minor units (cents); 0 when none. */
  refundedAmount: Scalars['Int']['output'];
  /** Derived at read time: a placed order is completed once every cohort is completed, expired or stopped. */
  status: RecruitingOrderStatus;
  /** Sum of line totals, in minor units (cents). */
  totalAmount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RecruitingOrderLineItem = {
  __typename?: 'RecruitingOrderLineItem';
  /** Cohort display name frozen at placement; unaffected by later renames or deletion of the source audience. */
  audienceName: Scalars['String']['output'];
  audienceType: RecruitingAudienceType;
  /** Derived at read time: completed once completedCount reaches quantity; expired once a collecting cohort is past its two-week collection window (from when fulfilment started it); otherwise the stored status. */
  cohortStatus: RecruitingCohortStatus;
  /** Completed testers attributed to this cohort, counted live (human: panel completes; synthetic: finished sessions). Not capped at quantity. */
  completedCount: Scalars['Int']['output'];
  /** Country frozen at placement. */
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Per-tester incentive in minor units (cents). */
  incentiveAmount: Scalars['Int']['output'];
  /** quantity x incentiveAmount, in minor units (cents). */
  lineTotalAmount: Scalars['Int']['output'];
  orderId: Scalars['ID']['output'];
  /** Panel targeting frozen at placement. Set only for human cohorts. */
  qualifications?: Maybe<Array<PanelQualificationFilterModel>>;
  quantity: Scalars['Int']['output'];
  /** Account credit refunded when this cohort was cancelled (its undelivered testers x incentiveAmount), in minor units (cents) of the order currency; 0 when none. */
  refundedAmount: Scalars['Int']['output'];
  /** Null when the cohort was not built from a saved audience, or it was deleted. */
  sourceAudienceId?: Maybe<Scalars['ID']['output']>;
  /** Persona config frozen at placement (syntheticAiTesters = quantity). Set only for synthetic cohorts. */
  synthetic?: Maybe<RecruitingSyntheticAudience>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RecruitingOrderLineItemInput = {
  /** Display name of the cohort (e.g. the saved audience name, or a label for a one-off cohort), frozen at placement. Trimmed; blank or omitted: "Custom audience". At most 255 characters. */
  audienceName?: InputMaybe<Scalars['String']['input']>;
  audienceType: RecruitingAudienceType;
  /** ISO 3166-1 alpha-2 country targeted by this cohort. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Per-tester incentive in minor units (cents). */
  incentiveAmount: Scalars['Int']['input'];
  /** RepData panel targeting. Required with at least one qualification when audienceType is human; must be omitted otherwise. */
  qualifications?: InputMaybe<Array<PanelQualificationFilterInput>>;
  /** Number of testers to recruit for this cohort. */
  quantity: Scalars['Int']['input'];
  /** Audience this cohort was built from (re-order convenience only; its contents are ignored). */
  sourceAudienceId?: InputMaybe<Scalars['UUID']['input']>;
  /** Synthetic persona config. Required when audienceType is synthetic; must be omitted otherwise. syntheticAiTesters is ignored: the cohort size is quantity. */
  synthetic?: InputMaybe<RecruitingSyntheticAudienceInput>;
};

export type RecruitingOrderLineItemListFilterInput = {
  /** True: only cohorts that are still running — the order is neither awaiting payment nor cancelled and the cohort has not completed, expired or been stopped. Combines with the other filters. */
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  audienceType?: InputMaybe<RecruitingAudienceType>;
  /** Derived cohort statuses (as returned in cohortStatus) to keep; empty or omitted: all. */
  cohortStatuses?: InputMaybe<Array<RecruitingCohortStatus>>;
  /** Derived cohort statuses (as returned in cohortStatus) to leave out. */
  excludeCohortStatuses?: InputMaybe<Array<RecruitingCohortStatus>>;
  /** Statuses of the owning order to leave out, as returned in order.status (derived), e.g. cancelled, pending_payment, completed. */
  excludeOrderStatuses?: InputMaybe<Array<RecruitingOrderStatus>>;
  orderId?: InputMaybe<Scalars['UUID']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-insensitive match anywhere in the project title, the cohort's frozen audienceName or the source audience's current name. */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
};

export type RecruitingOrderLineItemListItem = {
  __typename?: 'RecruitingOrderLineItemListItem';
  /** Cohort display name frozen at placement; unaffected by later renames or deletion of the source audience. */
  audienceName: Scalars['String']['output'];
  audienceType: RecruitingAudienceType;
  /** Derived at read time: completed once completedCount reaches quantity; expired once a collecting cohort is past its two-week collection window (from when fulfilment started it); otherwise the stored status. */
  cohortStatus: RecruitingCohortStatus;
  /** Completed testers attributed to this cohort, counted live (human: panel completes; synthetic: finished sessions). Not capped at quantity. */
  completedCount: Scalars['Int']['output'];
  /** Country frozen at placement. */
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Per-tester incentive in minor units (cents). */
  incentiveAmount: Scalars['Int']['output'];
  /** quantity x incentiveAmount, in minor units (cents). */
  lineTotalAmount: Scalars['Int']['output'];
  order: RecruitingOrderSummary;
  orderId: Scalars['ID']['output'];
  /** Panel targeting frozen at placement. Set only for human cohorts. */
  qualifications?: Maybe<Array<PanelQualificationFilterModel>>;
  quantity: Scalars['Int']['output'];
  /** Account credit refunded when this cohort was cancelled (its undelivered testers x incentiveAmount), in minor units (cents) of the order currency; 0 when none. */
  refundedAmount: Scalars['Int']['output'];
  /** Null when the cohort was not built from a saved audience, or it was deleted. */
  sourceAudienceId?: Maybe<Scalars['ID']['output']>;
  /** Current name of the saved audience the cohort was built from; null when none or it was deleted. Changes on rename: use audienceName for the name frozen at placement. */
  sourceAudienceName?: Maybe<Scalars['String']['output']>;
  /** Persona config frozen at placement (syntheticAiTesters = quantity). Set only for synthetic cohorts. */
  synthetic?: Maybe<RecruitingSyntheticAudience>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RecruitingOrderListFilterInput = {
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-insensitive match anywhere in the project title. */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  /** Order statuses to keep, as returned in status (derived: a placed order whose cohorts have all ended is completed); empty or omitted: all. */
  statuses?: InputMaybe<Array<RecruitingOrderStatus>>;
};

/** Outcome of the Stripe Checkout payment for a recruiting order */
export const RecruitingOrderPaymentStatus = {
  Failed: 'Failed',
  None: 'None',
  Paid: 'Paid',
  Processing: 'Processing',
} as const;

export type RecruitingOrderPaymentStatus =
  (typeof RecruitingOrderPaymentStatus)[keyof typeof RecruitingOrderPaymentStatus];
/** Lifecycle of a recruiting order, from checkout through fulfillment */
export const RecruitingOrderStatus = {
  Cancelled: 'Cancelled',
  Completed: 'Completed',
  PendingPayment: 'PendingPayment',
  Placed: 'Placed',
} as const;

export type RecruitingOrderStatus =
  (typeof RecruitingOrderStatus)[keyof typeof RecruitingOrderStatus];
export type RecruitingOrderSummary = {
  __typename?: 'RecruitingOrderSummary';
  createdAt: Scalars['DateTime']['output'];
  /** Lowercase ISO 4217 currency code of every amount on the order. */
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  paymentStatus: RecruitingOrderPaymentStatus;
  /** Null until the order is placed. */
  placedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Null once the project has been deleted. */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Null once the project has been deleted. */
  projectTitle?: Maybe<Scalars['String']['output']>;
  /** Derived at read time, as on RecruitingOrder: completed once every cohort of the order has ended. */
  status: RecruitingOrderStatus;
};

export type RecruitingProjectRollup = {
  __typename?: 'RecruitingProjectRollup';
  /** Sum over the rolled-up cohorts (see recruitingRollup's activeOnly) of each cohort's completedCount, capped at its quantity. */
  completed: Scalars['Int']['output'];
  /** Sum of the rolled-up cohorts' quantities. In the all-time rollup a stopped or failed cohort counts only its capped completes, since it will never fill. */
  total: Scalars['Int']['output'];
};

export type RecruitingQualificationLabelInput = {
  /** Qualification name as shown to the user, e.g. "Age". */
  name: Scalars['String']['input'];
  /** Selected option labels, e.g. ["25-34", "35-44"]. */
  options: Array<Scalars['String']['input']>;
};

export type RecruitingSyntheticAudience = {
  __typename?: 'RecruitingSyntheticAudience';
  syntheticAgeMax?: Maybe<Scalars['Int']['output']>;
  syntheticAgeMin?: Maybe<Scalars['Int']['output']>;
  syntheticAiTesters?: Maybe<Scalars['Int']['output']>;
  syntheticBiologicalSex?: Maybe<BiologicalSex>;
  syntheticCompanyIndustry?: Maybe<Scalars['String']['output']>;
  syntheticCompanySize?: Maybe<Scalars['String']['output']>;
  syntheticCompletionMax?: Maybe<Scalars['Int']['output']>;
  syntheticCompletionMin?: Maybe<Scalars['Int']['output']>;
  syntheticDecisionMakingMax?: Maybe<Scalars['Int']['output']>;
  syntheticDecisionMakingMin?: Maybe<Scalars['Int']['output']>;
  syntheticDirectnessMax?: Maybe<Scalars['Int']['output']>;
  syntheticDirectnessMin?: Maybe<Scalars['Int']['output']>;
  syntheticEmotionalExpressivenessMax?: Maybe<Scalars['Int']['output']>;
  syntheticEmotionalExpressivenessMin?: Maybe<Scalars['Int']['output']>;
  syntheticKnowledgebase?: Maybe<Scalars['String']['output']>;
  syntheticLocation?: Maybe<Scalars['String']['output']>;
  syntheticMotivation?: Maybe<Scalars['String']['output']>;
  syntheticPatienceMax?: Maybe<Scalars['Int']['output']>;
  syntheticPatienceMin?: Maybe<Scalars['Int']['output']>;
  syntheticPerfectionMax?: Maybe<Scalars['Int']['output']>;
  syntheticPerfectionMin?: Maybe<Scalars['Int']['output']>;
  syntheticReadingTypeMax?: Maybe<Scalars['Int']['output']>;
  syntheticReadingTypeMin?: Maybe<Scalars['Int']['output']>;
  syntheticRiskMax?: Maybe<Scalars['Int']['output']>;
  syntheticRiskMin?: Maybe<Scalars['Int']['output']>;
  syntheticSpeakerBoost?: Maybe<Scalars['Boolean']['output']>;
  syntheticTechnologyTrustMax?: Maybe<Scalars['Int']['output']>;
  syntheticTechnologyTrustMin?: Maybe<Scalars['Int']['output']>;
  syntheticTitles?: Maybe<Scalars['String']['output']>;
  syntheticUseProxy?: Maybe<Scalars['Boolean']['output']>;
  syntheticVerbosityMax?: Maybe<Scalars['Int']['output']>;
  syntheticVerbosityMin?: Maybe<Scalars['Int']['output']>;
  syntheticVictorOrVictimMax?: Maybe<Scalars['Int']['output']>;
  syntheticVictorOrVictimMin?: Maybe<Scalars['Int']['output']>;
  syntheticVoiceIds?: Maybe<Array<Scalars['String']['output']>>;
  syntheticVoiceSimilarityBoost?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceSpeed?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceStability?: Maybe<Scalars['Float']['output']>;
  syntheticVoiceStyle?: Maybe<Scalars['Float']['output']>;
  syntheticWorldview?: Maybe<Scalars['String']['output']>;
};

export type RecruitingSyntheticAudienceInput = {
  syntheticAgeMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticAgeMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticAiTesters?: InputMaybe<Scalars['Int']['input']>;
  syntheticBiologicalSex?: InputMaybe<BiologicalSex>;
  syntheticCompanyIndustry?: InputMaybe<Scalars['String']['input']>;
  syntheticCompanySize?: InputMaybe<Scalars['String']['input']>;
  syntheticCompletionMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticCompletionMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticDecisionMakingMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticDecisionMakingMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticDirectnessMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticDirectnessMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticEmotionalExpressivenessMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticEmotionalExpressivenessMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticKnowledgebase?: InputMaybe<Scalars['String']['input']>;
  syntheticLocation?: InputMaybe<Scalars['String']['input']>;
  syntheticMotivation?: InputMaybe<Scalars['String']['input']>;
  syntheticPatienceMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticPatienceMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticPerfectionMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticPerfectionMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticReadingTypeMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticReadingTypeMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticRiskMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticRiskMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticSpeakerBoost?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticTechnologyTrustMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticTechnologyTrustMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticTitles?: InputMaybe<Scalars['String']['input']>;
  syntheticUseProxy?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticVerbosityMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticVerbosityMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticVictorOrVictimMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticVictorOrVictimMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticVoiceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  syntheticVoiceSimilarityBoost?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceSpeed?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStability?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStyle?: InputMaybe<Scalars['Float']['input']>;
  syntheticWorldview?: InputMaybe<Scalars['String']['input']>;
};

export type RefineObservationInput = {
  /** Background, a correction, or scoping the AI should re-interpret the observation with. */
  context: Scalars['String']['input'];
  themeId: Scalars['UUID']['input'];
};

export type RefreshDocumentInput = {
  id: Scalars['ID']['input'];
};

export type RefreshProjectDocumentInput = {
  id: Scalars['ID']['input'];
};

export type RemoveBackgroundImageInput = {
  /** The GCS path of the background image to remove */
  imagePath: Scalars['String']['input'];
};

export type RemoveHyperbeamSessionInput = {
  /** The Hyperbeam session ID to terminate */
  sessionId: Scalars['String']['input'];
};

export type RemoveInsightTagInput = {
  insightId: Scalars['UUID']['input'];
  tagId: Scalars['UUID']['input'];
};

export type RemoveModeratorVoiceInput = {
  id: Scalars['ID']['input'];
};

/** Deprecated — use UpdateCompanionSessionInput. */
export type RenameCompanionSessionInput = {
  name: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
};

export type ReorderScreenerQuestionsInput = {
  projectScreenerId: Scalars['UUID']['input'];
  /** Every question id, in the new order. */
  questionIds: Array<Scalars['UUID']['input']>;
};

export type RepDataDefinitionCountryModel = {
  __typename?: 'RepDataDefinitionCountryModel';
  code: Scalars['String']['output'];
  languageOptions: Array<RepDataDefinitionLanguageOptionModel>;
  name: Scalars['String']['output'];
};

export type RepDataDefinitionLanguageOptionModel = {
  __typename?: 'RepDataDefinitionLanguageOptionModel';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RepDataQualificationAttributesDefinitionsModel = {
  __typename?: 'RepDataQualificationAttributesDefinitionsModel';
  categories: Array<Scalars['String']['output']>;
  types: Array<Scalars['String']['output']>;
};

export type RepDataQualificationModel = {
  __typename?: 'RepDataQualificationModel';
  category: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  questionOptions?: Maybe<Array<RepDataQuestionOptionModel>>;
  questionText: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RepDataQualificationsFilterInput = {
  /** Country code (e.g. us) */
  countryCode: Scalars['String']['input'];
  /** Language code (e.g. en) */
  languageCode: Scalars['String']['input'];
  /** Page number (1-based) */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Page size (default from API) */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RepDataQualificationsResponseModel = {
  __typename?: 'RepDataQualificationsResponseModel';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  qualifications: Array<RepDataQualificationModel>;
  totalQualifications: Scalars['Int']['output'];
};

export type RepDataQuestionOptionModel = {
  __typename?: 'RepDataQuestionOptionModel';
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type RepDataResponseAttributesDefinitionsModel = {
  __typename?: 'RepDataResponseAttributesDefinitionsModel';
  reconciliationStatuses: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
};

export type RepDataSurveyAttributesDefinitionsModel = {
  __typename?: 'RepDataSurveyAttributesDefinitionsModel';
  calculationTypes: Array<Scalars['String']['output']>;
  countries: Array<RepDataDefinitionCountryModel>;
  deviceCompatibilities: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  timeZones: Array<Scalars['String']['output']>;
  trafficControlLimits: Array<Scalars['String']['output']>;
};

export type RepDataSurveyObjectDefinitionsModel = {
  __typename?: 'RepDataSurveyObjectDefinitionsModel';
  qualificationAttributes: RepDataQualificationAttributesDefinitionsModel;
  responseAttributes: RepDataResponseAttributesDefinitionsModel;
  surveyAttributes: RepDataSurveyAttributesDefinitionsModel;
};

export type ReplaceModeratorVoiceRecordingInput = {
  gcsKey: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  langCode?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  mood: VoiceMood;
  transcript: Scalars['String']['input'];
};

export type ResearchRecommendation = {
  __typename?: 'ResearchRecommendation';
  description: Scalars['String']['output'];
  icon: ResearchRecommendationIcon;
  /** Generated item id, or the stable key of a default recommendation. */
  id: Scalars['String']['output'];
  /** Opening message to hand to the companion when the user starts it. */
  prompt: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Font Awesome icon shown next to a research recommendation */
export const ResearchRecommendationIcon = {
  Browser: 'Browser',
  Bullseye: 'Bullseye',
  CartShopping: 'CartShopping',
  ChartLine: 'ChartLine',
  DiagramSubtask: 'DiagramSubtask',
  Flask: 'Flask',
  Headset: 'Headset',
  Heart: 'Heart',
  Lightbulb: 'Lightbulb',
  MagnifyingGlass: 'MagnifyingGlass',
  Megaphone: 'Megaphone',
  Messages: 'Messages',
  Mobile: 'Mobile',
  Rocket: 'Rocket',
  Route: 'Route',
  Tags: 'Tags',
  Users: 'Users',
  WaveformLines: 'WaveformLines',
} as const;

export type ResearchRecommendationIcon =
  (typeof ResearchRecommendationIcon)[keyof typeof ResearchRecommendationIcon];
export type ResolvedIntroVideo = {
  __typename?: 'ResolvedIntroVideo';
  createdAt: Scalars['DateTime']['output'];
  /** Duration of the intro video in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  gcsKey?: Maybe<Scalars['String']['output']>;
  /** ID of the backing asset row. */
  id: Scalars['UUID']['output'];
  /** Whether this resolved to the project- or org-level intro video. */
  level: IntroVideoLevel;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: AssetStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ResponderStats = {
  __typename?: 'ResponderStats';
  count: Scalars['Int']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  responderType: ResponderType;
};

/** Who gave a response: Synthetic for AI testers, Human for everyone else */
export const ResponderType = {
  Human: 'Human',
  Synthetic: 'Synthetic',
} as const;

export type ResponderType = (typeof ResponderType)[keyof typeof ResponderType];
export type ResponderTypeFilterInput = {
  /** How to match `values` against the target field. Accepted values for this filter: IS, IS_NOT. */
  matchingType: MatchingType;
  /** Values to compare the target field against. */
  values: Array<ResponderType>;
};

export type ResponseActivityDayModel = {
  __typename?: 'ResponseActivityDayModel';
  count: Scalars['Int']['output'];
  /** Local calendar day in the requested time zone. */
  date: Scalars['Date']['output'];
  isToday: Scalars['Boolean']['output'];
  /** Projects with at least one response that day, busiest first. */
  projects: Array<ResponseActivityProjectCountModel>;
};

export type ResponseActivityInput = {
  /** IANA time zone the days are cut in, e.g. "Europe/Paris". */
  timeZone: Scalars['String']['input'];
};

export type ResponseActivityModel = {
  __typename?: 'ResponseActivityModel';
  /** When the underlying snapshot was computed. */
  computedAt: Scalars['DateTime']['output'];
  /** The last seven days, ending today. */
  rolling: ResponseActivityPeriodModel;
  /** Monday through Sunday of the current week. */
  week: ResponseActivityPeriodModel;
};

export type ResponseActivityPeriodModel = {
  __typename?: 'ResponseActivityPeriodModel';
  /** Seven consecutive local days. */
  days: Array<ResponseActivityDayModel>;
  /** Responses over the matching days one week earlier, through today's weekday. */
  previousTotal: Scalars['Int']['output'];
  /** Distinct projects with at least one response in the period. */
  projectCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ResponseActivityProjectCountModel = {
  __typename?: 'ResponseActivityProjectCountModel';
  count: Scalars['Int']['output'];
  projectId: Scalars['UUID']['output'];
  /** Null when the project has no title. */
  title?: Maybe<Scalars['String']['output']>;
};

/** The channel a response is shown under: TheySaid panel and AI tester responses roll up into Recruit */
export const ResponseChannel = {
  Email: 'Email',
  Link: 'Link',
  QrCode: 'QrCode',
  Recruit: 'Recruit',
  SocialMedia: 'SocialMedia',
  Website: 'Website',
} as const;

export type ResponseChannel =
  (typeof ResponseChannel)[keyof typeof ResponseChannel];
export type ResponseChannelFilterInput = {
  /** How to match `values` against the target field. Accepted values for this filter: IS, IS_NOT. */
  matchingType: MatchingType;
  /** Values to compare the target field against. */
  values: Array<ResponseChannel>;
};

export type ResponseChannelStats = {
  __typename?: 'ResponseChannelStats';
  count: Scalars['Int']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  responseChannel: ResponseChannel;
};

export type RetrainModeratorVoiceInput = {
  id: Scalars['ID']['input'];
};

export type ReviewObservationInput = {
  /** approved / rejected, or pending to undo a previous decision. */
  status: ThemeReviewStatus;
  themeId: Scalars['UUID']['input'];
};

/** The role of a user */
export const Role = {
  Admin: 'Admin',
  Member: 'Member',
  Owner: 'Owner',
  Viewer: 'Viewer',
} as const;

export type Role = (typeof Role)[keyof typeof Role];
/** The type of rule action */
export const RuleActionType = {
  CustomEndConversation: 'CUSTOM_END_CONVERSATION',
  CustomRedirect: 'CUSTOM_REDIRECT',
  FeedbackMessage: 'FEEDBACK_MESSAGE',
  PanelCompleteRedirect: 'PANEL_COMPLETE_REDIRECT',
  PanelOverQuotaRedirect: 'PANEL_OVER_QUOTA_REDIRECT',
  PanelQualityControlRedirect: 'PANEL_QUALITY_CONTROL_REDIRECT',
  PanelSecurityRedirect: 'PANEL_SECURITY_REDIRECT',
  PanelTerminateRedirect: 'PANEL_TERMINATE_REDIRECT',
  Question: 'QUESTION',
  Redirect: 'REDIRECT',
  ReviewRedirect: 'REVIEW_REDIRECT',
  SuccessMessage: 'SUCCESS_MESSAGE',
} as const;

export type RuleActionType =
  (typeof RuleActionType)[keyof typeof RuleActionType];
/** The type of rule activation */
export const RuleActivationType = {
  AiMatch: 'AI_MATCH',
  AlwaysMatch: 'ALWAYS_MATCH',
  IsTaskMessageMatch: 'IS_TASK_MESSAGE_MATCH',
  OptionAndMatch: 'OPTION_AND_MATCH',
  OptionMatch: 'OPTION_MATCH',
  OptionOrMatch: 'OPTION_OR_MATCH',
  RankingOptionBottomMatch: 'RANKING_OPTION_BOTTOM_MATCH',
  RankingOptionTopMatch: 'RANKING_OPTION_TOP_MATCH',
  RegexMatch: 'REGEX_MATCH',
  TextMatch: 'TEXT_MATCH',
} as const;

export type RuleActivationType =
  (typeof RuleActivationType)[keyof typeof RuleActivationType];
export type SaveDefaultModeratorVoiceInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveProjectModeratorVoiceInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type SaveProjectPanelConfigInput = {
  /** Country code for panel survey (e.g. US, GB). Defaults to US when not set. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  qualifications?: InputMaybe<Array<PanelQualificationFilterInput>>;
  targetCompletes?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveProjectThemeSettingsInput = {
  backgroundType?: InputMaybe<BackgroundType>;
  bgColor?: InputMaybe<Scalars['String']['input']>;
  bgGradient?: InputMaybe<ThemeGradientInput>;
  bgImage?: InputMaybe<Scalars['String']['input']>;
  font?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ThemeMode>;
  /** Background overlay opacity (0-100). Distinct from transparency (surface opacity). */
  overlayOpacity?: InputMaybe<Scalars['Int']['input']>;
  primaryColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  projectId: Scalars['UUID']['input'];
  secondaryColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  titleFont?: InputMaybe<Scalars['String']['input']>;
  titleFontWeight?: InputMaybe<TitleFontWeight>;
  transparency?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveProjectWidgetConfigInput = {
  allowedFilters?: InputMaybe<Array<WidgetConfigFilter>>;
  deviceTypes?: InputMaybe<Array<WidgetDeviceType>>;
  /** Id of a WidgetImage asset (from createWidgetImage) to show on the intercept popup. */
  imageAssetId?: InputMaybe<Scalars['ID']['input']>;
  importance?: InputMaybe<WidgetImportance>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pageLocationType?: InputMaybe<WidgetPageLocationType>;
  pageLocationUrl?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggerCssSelector?: InputMaybe<Scalars['String']['input']>;
  triggerType?: InputMaybe<WidgetTriggerType>;
  userSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  utInWidgetEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Type of scene in a reel - either a clip or a transition */
export const SceneType = {
  Clip: 'Clip',
  Transition: 'Transition',
} as const;

export type SceneType = (typeof SceneType)[keyof typeof SceneType];
export type ScreenerPreviewAnswerResponse = {
  __typename?: 'ScreenerPreviewAnswerResponse';
  disqualificationRedirectUrl?: Maybe<Scalars['String']['output']>;
  previewSessionKey?: Maybe<Scalars['String']['output']>;
  question?: Maybe<SurveyScreenerQuestionModel>;
  status: ScreenerSessionStatus;
};

export type ScreenerPreviewSession = {
  __typename?: 'ScreenerPreviewSession';
  question: SurveyScreenerQuestionModel;
  sessionId: Scalars['String']['output'];
  /** Total questions in this screener. */
  totalQuestions: Scalars['Int']['output'];
};

export type ScreenerQuestionModel = {
  __typename?: 'ScreenerQuestionModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  options: Array<ScreenerQuestionOptionModel>;
  projectScreenerId: Scalars['ID']['output'];
  questionOrder: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  type: ScreenerQuestionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ScreenerQuestionOptionInput = {
  isDisqualifying?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ScreenerQuestionOptionModel = {
  __typename?: 'ScreenerQuestionOptionModel';
  id: Scalars['ID']['output'];
  /** Selecting this option disqualifies the respondent and ends the screener. */
  isDisqualifying: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  optionOrder: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/** Answer shape of a screening question: multiple-choice, rating, or ranking. All are option-based. */
export const ScreenerQuestionType = {
  MultipleChoice: 'MultipleChoice',
  Ranking: 'Ranking',
  Rating: 'Rating',
} as const;

export type ScreenerQuestionType =
  (typeof ScreenerQuestionType)[keyof typeof ScreenerQuestionType];
/** Lifecycle of a screener session: active (answering questions), disqualified (failed a screener rule, session is unusable), completed (all questions answered, project session key issued). */
export const ScreenerSessionStatus = {
  Active: 'ACTIVE',
  Completed: 'COMPLETED',
  Disqualified: 'DISQUALIFIED',
} as const;

export type ScreenerSessionStatus =
  (typeof ScreenerSessionStatus)[keyof typeof ScreenerSessionStatus];
export type SetDefaultSkillInput = {
  isDefault: Scalars['Boolean']['input'];
  /** Org or system skill to mark/unmark as the default for its scope. Set this or `skillId`, not both. Defaulting a standard moderation / project-creation skill clears the org's own default of that scope. */
  ref?: InputMaybe<SkillRefInput>;
  /** Org skill to mark/unmark as the org default for its scope. Set this or `ref`, not both. */
  skillId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SetPinnedSkillInput = {
  isPinned: Scalars['Boolean']['input'];
  /** The skill to pin/unpin — an org skill or a system skill. */
  ref: SkillRefInput;
};

export type SetProjectSkillInput = {
  /** true = make this skill a default analysis of the project (auto-refreshed); false = remove it. */
  enabled: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
  ref: SkillRefInput;
};

export type SharedAssemblyAiTokenInput = {
  /** Token expiration time in seconds */
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum session duration in seconds */
  maxSessionDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type SharedAssemblyAiTokenResponse = {
  __typename?: 'SharedAssemblyAITokenResponse';
  /** Token expiration time */
  expiresAt: Scalars['DateTime']['output'];
  /** AssemblyAI streaming token */
  token: Scalars['String']['output'];
};

export type SharedGenerateSpeechInput = {
  /** Text to convert to speech */
  text: Scalars['String']['input'];
  /** Voice ID for ElevenLabs (default: JBFqnCBsd6RMkjVDRZzb) */
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type SharedGenerateSpeechResponse = {
  __typename?: 'SharedGenerateSpeechResponse';
  /** Base64 encoded audio data */
  audioData: Scalars['String']['output'];
};

export type SharedImportSurveyResponse = {
  __typename?: 'SharedImportSurveyResponse';
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  inAppPopupMessage?: Maybe<Scalars['String']['output']>;
  /** @deprecated Redesigned builder (868gc1px2): intro content now lives in project intros. */
  introText?: Maybe<Scalars['String']['output']>;
  intros?: Maybe<Array<SharedImportedProjectIntro>>;
  isAiVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isForm?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isPoll?: Maybe<Scalars['Boolean']['output']>;
  isUserVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `objectives` instead */
  learningGoal?: Maybe<Scalars['String']['output']>;
  maxResponses?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `interactionType` instead. Redesigned builder (868gc1px2). */
  mode?: Maybe<ProjectMode>;
  objectives?: Maybe<Array<SharedImportedObjective>>;
  publicTitle?: Maybe<Scalars['String']['output']>;
  questions: Array<SharedImportedQuestion>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  surveyTitle: Scalars['String']['output'];
  tags?: Maybe<Array<SharedImportedTag>>;
  thankyouText?: Maybe<Scalars['String']['output']>;
  themeSettings?: Maybe<SharedImportedThemeSettings>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  type?: Maybe<ProjectType>;
};

export type SharedImportedAsset = {
  __typename?: 'SharedImportedAsset';
  description: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SharedImportedConnectionRule = {
  __typename?: 'SharedImportedConnectionRule';
  activationData: Scalars['String']['output'];
  activationType: RuleActivationType;
  aiFollowup?: Maybe<Scalars['Int']['output']>;
  postActivationActionData?: Maybe<Scalars['String']['output']>;
  postActivationActionType: RuleActionType;
  preActivationActionData?: Maybe<Scalars['String']['output']>;
  preActivationActionType?: Maybe<RuleActionType>;
  targetQuestionOrder?: Maybe<Scalars['Int']['output']>;
};

export type SharedImportedObjective = {
  __typename?: 'SharedImportedObjective';
  text: Scalars['String']['output'];
};

export type SharedImportedProjectIntro = {
  __typename?: 'SharedImportedProjectIntro';
  audience: Array<Channel>;
  introSource?: Maybe<IntroSource>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SharedImportedQuestion = {
  __typename?: 'SharedImportedQuestion';
  aiConvoDepth?: Maybe<Scalars['Int']['output']>;
  aiInsights?: Maybe<Scalars['Boolean']['output']>;
  assets?: Maybe<Array<SharedImportedAsset>>;
  connectionRules?: Maybe<Array<SharedImportedConnectionRule>>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  maxSelections?: Maybe<Scalars['Int']['output']>;
  optionRenderType?: Maybe<OptionRenderType>;
  questionOptions?: Maybe<Array<SharedImportedQuestionOption>>;
  questionText: Scalars['String']['output'];
  questionType: Scalars['String']['output'];
  randomize?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  subQuestions?: Maybe<Array<SharedImportedSubQuestion>>;
  tags?: Maybe<Array<SharedImportedTag>>;
  voiceText?: Maybe<Scalars['String']['output']>;
};

export type SharedImportedQuestionOption = {
  __typename?: 'SharedImportedQuestionOption';
  assets?: Maybe<Array<SharedImportedAsset>>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SharedImportedSubQuestion = {
  __typename?: 'SharedImportedSubQuestion';
  text: Scalars['String']['output'];
};

export type SharedImportedTag = {
  __typename?: 'SharedImportedTag';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SharedImportedThemeGradient = {
  __typename?: 'SharedImportedThemeGradient';
  angle: Scalars['Int']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type SharedImportedThemeSettings = {
  __typename?: 'SharedImportedThemeSettings';
  backgroundType?: Maybe<BackgroundType>;
  bgColor?: Maybe<Scalars['String']['output']>;
  bgGradient?: Maybe<SharedImportedThemeGradient>;
  bgImage?: Maybe<Scalars['String']['output']>;
  font?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<ThemeMode>;
  overlayOpacity?: Maybe<Scalars['Int']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  titleFont?: Maybe<Scalars['String']['output']>;
  titleFontWeight?: Maybe<TitleFontWeight>;
  transparency?: Maybe<Scalars['Int']['output']>;
};

/** The signal of the insight. */
export const Signal = {
  Mixed: 'Mixed',
  Negative: 'Negative',
  Neutral: 'Neutral',
  Positive: 'Positive',
  Unknown: 'Unknown',
} as const;

export type Signal = (typeof Signal)[keyof typeof Signal];
export type SignalFilterInput = {
  /** How to match `values` against the target field. Accepted values for this filter: IS, IS_NOT. */
  matchingType: MatchingType;
  /** Values to compare the target field against. */
  values: Array<Signal>;
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  /** The file path in the bucket */
  path: Scalars['String']['output'];
  /** The permanent public URL where the file will be accessible after successful upload */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /** The temporary signed URL that can be used to upload the file. Valid for 5 minutes. */
  url: Scalars['String']['output'];
};

/** The GCS signed URL action type */
export const SignedUrlAction = {
  Resumable: 'RESUMABLE',
  Write: 'WRITE',
} as const;

export type SignedUrlAction =
  (typeof SignedUrlAction)[keyof typeof SignedUrlAction];
/** An AI skill: a saved analysis prompt run against a project's observations to generate an analysis result. System skills are code-defined and uneditable; org skills are created by users and visible to the whole organization. */
export type SkillModel = {
  __typename?: 'SkillModel';
  /** Whether the current user may edit/delete this skill (creator only). */
  canEdit: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Display name/email of the creator, when known. */
  createdByName?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Org skill uuid, or the system skill slug when isSystem is true. */
  id: Scalars['ID']['output'];
  /** The skill prompt: analysis instructions, or moderation / project-creation guidelines. */
  instructions: Scalars['String']['output'];
  /** The org's default skill for this skill's scope (analysis: preselected when adding an analysis; moderation / project_creation: applied to AI follow-ups / question generation). Derived per-org from the skill_configurations table; toggle with setDefaultSkill. At most one per org and scope. */
  isDefault: Scalars['Boolean']['output'];
  /** Visual pin — pinned skills (org or system) sort first in the list. Derived from the skill_configurations table; toggle with setSkillPinned. Purely presentational; no effect on generation. */
  isPinned: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** What the skill is used for; fixed at creation. */
  scope: SkillScope;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Reference to a skill: set exactly one of the two fields. */
export type SkillRefInput = {
  skillId?: InputMaybe<Scalars['UUID']['input']>;
  systemSkillSlug?: InputMaybe<Scalars['String']['input']>;
};

export const SkillScope = {
  Analysis: 'Analysis',
  Moderation: 'Moderation',
  ProjectCreation: 'ProjectCreation',
} as const;

export type SkillScope = (typeof SkillScope)[keyof typeof SkillScope];
export type SkipQuestionPreviewInput = {
  projectId: Scalars['UUID']['input'];
  questionId: Scalars['UUID']['input'];
  /** Session id returned by startUnifiedPreview */
  sessionId: Scalars['UUID']['input'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type SlackChannelsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SlackChannelsPage = {
  __typename?: 'SlackChannelsPage';
  channels: Array<SlackChannel>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type StartScreenerPreviewInput = {
  /** The project whose screener to preview. */
  projectId: Scalars['UUID']['input'];
};

export type StartUnifiedPreviewInput = {
  projectId: Scalars['UUID']['input'];
  screenerSessionKey?: InputMaybe<Scalars['String']['input']>;
};

export type StartUnifiedPreviewResponse = {
  __typename?: 'StartUnifiedPreviewResponse';
  /** The first question of the previewed survey */
  firstQuestion: QuestionV2;
  /** Preview session id, passed to every subsequent preview call */
  sessionId: Scalars['UUID']['output'];
};

export type StringFilterInput = {
  /** How to match `values` against the target field. Accepted values for this filter: IS, IS_NOT, CONTAINS. */
  matchingType: MatchingType;
  /** Values to compare the target field against. */
  values: Array<Scalars['String']['input']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  marketingFeatures?: Maybe<Array<MarketingFeature>>;
  metadata?: Maybe<StripeProductMetadata>;
  name: Scalars['String']['output'];
  prices: Array<StripePrice>;
};

export type StripeProductFilterInput = {
  /** Filter products by product_code in metadata (case-insensitive match) */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StripeProductMetadata = {
  __typename?: 'StripeProductMetadata';
  productCode?: Maybe<Scalars['String']['output']>;
};

export type StripeProducts = {
  __typename?: 'StripeProducts';
  products: Array<StripeProduct>;
};

export type SubQuestionAnswer = {
  __typename?: 'SubQuestionAnswer';
  subQuestionId: Scalars['UUID']['output'];
  value: Scalars['String']['output'];
};

export type SubQuestionAnswerPreviewInput = {
  subQuestionId: Scalars['UUID']['input'];
  /** The rating value (matching one of the parent question's option values) or "NA". */
  value: Scalars['String']['input'];
};

export type SubQuestionDistribution = {
  __typename?: 'SubQuestionDistribution';
  distribution: Array<DistributionItem>;
  subQuestionId: Scalars['UUID']['output'];
};

export type SubQuestionModel = {
  __typename?: 'SubQuestionModel';
  id: Scalars['ID']['output'];
  questionOrder: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  /** English translation of the sub-question text */
  translatedText?: Maybe<Scalars['String']['output']>;
  type: QuestionType;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** DEPRECATED: use POST /sse/companion instead; this subscription will be removed. Streams a companion turn: progressive notices, tool calls/results, text deltas, custom sections, charts, and a final report. Scoped to the authenticated organization; data never crosses orgs. */
  companionStream: CompanionFrame;
  /** Emits when the authenticated user's organization role or membership changes. Clients should refresh their access token (or sign out) on receipt so the new permissions take effect immediately. Server keys the channel by the authenticated user id, so a subscriber can never receive another user's events. */
  currentUserRoleChanged: UserRoleChangedPayload;
  /**
   * Streams AI-generated questions one-by-one for a learning goal. Each event is a fully-formed question, emitted as the generation agent creates it; the subscription completes once the agent has finished producing questions.
   * @deprecated Use POST /sse/generate-questions instead; this subscription will be removed.
   */
  generateAIQuestionsV3: GeneratedQuestion;
  /** Emits the project whenever it changes (currently: when it receives its first response), returning the same ProjectModel the `project` query returns so the builder subscribes selecting only the fields it needs — e.g. `totalInsights`, to lock editing the moment the first response arrives — without a manual page reload. */
  projectUpdated: ProjectModel;
};

export type SubscriptionCompanionStreamArgs = {
  input: CompanionMessageInput;
};

export type SubscriptionGenerateAiQuestionsV3Args = {
  input: GenerateQuestionsInput;
};

export type SubscriptionProjectUpdatedArgs = {
  projectId: Scalars['ID']['input'];
};

export type SuggestRecruitingAudienceDescriptionInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<PanelQualificationFilterInput>>;
  syntheticAgeMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticAgeMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticAiTesters?: InputMaybe<Scalars['Int']['input']>;
  syntheticBiologicalSex?: InputMaybe<BiologicalSex>;
  syntheticCompanyIndustry?: InputMaybe<Scalars['String']['input']>;
  syntheticCompanySize?: InputMaybe<Scalars['String']['input']>;
  syntheticCompletionMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticCompletionMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticDecisionMakingMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticDecisionMakingMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticDirectnessMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticDirectnessMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticEmotionalExpressivenessMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticEmotionalExpressivenessMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticKnowledgebase?: InputMaybe<Scalars['String']['input']>;
  syntheticLocation?: InputMaybe<Scalars['String']['input']>;
  syntheticMotivation?: InputMaybe<Scalars['String']['input']>;
  syntheticPatienceMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticPatienceMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticPerfectionMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticPerfectionMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticReadingTypeMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticReadingTypeMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticRiskMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticRiskMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticSpeakerBoost?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticTechnologyTrustMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticTechnologyTrustMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticTitles?: InputMaybe<Scalars['String']['input']>;
  syntheticUseProxy?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticVerbosityMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticVerbosityMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticVictorOrVictimMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticVictorOrVictimMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticVoiceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  syntheticVoiceSimilarityBoost?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceSpeed?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStability?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStyle?: InputMaybe<Scalars['Float']['input']>;
  syntheticWorldview?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyActions = {
  __typename?: 'SurveyActions';
  postActivationActionData?: Maybe<Scalars['String']['output']>;
  postActivationActionType?: Maybe<RuleActionType>;
  preActivationActionData?: Maybe<Scalars['String']['output']>;
  preActivationActionType?: Maybe<RuleActionType>;
};

export type SurveyScreenerQuestionModel = {
  __typename?: 'SurveyScreenerQuestionModel';
  id: Scalars['ID']['output'];
  options: Array<SurveyScreenerQuestionOptionModel>;
  /** Position in the screener, starting at 0. */
  questionOrder: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  type: ScreenerQuestionType;
};

export type SurveyScreenerQuestionOptionModel = {
  __typename?: 'SurveyScreenerQuestionOptionModel';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Bipolar personality dimension for synthetic AI testers */
export const SyntheticPersonalityDimension = {
  Completion: 'Completion',
  DecisionMaking: 'DecisionMaking',
  Directness: 'Directness',
  EmotionalExpressiveness: 'EmotionalExpressiveness',
  Patience: 'Patience',
  Perfection: 'Perfection',
  ReadingType: 'ReadingType',
  Risk: 'Risk',
  TechnologyTrust: 'TechnologyTrust',
  Verbosity: 'Verbosity',
  VictorOrVictim: 'VictorOrVictim',
} as const;

export type SyntheticPersonalityDimension =
  (typeof SyntheticPersonalityDimension)[keyof typeof SyntheticPersonalityDimension];
export type SyntheticVoice = {
  __typename?: 'SyntheticVoice';
  accent?: Maybe<Scalars['String']['output']>;
  age?: Maybe<SyntheticVoiceAge>;
  descriptive?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<SyntheticVoiceGender>;
  language?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** mp3 sample URL for the preview button. */
  previewUrl?: Maybe<Scalars['String']['output']>;
  useCase?: Maybe<Scalars['String']['output']>;
  voiceId: Scalars['String']['output'];
};

export const SyntheticVoiceAge = {
  MiddleAged: 'MiddleAged',
  Old: 'Old',
  Young: 'Young',
} as const;

export type SyntheticVoiceAge =
  (typeof SyntheticVoiceAge)[keyof typeof SyntheticVoiceAge];
export const SyntheticVoiceGender = {
  Female: 'Female',
  Male: 'Male',
  Neutral: 'Neutral',
} as const;

export type SyntheticVoiceGender =
  (typeof SyntheticVoiceGender)[keyof typeof SyntheticVoiceGender];
export type SyntheticVoicePage = {
  __typename?: 'SyntheticVoicePage';
  hasMore: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  /** Total voices matching the query (ElevenLabs total_count). */
  totalCount: Scalars['Int']['output'];
  voices: Array<SyntheticVoice>;
};

export type SystemIntroVideos = {
  __typename?: 'SystemIntroVideos';
  /** GCS key of the default survey intro video. */
  surveyGcsKey: Scalars['String']['output'];
  /** GCS key of the default usability test intro video. */
  utGcsKey: Scalars['String']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Scalars['HexColorCode']['output']>;
  count: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TemplateModel = {
  __typename?: 'TemplateModel';
  /** Global learnt-text summary rolled up over all of the project’s objectives */
  aiLearntText?: Maybe<Scalars['String']['output']>;
  /** When enabled, voice recordings are deleted and PII is redacted. */
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inAppPopupMessage?: Maybe<Scalars['String']['output']>;
  introText?: Maybe<Scalars['String']['output']>;
  isAiVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isForm?: Maybe<Scalars['Boolean']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isPoll?: Maybe<Scalars['Boolean']['output']>;
  isUserVoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `objectives` instead */
  learningGoal?: Maybe<Scalars['String']['output']>;
  maxResponses?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `interactionType` instead. Redesigned builder (868gc1px2). */
  mode?: Maybe<ProjectMode>;
  objectives?: Maybe<Array<ProjectObjectiveModel>>;
  publicTitle?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<QuestionV2Model>>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tag>>;
  thankyouText?: Maybe<Scalars['String']['output']>;
  themeSettings?: Maybe<ProjectFrontendThemeSettings>;
  title?: Maybe<Scalars['String']['output']>;
  /** `aiLearntText` translated into the project language (non-English projects only) */
  translatedAiLearntText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  type?: Maybe<ProjectType>;
};

/** Confidence in an observation, derived from the amount of supporting evidence */
export const ThemeConfidence = {
  High: 'High',
  Low: 'Low',
  Medium: 'Medium',
} as const;

export type ThemeConfidence =
  (typeof ThemeConfidence)[keyof typeof ThemeConfidence];
export type ThemeGradient = {
  __typename?: 'ThemeGradient';
  /** Gradient angle in degrees */
  angle: Scalars['Int']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type ThemeGradientInput = {
  /** Gradient angle in degrees */
  angle: Scalars['Int']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type ThemeMessage = {
  __typename?: 'ThemeMessage';
  aiProcessedText?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  insight?: Maybe<InsightV2>;
  /** Offset in milliseconds from the recording start at which this quote was spoken; null when no timed transcript exists or the quote could not be located */
  recordingOffsetMs?: Maybe<Scalars['Int']['output']>;
  signal?: Maybe<Signal>;
  text: Scalars['String']['output'];
  /** `aiProcessedText` translated into the project language (non-English projects only) */
  translatedAiProcessedText?: Maybe<Scalars['String']['output']>;
};

export type ThemeMessageOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order messages by. */
  field: ThemeMessageOrderField;
};

/** Fields to order theme messages by */
export const ThemeMessageOrderField = {
  CreatedAt: 'CREATED_AT',
  RespondentAlphabetical: 'RESPONDENT_ALPHABETICAL',
  TagAlphabetical: 'TAG_ALPHABETICAL',
} as const;

export type ThemeMessageOrderField =
  (typeof ThemeMessageOrderField)[keyof typeof ThemeMessageOrderField];
export type ThemeMessagesFilterInput = {
  /** Filter messages created after this date */
  since?: InputMaybe<Scalars['DateTime']['input']>;
  themeId: Scalars['UUID']['input'];
  /** Filter messages created before this date */
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Theme mode for the project */
export const ThemeMode = {
  Auto: 'AUTO',
  Dark: 'DARK',
  Light: 'LIGHT',
} as const;

export type ThemeMode = (typeof ThemeMode)[keyof typeof ThemeMode];
/** Whether an observation was generated by AI or created by a user */
export const ThemeOrigin = {
  Ai: 'Ai',
  User: 'User',
} as const;

export type ThemeOrigin = (typeof ThemeOrigin)[keyof typeof ThemeOrigin];
/** Scope of a theme reprocessing run: `all` re-runs the full pipeline (extraction + both consolidation passes); `project` rebuilds only the observations from the existing question-scoped themes. */
export const ThemeProcessingScope = {
  All: 'All',
  Project: 'Project',
} as const;

export type ThemeProcessingScope =
  (typeof ThemeProcessingScope)[keyof typeof ThemeProcessingScope];
/** Review decision on an observation: pending, approved, or rejected */
export const ThemeReviewStatus = {
  Approved: 'Approved',
  Pending: 'Pending',
  Rejected: 'Rejected',
} as const;

export type ThemeReviewStatus =
  (typeof ThemeReviewStatus)[keyof typeof ThemeReviewStatus];
/** Consolidation scope of an observation: question-scoped observations are merged only against observations of the same question, project-scoped ones are merged across the whole project */
export const ThemeScope = {
  Project: 'Project',
  Question: 'Question',
} as const;

export type ThemeScope = (typeof ThemeScope)[keyof typeof ThemeScope];
/** Error codes for theme trigger processing */
export const ThemeTriggerProcessingErrorCode = {
  DailyLimitReached: 'DAILY_LIMIT_REACHED',
} as const;

export type ThemeTriggerProcessingErrorCode =
  (typeof ThemeTriggerProcessingErrorCode)[keyof typeof ThemeTriggerProcessingErrorCode];
export type ThemeTriggerProcessingValidationResult = {
  __typename?: 'ThemeTriggerProcessingValidationResult';
  canTrigger: Scalars['Boolean']['output'];
  errorCode?: Maybe<ThemeTriggerProcessingErrorCode>;
  nextTriggerTime?: Maybe<Scalars['DateTime']['output']>;
};

/** The connected ticketing account the agent comments as. */
export type TicketAgentAccountModel = {
  __typename?: 'TicketAgentAccountModel';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Workspaces / sites / organizations the connection can reach. */
  workspaces: Array<Scalars['String']['output']>;
};

export type TicketAgentSubscriptionModel = {
  __typename?: 'TicketAgentSubscriptionModel';
  externalScopeId: Scalars['String']['output'];
  externalScopeName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  /** The status whose transition starts a test. */
  triggerStatus: Scalars['String']['output'];
};

export type TicketScopeModel = {
  __typename?: 'TicketScopeModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Title font weight for project themes */
export const TitleFontWeight = {
  Bold: 'BOLD',
  Light: 'LIGHT',
  Regular: 'REGULAR',
} as const;

export type TitleFontWeight =
  (typeof TitleFontWeight)[keyof typeof TitleFontWeight];
export type TotalInsightsFilterInput = {
  /** @deprecated No longer applied */
  chatSizes?: InputMaybe<Array<ChatSize>>;
  insightRead?: InputMaybe<Scalars['Boolean']['input']>;
  maxProgress?: InputMaybe<Scalars['Float']['input']>;
  minProgress?: InputMaybe<Scalars['Float']['input']>;
  qualities?: InputMaybe<Array<InsightQuality>>;
  /** Filter by Human / Synthetic responder. */
  responderTypes?: InputMaybe<Array<ResponderType>>;
  /** Filter by the channel a response is shown under (Recruit covers both panels). */
  responseChannels?: InputMaybe<Array<ResponseChannel>>;
  /** Search in email, name and summary. Minimum 2 characters required. */
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  signal?: InputMaybe<Signal>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter insights based on user's read status */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UnifiedPreviewCompletionStatus = {
  __typename?: 'UnifiedPreviewCompletionStatus';
  /** Required primary questions that have no answer yet in this preview session */
  missingRequiredQuestions: Array<QuestionV2>;
};

export type UpdateCompanionSessionInput = {
  /** New conversation name; omit to leave unchanged. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New output persona id (from the companionPersonas query); omit to leave unchanged. Unknown ids are rejected. */
  personaId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type UpdateConnectionRuleInput = {
  activationData?: InputMaybe<Scalars['String']['input']>;
  activationType?: InputMaybe<RuleActivationType>;
  aiFollowup?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  postActivationActionData?: InputMaybe<Scalars['String']['input']>;
  postActivationActionType?: InputMaybe<RuleActionType>;
  preActivationActionData?: InputMaybe<Scalars['String']['input']>;
  preActivationActionType?: InputMaybe<RuleActionType>;
  sourceQuestionId?: InputMaybe<Scalars['ID']['input']>;
  targetQuestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDocumentInput = {
  /** GCS key for the document. Only one of gcsKey, text, or url should be provided. */
  gcsKey?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the document to update. */
  id: Scalars['ID']['input'];
  /** MIME type of the document (e.g., application/pdf, text/plain) */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Optional name for the document. If not provided, will be derived from the source. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Text content of the document. Only one of gcsKey, text, or url should be provided. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** URL of the document. Only one of gcsKey, text, or url should be provided. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInsightQualityInput = {
  id: Scalars['UUID']['input'];
  /** New quality bucket. Setting Low archives the insight (sets archivedAt); moving away from Low restores it. */
  quality: InsightQuality;
};

export type UpdateInsightsV2FilterInput = {
  ids: Array<Scalars['UUID']['input']>;
};

export type UpdateInsightsV2Input = {
  filter: UpdateInsightsV2FilterInput;
  values: UpdateInsightsV2ValuesInput;
};

export type UpdateInsightsV2ValuesInput = {
  insightRead?: InputMaybe<Scalars['Boolean']['input']>;
  msgRead?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIntegrationSettingsInput = {
  defaultSlackNotificationChannel?: InputMaybe<Scalars['String']['input']>;
  providerKey: Scalars['String']['input'];
  pushInsights?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<OrgNangoConnectionStatus>;
};

export type UpdateOptionAssetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrgIntroVideoInput = {
  id: Scalars['ID']['input'];
  /** New display name for the intro video. */
  name: Scalars['String']['input'];
};

export type UpdateOrganizationSettingsInput = {
  /** Whether the organization consents to TheySaid using its survey data to train and improve TheySaid's AI models */
  aiTrainingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL of the organization avatar */
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  /** Background color */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Primary brand color in hex format (e.g. #FF0000) */
  brandColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  /** Organization category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization_assets intro video to use as the org-level default intro video (null clears it) */
  defaultIntroVideoAssetId?: InputMaybe<Scalars['UUID']['input']>;
  /** ID of the organization_assets moderator voice to use as the org-level default moderator voice (null uses the built-in ElevenLabs default) */
  defaultModeratorVoiceAssetId?: InputMaybe<Scalars['UUID']['input']>;
  /** Font family name */
  font?: InputMaybe<Scalars['String']['input']>;
  /** Whether to hide the TheySaid logo */
  hideTheysaidLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the settings to update */
  id: Scalars['UUID']['input'];
  /** Organization industry */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Default language code for new projects in this organization (e.g. 'en', 'fr') */
  language?: InputMaybe<Scalars['String']['input']>;
  /** URL of the organization logo */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Selected background image URL (must be one of the backgrounds in backgroundImages) */
  selectedBackground?: InputMaybe<Scalars['String']['input']>;
  /** Target customers */
  targetCustomers?: InputMaybe<Scalars['String']['input']>;
  /** Theme mode (dark or light) */
  themeMode?: InputMaybe<ThemeMode>;
  /** Transparency level (0-100) */
  transparency?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum widget popups per device per month (null = no limit, must be >= 1) */
  widgetMaxPopupsPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Seconds between widget popups for the same device (null = no limit) */
  widgetTimeBetweenPopupsSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProjectDocumentInput = {
  /** GCS key for the document. Only one of gcsKey, text, or url should be provided. */
  gcsKey?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the document to update. */
  id: Scalars['ID']['input'];
  /** MIME type of the document (e.g., application/pdf, text/plain) */
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Optional name for the document. If not provided, will be derived from the source. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Text content of the document. Only one of gcsKey, text, or url should be provided. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** URL of the document. Only one of gcsKey, text, or url should be provided. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectInput = {
  /** When enabled, voice recordings are deleted and PII is redacted. */
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  calendarLink?: InputMaybe<Scalars['String']['input']>;
  /** Whether responders may jump forward to later questions. Redesigned builder. */
  canJumpForward?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** ID of the project_assets intro video to use as this project's default intro video. */
  defaultIntroVideoAssetId?: InputMaybe<Scalars['UUID']['input']>;
  /** Device types this project supports (computer | phone). Redesigned builder. */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  id: Scalars['ID']['input'];
  inAppPopupMessage?: InputMaybe<Scalars['String']['input']>;
  inferredType?: InputMaybe<ProjectType>;
  /** How responders interact with the survey (voice | text). Redesigned builder. */
  interactionType?: InputMaybe<InteractionType>;
  /** @deprecated Redesigned builder (868gc1px2): intro content now lives in the project_intro table. */
  introText?: InputMaybe<Scalars['String']['input']>;
  /** Whether this project uses its own intro video or the org-level default. */
  introVideoLevel?: InputMaybe<IntroVideoLevel>;
  /** Whether AI form assistance is enabled for this project. */
  isAIFormAssistanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAiVoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAnalyticsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isCameraEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isForm?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  isPoll?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the thank-you screen is shown. Null defaults to on when a custom message exists. */
  isThankyouEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUserVoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `objectives` instead */
  learningGoal?: InputMaybe<Scalars['String']['input']>;
  maxResponses?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use `interactionType` instead. Redesigned builder (868gc1px2). */
  mode?: InputMaybe<ProjectMode>;
  objectives?: InputMaybe<Array<CreateProjectObjectiveInput>>;
  publicTitle?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  reviewLink?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatus>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<CreateTagV2Input>>;
  thankyouDescription?: InputMaybe<Scalars['String']['input']>;
  thankyouText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Deprecated with the redesigned builder (868gc1px2). Legacy product-type field. */
  type?: InputMaybe<ProjectType>;
};

export type UpdateProjectIntegrationSettingsInput = {
  isActive: Scalars['Boolean']['input'];
  projectId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  slackNotificationChannels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProjectIntroInput = {
  /** Replaces the intro's channel audience when provided. */
  audience?: InputMaybe<Array<Channel>>;
  id: Scalars['UUID']['input'];
  introSource?: InputMaybe<IntroSource>;
  /** Whether the responder shows this intro. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the intro instructions (title/subtitle) are shown. */
  isInstructionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the intro video is shown. */
  isVideoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orgAssetId?: InputMaybe<Scalars['UUID']['input']>;
  projectAssetId?: InputMaybe<Scalars['UUID']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectIntroVideoInput = {
  id: Scalars['ID']['input'];
  /** New display name for the intro video. */
  name: Scalars['String']['input'];
};

export type UpdateProjectScreenerInput = {
  /** Replaces the screener's publishing methods when provided. */
  audience?: InputMaybe<Array<Channel>>;
  disqualificationRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** Turn the screener on or off. When off, its project can be taken directly. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['UUID']['input'];
};

export type UpdateProjectSettingsInput = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  calendarLink?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  defaultIntroVideoAssetId?: InputMaybe<Scalars['UUID']['input']>;
  inAppPopupMessage?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Redesigned builder (868gc1px2): intro content now lives in project intros. */
  introText?: InputMaybe<Scalars['String']['input']>;
  introVideoLevel?: InputMaybe<IntroVideoLevel>;
  isAIFormAssistanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAiVoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAnalyticsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isThankyouEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUserVoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxResponses?: InputMaybe<Scalars['Int']['input']>;
  moderatorVoiceAssetId?: InputMaybe<Scalars['UUID']['input']>;
  projectId: Scalars['UUID']['input'];
  reviewLink?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  syntheticUseProxy?: InputMaybe<Scalars['Boolean']['input']>;
  thankyouDescription?: InputMaybe<Scalars['String']['input']>;
  thankyouText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionAssetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionOrderInput = {
  projectId: Scalars['ID']['input'];
  questions: Array<QuestionOrderInput>;
};

export type UpdateQuestionV2Input = {
  aiConvoDepth?: InputMaybe<Scalars['Int']['input']>;
  aiInsights?: InputMaybe<Scalars['Boolean']['input']>;
  contentUrl?: InputMaybe<Scalars['String']['input']>;
  /** For Task questions in usability-testing projects: enable feedback follow-up question */
  feedbackQuestionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  /** Per-question voice|text override; null inherits the project. Redesigned builder. */
  interactionType?: InputMaybe<InteractionType>;
  maxSelections?: InputMaybe<Scalars['Int']['input']>;
  minSelections?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use maxSelections instead */
  multipleSelect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Label for the Not Applicable option on matrix questions. Null/omitted means N/A is disabled; any value enables it. */
  notApplicableLabel?: InputMaybe<Scalars['String']['input']>;
  optionRenderType?: InputMaybe<OptionRenderType>;
  options?: InputMaybe<Array<QuestionOptionInput>>;
  randomize?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this question shows live results to responders. Redesigned builder. */
  showLiveDistribution?: InputMaybe<Scalars['Boolean']['input']>;
  subQuestions?: InputMaybe<Array<CreateSubQuestionInput>>;
  /** For Task questions in usability-testing projects: enable success follow-up question */
  successQuestionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<CreateTagV2Input>>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionType>;
};

export type UpdateRecruitingAudienceInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Trimmed, then at most 280 characters. Omitted: unchanged; null or blank: cleared. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Per-tester human incentive in cents: a whole-dollar amount from 100 ($1) to 9900 ($99). Omitted: unchanged; null: cleared. */
  humanIncentive?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<PanelQualificationFilterInput>>;
  syntheticAgeMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticAgeMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticAiTesters?: InputMaybe<Scalars['Int']['input']>;
  syntheticBiologicalSex?: InputMaybe<BiologicalSex>;
  syntheticCompanyIndustry?: InputMaybe<Scalars['String']['input']>;
  syntheticCompanySize?: InputMaybe<Scalars['String']['input']>;
  syntheticCompletionMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticCompletionMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticDecisionMakingMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticDecisionMakingMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticDirectnessMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticDirectnessMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticEmotionalExpressivenessMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticEmotionalExpressivenessMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticKnowledgebase?: InputMaybe<Scalars['String']['input']>;
  syntheticLocation?: InputMaybe<Scalars['String']['input']>;
  syntheticMotivation?: InputMaybe<Scalars['String']['input']>;
  syntheticPatienceMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticPatienceMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticPerfectionMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticPerfectionMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticReadingTypeMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticReadingTypeMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticRiskMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticRiskMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticSpeakerBoost?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticTechnologyTrustMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticTechnologyTrustMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticTitles?: InputMaybe<Scalars['String']['input']>;
  syntheticUseProxy?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticVerbosityMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticVerbosityMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticVictorOrVictimMax?: InputMaybe<Scalars['Int']['input']>;
  syntheticVictorOrVictimMin?: InputMaybe<Scalars['Int']['input']>;
  syntheticVoiceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  syntheticVoiceSimilarityBoost?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceSpeed?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStability?: InputMaybe<Scalars['Float']['input']>;
  syntheticVoiceStyle?: InputMaybe<Scalars['Float']['input']>;
  syntheticWorldview?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTagV2Input = {
  color?: InputMaybe<Scalars['HexColorCode']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UploadQuestionMobileAppInput = {
  fileName: Scalars['String']['input'];
  gcsKey: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
};

export type UrlPreview = {
  __typename?: 'UrlPreview';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UrlPreviewInput = {
  url: Scalars['URL']['input'];
};

export type User = {
  __typename?: 'User';
  /** The email address of the user. */
  email: Scalars['EmailAddress']['output'];
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique ID of the user. */
  id: Scalars['ID']['output'];
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** A URL reference to an image representing the user. */
  profilePictureUrl?: Maybe<Scalars['URL']['output']>;
  /** The role of the user in the organization. */
  role?: Maybe<Role>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  id: Scalars['ID']['output'];
  /** The timestamp when the user last logged in. */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Emitted to the affected user when their organization membership changes. A null `newRole` indicates the user was removed from the organization. */
export type UserRoleChangedPayload = {
  __typename?: 'UserRoleChangedPayload';
  /** When the change was published. */
  changedAt: Scalars['DateTime']['output'];
  /** The user that initiated the change (e.g. an admin/owner). */
  changedByUserId?: Maybe<Scalars['ID']['output']>;
  /** The new role; null indicates the user was removed from the organization. */
  newRole?: Maybe<Role>;
  /** The organization in which the change occurred (WorkOS id). */
  organizationId: Scalars['ID']['output'];
  /** The role the user had immediately before the change. */
  previousRole?: Maybe<Role>;
  /** The user whose role/membership changed. */
  userId: Scalars['ID']['output'];
};

export type UxAgentPersonaModel = {
  __typename?: 'UxAgentPersonaModel';
  age?: Maybe<Scalars['String']['output']>;
  /** GCS key of the generated avatar image for this persona (from InsightAssetType.Avatar) */
  avatarGcsKey?: Maybe<Scalars['String']['output']>;
  biologicalSex?: Maybe<Scalars['String']['output']>;
  companyIndustry?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  knowledgebase?: Maybe<Scalars['String']['output']>;
  motivation?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Scalars['String']['output']>;
  worldView?: Maybe<Scalars['String']['output']>;
};

export type V2OrganizationUpdateInput = {
  /** The ID of the organization to update. */
  id: Scalars['ID']['input'];
  /** The name of the organization to update. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Completion flags for the dashboard onboarding checklist.
   * @deprecated Onboarding is per-user, not per-org. Use the `updateOnboardingSteps` mutation instead.
   */
  onboardingSteps?: InputMaybe<OnboardingStepsInput>;
};

/** Publish state of a project video */
export const VideoPublishStatus = {
  Published: 'Published',
  Unpublished: 'Unpublished',
} as const;

export type VideoPublishStatus =
  (typeof VideoPublishStatus)[keyof typeof VideoPublishStatus];
/** Default delivery mood for a moderator voice */
export const VoiceMood = {
  Energetic: 'Energetic',
  Neutral: 'Neutral',
  Professional: 'Professional',
  Warm: 'Warm',
} as const;

export type VoiceMood = (typeof VoiceMood)[keyof typeof VoiceMood];
export type VoiceTranscriptOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type VoiceTranscriptSubQuestionInput = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Filters that can be enabled/disabled for widget configuration UI */
export const WidgetConfigFilter = {
  Activation: 'Activation',
  DeviceType: 'DeviceType',
  Importance: 'Importance',
  PageLocation: 'PageLocation',
  Segment: 'Segment',
  Status: 'Status',
} as const;

export type WidgetConfigFilter =
  (typeof WidgetConfigFilter)[keyof typeof WidgetConfigFilter];
/** Device type for widget targeting */
export const WidgetDeviceType = {
  Desktop: 'Desktop',
  Mobile: 'Mobile',
  Tablet: 'Tablet',
} as const;

export type WidgetDeviceType =
  (typeof WidgetDeviceType)[keyof typeof WidgetDeviceType];
export type WidgetImageAsset = {
  __typename?: 'WidgetImageAsset';
  /** GCS key of the stored image. */
  gcsKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  /** Temporary signed URL for rendering the image. Valid for 5 minutes. */
  url: Scalars['String']['output'];
};

/** Widget importance/priority level for display order */
export const WidgetImportance = {
  High: 'High',
  Low: 'Low',
  Medium: 'Medium',
  VeryHigh: 'VeryHigh',
} as const;

export type WidgetImportance =
  (typeof WidgetImportance)[keyof typeof WidgetImportance];
/** Page location targeting type for widget */
export const WidgetPageLocationType = {
  SiteWide: 'SiteWide',
  SpecificUrl: 'SpecificUrl',
} as const;

export type WidgetPageLocationType =
  (typeof WidgetPageLocationType)[keyof typeof WidgetPageLocationType];
/** How the widget is triggered */
export const WidgetTriggerType = {
  Automatic: 'Automatic',
  OnClick: 'OnClick',
} as const;

export type WidgetTriggerType =
  (typeof WidgetTriggerType)[keyof typeof WidgetTriggerType];
export type WorkosAndCompanyCreateInput = {
  /** The name of the organization to create. */
  name: Scalars['String']['input'];
  /** Who the company sells to, in the user's words; stored as the organization's target customers. Omitted or blank: not stored. */
  targetCustomers?: InputMaybe<Scalars['String']['input']>;
  /** The company's website (a URL or bare domain), added to Teach AI as a link (https:// is assumed when no scheme is given). Omitted or blank: not added. Malformed: rejected with COMPANY_INFO_INVALID_WEBSITE. */
  website?: InputMaybe<Scalars['String']['input']>;
};
